
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("N0fDW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9urUx")).default);
$parcel$export(module.exports, "useFeatures", () => (parcelRequire("kFwR2")).useFeatures);

var $9urUx = parcelRequire("9urUx");

var $kFwR2 = parcelRequire("kFwR2");

});
parcelRegister("9urUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f3d9fe15c0dae80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Ti3v = parcelRequire("4Ti3v");
var $u0mbR = parcelRequire("u0mbR");

var $agcDm = parcelRequire("agcDm");

var $emcAw = parcelRequire("emcAw");
const $5f3d9fe15c0dae80$var$MultiProjectSidebarCore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_START_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emcAw.default), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarReady), {
        id: (0, $4Ti3v.SIDEBAR_ID).CORE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_END_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceReport), null)));
var $5f3d9fe15c0dae80$export$2e2bcd8739ae039 = $5f3d9fe15c0dae80$var$MultiProjectSidebarCore;

});
parcelRegister("4Ti3v", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $7a89ae81cc6f8c6c$export$adf978edbdfaf080);
const $7a89ae81cc6f8c6c$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("agcDm", function(module, exports) {

$parcel$export(module.exports, "RENDER_START_MARK", () => $2c9144edaf673b4b$export$8f8203e04f80aed);
$parcel$export(module.exports, "RENDER_END_MARK", () => $2c9144edaf673b4b$export$dc795f9b21e2778a);
$parcel$export(module.exports, "PerformanceMark", () => $2c9144edaf673b4b$export$b8228db3a01d9a76);
$parcel$export(module.exports, "PerformanceReport", () => $2c9144edaf673b4b$export$c97ab321326d29f7);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");
const $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
const $2c9144edaf673b4b$export$8f8203e04f80aed = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
const $2c9144edaf673b4b$export$dc795f9b21e2778a = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
const $2c9144edaf673b4b$var$segment = (0, $lNfG4.metrics).pageSegmentLoad({
    key: $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME,
    timings: [
        {
            key: 'tti',
            endMark: $2c9144edaf673b4b$export$dc795f9b21e2778a
        }
    ]
});
const $2c9144edaf673b4b$export$b8228db3a01d9a76 = ({ id: id })=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    if (!false && !startedRef.current) {
        $2c9144edaf673b4b$var$segment.startFromPageLoad();
        startedRef.current = true;
    }
    (0, $eUqFw.useEffect)(()=>$2c9144edaf673b4b$var$segment.mark(id), [
        id
    ]);
    return null;
};
const $2c9144edaf673b4b$export$c97ab321326d29f7 = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        $2c9144edaf673b4b$var$segment.stop();
    }, []);
    return null;
};

});

parcelRegister("emcAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cfc64baafae021$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $41WOo = parcelRequire("41WOo");

var $gP3W1 = parcelRequire("gP3W1");

var $bWsAc = parcelRequire("bWsAc");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5cLMB = parcelRequire("5cLMB");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $6yplV = parcelRequire("6yplV");

var $57SqH = parcelRequire("57SqH");

var $lym21 = parcelRequire("lym21");
var $fUoOQ = parcelRequire("fUoOQ");

var $gTasH = parcelRequire("gTasH");

var $8l70H = parcelRequire("8l70H");

var $4h0Ly = parcelRequire("4h0Ly");

var $9QtHd = parcelRequire("9QtHd");

var $439fx = parcelRequire("439fx");
// eslint-disable-next-line complexity
const $b7cfc64baafae021$var$MultiProjectMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, $57SqH.useSidebarData)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [projectState] = (0, $5cLMB.useProjectState)();
    const [{ route: route, match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
            starredProjectsCount: favorites.length,
            recentProjectsCount: recents.length,
            overviewsCount: overviews.length
        });
    // only run once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // the currentProject data gets loaded async and thus it is null while
    // transitioning between projects. To allow expanding the right current
    // project when the data has not been resolved yet, we use the project
    // key from the URL instead.
    const currentProjectKey = projectKey ?? currentProject?.key;
    const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
    const projectsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", null, favorites.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "starred",
        projects: favorites,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        currentRoute: route,
        showViewAllProjects: hasMoreFavorite,
        viewAllProjectsLabel: formatMessage((0, $8l70H.default).viewAllStarred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "recent",
        projects: recents,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        currentRoute: route,
        showViewAllProjects: true
    }));
    const callToActionType = (0, $eI5EY.fg)('jwm_create_project_from_sample') ? (0, $lym21.getCallToActionType)(projectState?.isSampleProject) : (0, $lym21.CallToActionType).NONE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SidebarWrapper, {
        "aria-label": formatMessage((0, $8l70H.default).navigationLabel),
        isCrossProjectView: true
    }, shouldDisplayOverviews && (loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$OverviewsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4h0Ly.default), {
        overviews: overviews,
        hasError: Boolean(overviewsError)
    }))), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ProjectsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $439fx.default), null), projectsContent), (0, $eI5EY.fg)('jwm_create_project_from_sample') && !loading && callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_BUTTON && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUoOQ.CreateProjectCta), null)), (0, $eI5EY.fg)('jwm_mobile_discovery') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gP3W1.AsyncMobileDownloadPrompt), null), (0, $eI5EY.fg)('jwm_create_project_from_sample') && (callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_BANNER || callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_NONE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUoOQ.CreateProjectCta), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Footer, {
        hasMargin: true
    }, currentProject != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Type, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
    }, currentProject.isSimplified ? formatMessage((0, $8l70H.default).teamManagedProject) : formatMessage((0, $8l70H.default).companyManagedProject)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTasH.default), null)), (0, $eI5EY.fg)('jwm_create_project_from_sample') ? callToActionType === (0, $lym21.CallToActionType).TRIAL_BANNER && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWsAc.TrialBannerExperiment), {
        isProjectSimplified: !!currentProject?.isSimplified
    }) : (0, $41WOo.isJwmMonetizationExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWsAc.TrialBannerExperiment), {
        isProjectSimplified: !!currentProject?.isSimplified
    }));
};
const $b7cfc64baafae021$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemAvatarSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonBase, null));
const $b7cfc64baafae021$var$OverviewsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null));
const $b7cfc64baafae021$var$ProjectsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SidebarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
            __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SectionHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb68cl _4t3i7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemAvatarSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$CollapsibleHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbys9h _18u0u2gc _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.hasMargin && "_18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Type = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
            __cmplp.className
        ])
    });
});
var $b7cfc64baafae021$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b7cfc64baafae021$var$MultiProjectMenu);

});
parcelRegister("41WOo", function(module, exports) {

$parcel$export(module.exports, "isJwmMonetizationExperimentEnabled", () => $2d43a89fd1224d6e$export$10ae23b90fb69a2a);
$parcel$export(module.exports, "isVariationOnJwmMonetizationExperiment", () => $2d43a89fd1224d6e$export$157c21c92e1418f2);
$parcel$export(module.exports, "isJwmInlineFieldCreateEnabled", () => $2d43a89fd1224d6e$export$fb2108971c4de07a);
$parcel$export(module.exports, "getJwmInlineFieldCreateCohort", () => $2d43a89fd1224d6e$export$bd44a7b81fbc9090);
$parcel$export(module.exports, "isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort", () => $2d43a89fd1224d6e$export$7b2cbb525cd1479e);
$parcel$export(module.exports, "isAutomationDiscoveryOnBoardColumnsExperimentEnabled", () => $2d43a89fd1224d6e$export$926c1115b4c28620);
$parcel$export(module.exports, "isJwmTemplateBundlesEnabled", () => $2d43a89fd1224d6e$export$b9595e1ee168b117);
$parcel$export(module.exports, "isLinkedIssuesEnabledInJwmBoardCards", () => $2d43a89fd1224d6e$export$144ea04c193e7769);
$parcel$export(module.exports, "getJwmHelpSampleUsersCreateProjectsCtaType", () => $2d43a89fd1224d6e$export$6df5130e98d74ad2);
$parcel$export(module.exports, "isOnboardingForLinkedIssuesEnabledInJwmBoard", () => $2d43a89fd1224d6e$export$21f160f3ad728081);
$parcel$export(module.exports, "isJwmReduceNoiseOnSignupEnabled", () => $2d43a89fd1224d6e$export$dc89692c53fbc1);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $2d43a89fd1224d6e$export$10ae23b90fb69a2a = ()=>!(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', null);
const $2d43a89fd1224d6e$export$157c21c92e1418f2 = ()=>(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$fb2108971c4de07a = ()=>(0, $79xbN.expValEquals)('jwm_inline_field_create', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$bd44a7b81fbc9090 = ()=>(0, $79xbN.expVal)('jwm_inline_field_create', 'cohort', 'not-enrolled');
const $2d43a89fd1224d6e$export$7b2cbb525cd1479e = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $2d43a89fd1224d6e$export$926c1115b4c28620 = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled';
};
const $2d43a89fd1224d6e$export$b9595e1ee168b117 = ()=>(0, $79xbN.expValEquals)('jwm_template_bundles_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$144ea04c193e7769 = ()=>(0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$6df5130e98d74ad2 = ()=>{
    // Intentionally not firing exposure here because it is yet to be determined whether the engagement platform message has started.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_help_sample_users_create_projects');
    return expConfig.get('ctaType', 'none');
};
const $2d43a89fd1224d6e$export$21f160f3ad728081 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Need this preconditioning to make sure can independently control onboarding
    (0, $eI5EY.fg)('jwm_linked_issues_on_the_board_onboarding') && (0, $79xbN.expVal)('jwm_linked_issues_on_the_board_milestone_1', 'isJWMBoardLinkedIssuesEnabled', false);
const $2d43a89fd1224d6e$export$dc89692c53fbc1 = ()=>(0, $79xbN.expValEquals)('jwm_reduce_noise_on_signup', 'cohort', 'variation');

});
parcelRegister("eI5EY", function(module, exports) {

$parcel$export(module.exports, "fg", () => $010af7f17578702e$export$b40ec24ac8275656);

var $8tM2T = parcelRequire("8tM2T");

var $9bn72 = parcelRequire("9bn72");

var $3WQZN = parcelRequire("3WQZN");
const $010af7f17578702e$export$b40ec24ac8275656 = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $8tM2T.default).checkGate(gateName);
    (0, $3WQZN.addFeatureFlagAccessed)(gateName, value);
    return value;
};

});


parcelRegister("gP3W1", function(module, exports) {

$parcel$export(module.exports, "AsyncMobileDownloadPrompt", () => $67b3342293e0228e$export$64ca7d64bb703770);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $ldsZq = parcelRequire("ldsZq");
const $67b3342293e0228e$var$runtimeProps = {};
const $67b3342293e0228e$var$entryPointParams = {};
const $67b3342293e0228e$export$64ca7d64bb703770 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ldsZq.downloadMobilePromptEntryPoint), $67b3342293e0228e$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessDownloadMobilePrompt",
        packageName: (0, $eed20802841d894c$export$b8b9d90f9e5bd72b),
        teamName: "frontier",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $67b3342293e0228e$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("6j4bv", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $82c08dfbbf99b106$export$338256068bc140fb);

var $eUqFw = parcelRequire("eUqFw");

var $hRw7O = parcelRequire("hRw7O");

var $80LCQ = parcelRequire("80LCQ");

var $fn8UB = parcelRequire("fn8UB");

var $VvIn5 = parcelRequire("VvIn5");
const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
    const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eUqFw.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hRw7O", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $8aa020919bcd63f9$export$93ca5d3f8675ae4c);
const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("80LCQ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $5764a513c11cf0da$export$90681c8c3a56f09a);

var $eUqFw = parcelRequire("eUqFw");

var $gZ48R = parcelRequire("gZ48R");

var $hRw7O = parcelRequire("hRw7O");
const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eUqFw.useRef)();
    const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
    const preloadLastRequested = (0, $eUqFw.useRef)(0);
    const cancelPreload = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eUqFw.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eUqFw.useCallback)(()=>{
        if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eUqFw.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("fn8UB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $9075a0262fd7a4a5$export$bfae318f9651db2f);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ln3W8 = parcelRequire("ln3W8");

var $boTUp = parcelRequire("boTUp");
const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eUqFw.useRef)(true);
    const timer = (0, $eUqFw.useRef)();
    const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eUqFw.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eUqFw.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("boTUp", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $f334fadd26cc659d$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $f334fadd26cc659d$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $f334fadd26cc659d$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $f334fadd26cc659d$export$322c8997d351da6a);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
    const value = (0, $eUqFw.useRef)(null);
    const subscribers = (0, $eUqFw.useRef)();
    const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("VvIn5", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $df836dfb6cf1aa5a$export$f291ec7cea728e1);

var $eUqFw = parcelRequire("eUqFw");
const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eUqFw.useRef)(0);
    const loadStartTime = (0, $eUqFw.useRef)(0);
    const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("1HzcR", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $48716810ae87e4eb$export$ee1e46af8fa2fb93);

var $eUqFw = parcelRequire("eUqFw");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);

});
parcelRegister("P6D7Q", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $f27db5d96682fc65$export$3cd1c81e13390c49);

var $eUqFw = parcelRequire("eUqFw");
const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("ioLN0", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");
const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $fVaJL = parcelRequire("fVaJL");

var $232mI = parcelRequire("232mI");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $5iuyH.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fVaJL.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fVaJL.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $232mI.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});



const $eed20802841d894c$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';

parcelRegister("ldsZq", function(module, exports) {

$parcel$export(module.exports, "downloadMobilePromptEntryPoint", () => $c626ef33a70c140f$export$66f4c5613c7e964);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $c626ef33a70c140f$export$66f4c5613c7e964 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("k5xr3")), {
        moduleId: "c94481ab"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k5xr3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bApOA');
        const value = parcelRequire('cGSJA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bApOA").then(()=>parcelRequire('cGSJA'));
}

});



parcelRegister("bWsAc", function(module, exports) {

$parcel$export(module.exports, "TrialBannerExperiment", () => $5bbfbbbb7a700c1d$export$c54011d73ccea97b);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $kyg8p = parcelRequire("kyg8p");
const $5bbfbbbb7a700c1d$var$entryPointParams = {};
const $5bbfbbbb7a700c1d$export$c54011d73ccea97b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $kyg8p.trialBannerEntryPoint), $5bbfbbbb7a700c1d$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        // Preloads data for the onboarding modal on mount
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessMonetizationTrialBanner",
        packageName: (0, $ebba456e6ace08b3$export$b8b9d90f9e5bd72b),
        teamName: "program-moon",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {
            isProjectSimplified: props.isProjectSimplified
        },
        errorFallback: "unmount"
    });
};

});
const $ebba456e6ace08b3$export$2fa4e95d1c6e7b0f = 'jira_workmanagement_ui_jwmmonetisationbannerdismiss_clicked_last';
const $ebba456e6ace08b3$export$b8b9d90f9e5bd72b = 'jiraBusinessProgramMoonTrialBanner';
const $ebba456e6ace08b3$export$5200514808277ba7 = 'showJWMPremiumUpgradeSuccessFlag';

parcelRegister("kyg8p", function(module, exports) {

$parcel$export(module.exports, "trialBannerEntryPoint", () => $d331199b87144c91$export$ee321d3cb6d82261);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $d331199b87144c91$export$ee321d3cb6d82261 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("fiNxT")), {
        moduleId: "61fe650e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fiNxT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('7OoSx')
        ]);
        const value = parcelRequire('jdZ9N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("7OoSx")
    ]).then(()=>parcelRequire('jdZ9N'));
}

});



parcelRegister("5cLMB", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingSubscriber", () => $502e2dc73b97f226$export$1cbc60d8dd921852);
$parcel$export(module.exports, "useJswOnboarding", () => $502e2dc73b97f226$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $502e2dc73b97f226$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $502e2dc73b97f226$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $502e2dc73b97f226$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $502e2dc73b97f226$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useShouldShowOpenMenuItem", () => $502e2dc73b97f226$export$d994ff8c0341aba1);
$parcel$export(module.exports, "useInviteToProject", () => $502e2dc73b97f226$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $502e2dc73b97f226$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $502e2dc73b97f226$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $502e2dc73b97f226$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $502e2dc73b97f226$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $502e2dc73b97f226$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $502e2dc73b97f226$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $502e2dc73b97f226$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $502e2dc73b97f226$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $502e2dc73b97f226$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $502e2dc73b97f226$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $502e2dc73b97f226$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $502e2dc73b97f226$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $502e2dc73b97f226$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $502e2dc73b97f226$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $502e2dc73b97f226$export$f4a2be940259bf95);
$parcel$export(module.exports, "usePersonaExperience", () => $502e2dc73b97f226$export$8e98a1e4d2dbf1b9);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("7dRgX")).QUICKSTART_UI_STATUS);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $9CmwD = parcelRequire("9CmwD");

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $c8ave = parcelRequire("c8ave");

var $lCsoa = parcelRequire("lCsoa");

var $fricC = parcelRequire("fricC");

var $5OjXh = parcelRequire("5OjXh");

var $7AH2S = parcelRequire("7AH2S");
const $502e2dc73b97f226$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $lCsoa.initialState,
    actions: $c8ave
});
const $502e2dc73b97f226$export$1cbc60d8dd921852 = (0, $dYfll.createSubscriber)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$7d91c0af4772787a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$638bfcfce1254bb8 = (0, $heB5U.createContainer)($502e2dc73b97f226$export$390f32400eaf98c9, {});
const $502e2dc73b97f226$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : state.isOpen && !state.isDismissed) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $502e2dc73b97f226$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $502e2dc73b97f226$export$594f006fa6a1b2e5 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$ea14030920a5d8e6
});
const $502e2dc73b97f226$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $502e2dc73b97f226$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$a943afa434e9487a
});
const $502e2dc73b97f226$export$2c3cd14fff9d6e43 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: null
});
const $502e2dc73b97f226$export$b0db7e46e369e1d9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$9d731f44f82af09f
});
// TODO: KURO-1678, delete
const $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.shouldRenderComponent && state.isDismissed;
    }
});
const $502e2dc73b97f226$export$d994ff8c0341aba1 = ()=>{
    const [shouldShow, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed }] = $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook();
    return {
        shouldShow: shouldShow,
        setIsDismissed: nextSetChecklistIsDismissed
    };
};
const $502e2dc73b97f226$export$71de79653346a1ea = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $502e2dc73b97f226$export$61185a9266f1f57a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN || userRole === (0, $fricC.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $502e2dc73b97f226$export$ef4747ba36826d6a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $502e2dc73b97f226$export$522993b46d9f8266 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (state.shouldRenderComponent === false) return (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED;
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[quickstartType];
        if (state.isDismissed) return (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        if (state.isOpen) return (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        return (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
    }
});
const $502e2dc73b97f226$export$aa4ba29241532382 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $502e2dc73b97f226$export$ed5c755b733bf2b1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $502e2dc73b97f226$export$35fe0366802512dd = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.isDismissed;
    }
});
const $502e2dc73b97f226$export$a41ee0d3b6938099 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $502e2dc73b97f226$export$4ae7b465b076be9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $502e2dc73b97f226$export$bf6e646c0476acad = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $502e2dc73b97f226$export$6b706bff94798d11 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $502e2dc73b97f226$export$c98db656edc5b3e1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $502e2dc73b97f226$export$a823278ac9d1112b = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN)
});
const $502e2dc73b97f226$export$cb9e0e8fe4df8490 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $7dRgX.KANBAN_ONBOARDING_TASK)))
});
const $502e2dc73b97f226$export$521909e3dc7ab811 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $502e2dc73b97f226$export$f4a2be940259bf95 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $502e2dc73b97f226$export$8e98a1e4d2dbf1b9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.personaExperience
});

});
parcelRegister("9CmwD", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$6278b41164dbde6c);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $9672b8899ab98e98$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $9672b8899ab98e98$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$fd75f6abc7861439);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$fb658bddae7f81bb);
$parcel$export(module.exports, "EXTERNAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$bc3e0c6bccecee38);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $9672b8899ab98e98$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $9672b8899ab98e98$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $9672b8899ab98e98$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $9672b8899ab98e98$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $9672b8899ab98e98$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $9672b8899ab98e98$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $9672b8899ab98e98$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $9672b8899ab98e98$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $9672b8899ab98e98$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $9672b8899ab98e98$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $9672b8899ab98e98$export$7d9a4e0ef5194fe1 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $9672b8899ab98e98$export$477ca3550da12e43 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $9672b8899ab98e98$export$7c0307155b744916 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $9672b8899ab98e98$export$b5ab111fb8825075 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $9672b8899ab98e98$export$14139f0ec41d437e = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $9672b8899ab98e98$export$ebf7af45376deb8b = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $9672b8899ab98e98$export$7b6945581ccdab4a = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $9672b8899ab98e98$export$310a9ac5c28d65f6 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $9672b8899ab98e98$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $9672b8899ab98e98$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $9672b8899ab98e98$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $9672b8899ab98e98$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $9672b8899ab98e98$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $9672b8899ab98e98$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $9672b8899ab98e98$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $9672b8899ab98e98$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $9672b8899ab98e98$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $9672b8899ab98e98$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $9672b8899ab98e98$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $9672b8899ab98e98$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $9672b8899ab98e98$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $9672b8899ab98e98$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $9672b8899ab98e98$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $9672b8899ab98e98$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $9672b8899ab98e98$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $9672b8899ab98e98$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $9672b8899ab98e98$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $9672b8899ab98e98$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $9672b8899ab98e98$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $9672b8899ab98e98$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $9672b8899ab98e98$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $9672b8899ab98e98$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $9672b8899ab98e98$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $9672b8899ab98e98$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $9672b8899ab98e98$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $9672b8899ab98e98$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $9672b8899ab98e98$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $9672b8899ab98e98$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $9672b8899ab98e98$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $9672b8899ab98e98$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $9672b8899ab98e98$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $9672b8899ab98e98$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $9672b8899ab98e98$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $9672b8899ab98e98$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $9672b8899ab98e98$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $9672b8899ab98e98$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $9672b8899ab98e98$export$f9776303073903dd = 'jira.polaris:roadmap';
const $9672b8899ab98e98$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $9672b8899ab98e98$export$e8df553a3f519284 || T4JTemplateKey === $9672b8899ab98e98$export$8eecdf6acea9494 || T4JTemplateKey === $9672b8899ab98e98$export$9e38ad41d19608ee;
const $9672b8899ab98e98$export$a062badd78c9993 = {
    [$9672b8899ab98e98$export$e82092c4fb277f9b]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$fd75f6abc7861439]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$5eddf3b31dd1858f]: $9672b8899ab98e98$export$50478ee5ecbf7a4d,
    [$9672b8899ab98e98$export$fb658bddae7f81bb]: $9672b8899ab98e98$export$50478ee5ecbf7a4d
};

});

parcelRegister("7dRgX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3913ca223572f8d7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $3913ca223572f8d7$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $3913ca223572f8d7$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $3913ca223572f8d7$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $3913ca223572f8d7$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $3913ca223572f8d7$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $3913ca223572f8d7$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $3913ca223572f8d7$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $3913ca223572f8d7$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $3913ca223572f8d7$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $3913ca223572f8d7$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $3913ca223572f8d7$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $3913ca223572f8d7$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $3913ca223572f8d7$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $3913ca223572f8d7$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $3913ca223572f8d7$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $3913ca223572f8d7$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $3913ca223572f8d7$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $3913ca223572f8d7$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $3913ca223572f8d7$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $3913ca223572f8d7$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $3913ca223572f8d7$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $3913ca223572f8d7$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $3913ca223572f8d7$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $3913ca223572f8d7$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $3913ca223572f8d7$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $3913ca223572f8d7$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $3913ca223572f8d7$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $3913ca223572f8d7$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $3913ca223572f8d7$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $3913ca223572f8d7$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $3913ca223572f8d7$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $3913ca223572f8d7$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $3913ca223572f8d7$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $3913ca223572f8d7$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $3913ca223572f8d7$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $3913ca223572f8d7$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $3913ca223572f8d7$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $3913ca223572f8d7$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $3913ca223572f8d7$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $3913ca223572f8d7$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $3913ca223572f8d7$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $3913ca223572f8d7$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $3913ca223572f8d7$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $3913ca223572f8d7$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $3913ca223572f8d7$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $3913ca223572f8d7$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $3913ca223572f8d7$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $3913ca223572f8d7$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $3913ca223572f8d7$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $3913ca223572f8d7$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $3913ca223572f8d7$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $3913ca223572f8d7$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $3913ca223572f8d7$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $3913ca223572f8d7$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $3913ca223572f8d7$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $3913ca223572f8d7$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $3913ca223572f8d7$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $3913ca223572f8d7$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $3913ca223572f8d7$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $3913ca223572f8d7$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $3913ca223572f8d7$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $3913ca223572f8d7$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $3913ca223572f8d7$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $3913ca223572f8d7$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $3913ca223572f8d7$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $3913ca223572f8d7$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $3913ca223572f8d7$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $3913ca223572f8d7$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $3913ca223572f8d7$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "JWM_BOARD_TASK", () => $3913ca223572f8d7$export$42a8341e3c94a2be);
$parcel$export(module.exports, "JWM_SUMMARY_TASK", () => $3913ca223572f8d7$export$e29c6a916affb308);
$parcel$export(module.exports, "JWM_INVITE_TEAM_TASK", () => $3913ca223572f8d7$export$bc193be3ff1dd519);
$parcel$export(module.exports, "JWM_PAGES_TASK", () => $3913ca223572f8d7$export$73a289f194001f88);

var $exb0h = parcelRequire("exb0h");

var $6vrw7 = parcelRequire("6vrw7");
const $3913ca223572f8d7$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $3913ca223572f8d7$export$2b3151a089bc8780 = 'jlove-makkuro';
const $3913ca223572f8d7$export$6826d33e9a2c0119 = 320;
const $3913ca223572f8d7$export$b580da85daad7757 = 'root';
const $3913ca223572f8d7$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $3913ca223572f8d7$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $3913ca223572f8d7$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $3913ca223572f8d7$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $3913ca223572f8d7$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $3913ca223572f8d7$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $3913ca223572f8d7$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $3913ca223572f8d7$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $3913ca223572f8d7$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $3913ca223572f8d7$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $3913ca223572f8d7$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $3913ca223572f8d7$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $3913ca223572f8d7$export$cbeb719208f32c8a = $3913ca223572f8d7$var$completeJswTaskName('add-columns-task');
const $3913ca223572f8d7$export$88c918f2cfaff86 = $3913ca223572f8d7$var$completeJswTaskName('create-project-task');
const $3913ca223572f8d7$export$abbbea7c37c93cb5 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task');
const $3913ca223572f8d7$export$2a0253cb20f48a8 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task-simplified');
const $3913ca223572f8d7$export$f97428bb4b1991ec = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$45eaf4204fcc7 = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-video-task');
const $3913ca223572f8d7$export$af57685e201438e8 = $3913ca223572f8d7$var$completeJswTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$d6c67e9aab4e2b26 = $3913ca223572f8d7$var$completeJswTaskName('find-help-task');
const $3913ca223572f8d7$export$3de8c242d2b82f26 = $3913ca223572f8d7$var$completeJswTaskName('set-up-board-task');
const $3913ca223572f8d7$export$a01fa44f793dbfac = $3913ca223572f8d7$var$completeJswTaskName('get-mobile-app-task');
const $3913ca223572f8d7$export$6a4507e462fd41da = $3913ca223572f8d7$var$completeJswTaskName('map-out-your-project-goals');
const $3913ca223572f8d7$export$e64c1dced6ac4458 = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work');
const $3913ca223572f8d7$export$63b0e55f9c6454ac = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $3913ca223572f8d7$export$c1effb1c8979fe22 = $3913ca223572f8d7$var$completeJswTaskName('monitor-manage-risk');
const $3913ca223572f8d7$export$d97d31d934dbb194 = $3913ca223572f8d7$var$completeJswTaskName('premium-reverse-trial-task');
const $3913ca223572f8d7$export$cafb5bd13b02056b = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task');
const $3913ca223572f8d7$export$e55c18b809946e72 = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $3913ca223572f8d7$export$de5640b9ae8140a7 = $3913ca223572f8d7$var$completeJswTaskName('standard-edition-overview-task');
const $3913ca223572f8d7$export$540b5c3c4b6ce459 = $3913ca223572f8d7$var$completeJswTaskName('advanced-roadmaps-task');
const $3913ca223572f8d7$export$6f71dff531ff592 = $3913ca223572f8d7$var$completeJswTaskName('change-control-task');
const $3913ca223572f8d7$export$83255ab79e45f34f = $3913ca223572f8d7$var$completeJswTaskName('automations-task');
const $3913ca223572f8d7$export$b57d172af9ad7647 = $3913ca223572f8d7$var$completeJswTaskName('site-administrations-task');
const $3913ca223572f8d7$export$ff4c933c1fe90b68 = $3913ca223572f8d7$var$completeJswTaskName('user-management-task');
const $3913ca223572f8d7$export$3e2776d61f3662dc = $3913ca223572f8d7$var$completeJswTaskName('scrum-onboarding-task');
const $3913ca223572f8d7$export$9048315f2c03fd9d = $3913ca223572f8d7$var$completeJswTaskName('customize-site-name-task');
const $3913ca223572f8d7$export$a333714599f14a6 = $3913ca223572f8d7$var$completeJswTaskName('get-to-know-your-template-task');
const $3913ca223572f8d7$export$4145c2cec2da6f9b = $3913ca223572f8d7$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $3913ca223572f8d7$export$4957a1ad203cf6dd = $3913ca223572f8d7$var$completeJswTaskName('try-atlassian-university-task');
const $3913ca223572f8d7$export$190b5dd0a1322552 = $3913ca223572f8d7$var$completeJswTaskName('calendar-view-task');
const $3913ca223572f8d7$export$501166b25f254aab = $3913ca223572f8d7$var$completeJwmTaskName('jwm-project-summary-task');
const $3913ca223572f8d7$export$94ad6507a703f4eb = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-sample-project-task');
const $3913ca223572f8d7$export$be1c522400a1bd7c = $3913ca223572f8d7$var$completeJwmTaskName('background-color-task');
const $3913ca223572f8d7$export$2aa6e7b6e24a04f5 = $3913ca223572f8d7$var$completeJwmTaskName('calendar-task');
const $3913ca223572f8d7$export$f3b53199b07af2a1 = $3913ca223572f8d7$var$completeJwmTaskName('timeline-task');
const $3913ca223572f8d7$export$d37415ffddcf2142 = $3913ca223572f8d7$var$completeJwmTaskName('build-form-task');
const $3913ca223572f8d7$export$2ae00586da7cb606 = $3913ca223572f8d7$var$completeJwmTaskName('feedback-task');
const $3913ca223572f8d7$export$b86266e6594a97bb = $3913ca223572f8d7$var$completeJwmTaskName('feedback-sample-project-task');
const $3913ca223572f8d7$export$20bc3dc137ac1c38 = $3913ca223572f8d7$var$completeJwmTaskName('create-your-own-project-task');
const $3913ca223572f8d7$export$77071b77e2801b18 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-project-task');
const $3913ca223572f8d7$export$9c89f946f05d884a = $3913ca223572f8d7$var$completeJwmTaskName('share-project-task');
const $3913ca223572f8d7$export$ce8b25442735839a = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-boards');
const $3913ca223572f8d7$export$31015cf4e430c94d = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-cards');
const $3913ca223572f8d7$export$b52a7c936684cfc5 = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-import');
const $3913ca223572f8d7$export$b5555f24061f9fb = $3913ca223572f8d7$var$completeJwmTaskName('summary-and-reports-task');
const $3913ca223572f8d7$export$ff25449f34b8abf = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $3913ca223572f8d7$export$3380e677209260fe = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-key-differences');
const $3913ca223572f8d7$export$7a2fcaad1564e6b7 = $3913ca223572f8d7$var$completeJwmTaskName('get-started-list-task');
const $3913ca223572f8d7$export$99b0e09ff6f00490 = $3913ca223572f8d7$var$completeJsmTaskName('customize-your-request-types-task');
const $3913ca223572f8d7$export$2a82344eb273eeff = $3913ca223572f8d7$var$completeJsmTaskName('review-your-channels-task');
const $3913ca223572f8d7$export$1de5766b7e640d6b = $3913ca223572f8d7$var$completeJsmTaskName('invite-your-team-task');
const $3913ca223572f8d7$export$8ab0859f5b30b013 = $3913ca223572f8d7$var$completeDevopsTaskName('welcome-to-your-project-task');
const $3913ca223572f8d7$export$d1f6d18c6698104c = $3913ca223572f8d7$var$completeDevopsTaskName('get-to-know-jira-task');
const $3913ca223572f8d7$export$e6ee159eee7adc1c = $3913ca223572f8d7$var$completeDevopsTaskName('navigate-your-tools-task');
const $3913ca223572f8d7$export$dd267ca1e3cd3bad = $3913ca223572f8d7$var$completeDevopsTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$f14c8bffc35200d3 = $3913ca223572f8d7$var$completeDevopsTaskName('create-automation-rules-task');
const $3913ca223572f8d7$export$36cc22c9997d92a = $3913ca223572f8d7$var$completeDevopsTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$d651cc94a46ff383 = $3913ca223572f8d7$var$completeDevopsTaskName('find-help-task');
const $3913ca223572f8d7$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $3913ca223572f8d7$export$c8ab6996f562d0db = (0, $6vrw7.toAccountId)('accountId');
const $3913ca223572f8d7$export$2b5f951ad8e70cfe = $3913ca223572f8d7$var$completeJswTaskName('kanban-onboarding-task');
const $3913ca223572f8d7$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $3913ca223572f8d7$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $3913ca223572f8d7$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $3913ca223572f8d7$export$f779bbfe667acddc = [
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PEOPLE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_ACCESS
];
const $3913ca223572f8d7$export$38fbac7a5bf4aa33 = [
    $3913ca223572f8d7$export$2a82344eb273eeff,
    $3913ca223572f8d7$export$99b0e09ff6f00490,
    $3913ca223572f8d7$export$1de5766b7e640d6b
];
const $3913ca223572f8d7$export$42a8341e3c94a2be = $3913ca223572f8d7$var$completeJwmTaskName('jwm-board-task');
const $3913ca223572f8d7$export$e29c6a916affb308 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-summary-task');
const $3913ca223572f8d7$export$bc193be3ff1dd519 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-invite-team-task');
const $3913ca223572f8d7$export$73a289f194001f88 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-pages-task');

});

parcelRegister("c8ave", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("ah9g7")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("ah9g7")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("3TtLb")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("agwlB")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("aI5eR")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("1jaP6")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("1jaP6")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("lCKeP")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("9FTSc")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("iq74h")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("cKB0H")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("8n1zQ")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("ioWKV")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("ioWKV")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("P9NN5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("6GDwI")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("g1Zgk")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dn2YB")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("jssF8")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("ahbtR")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("gn07r")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("7I9OF")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("cDYe7")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("kDmv4")).nextGetTasks);

var $ah9g7 = parcelRequire("ah9g7");

var $3TtLb = parcelRequire("3TtLb");

var $agwlB = parcelRequire("agwlB");

var $aI5eR = parcelRequire("aI5eR");

var $1jaP6 = parcelRequire("1jaP6");

var $lCKeP = parcelRequire("lCKeP");

var $9FTSc = parcelRequire("9FTSc");

var $iq74h = parcelRequire("iq74h");

var $cKB0H = parcelRequire("cKB0H");

var $8n1zQ = parcelRequire("8n1zQ");

var $ioWKV = parcelRequire("ioWKV");

var $P9NN5 = parcelRequire("P9NN5");

var $6GDwI = parcelRequire("6GDwI");

var $g1Zgk = parcelRequire("g1Zgk");

var $dn2YB = parcelRequire("dn2YB");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $gn07r = parcelRequire("gn07r");

var $7I9OF = parcelRequire("7I9OF");

var $cDYe7 = parcelRequire("cDYe7");

var $kDmv4 = parcelRequire("kDmv4");

});
parcelRegister("ah9g7", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $2484e60819053729$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $2484e60819053729$export$57534cbc400a434c);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $2484e60819053729$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $2484e60819053729$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };
const $2484e60819053729$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $7dRgX.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("8ppHd", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $1733f663faa18bb1$export$583b2d2422a6757f);

var $48bs8 = parcelRequire("48bs8");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");
const $1733f663faa18bb1$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $1733f663faa18bb1$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), $1733f663faa18bb1$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
    });
const $1733f663faa18bb1$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $1733f663faa18bb1$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $1733f663faa18bb1$export$583b2d2422a6757f = async (props)=>{
    const success = await $1733f663faa18bb1$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $1733f663faa18bb1$var$trySetUserProperties(props, 2);
};

});


parcelRegister("3TtLb", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $e2436d4b85647276$export$dcf23146e0a40195);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $e2436d4b85647276$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };
var $e2436d4b85647276$export$2e2bcd8739ae039 = $e2436d4b85647276$export$dcf23146e0a40195;

});
parcelRegister("5OjXh", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $6278fa6778740945$export$eae834ce0286017a);

var $7ZZxN = parcelRequire("7ZZxN");

var $7dRgX = parcelRequire("7dRgX");
const $6278fa6778740945$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
const $6278fa6778740945$export$eae834ce0286017a = (state)=>{
    if ($6278fa6778740945$export$6f17f2cb816105eb(state)) return (0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("agwlB", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $8d23b98670e25122$export$797c35e2e1d0d014);

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $9z6Oy = parcelRequire("9z6Oy");


var $jRj3P = parcelRequire("jRj3P");

var $jMP2a = parcelRequire("jMP2a");

var $4sxuP = parcelRequire("4sxuP");

var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");
var $8ppHd = parcelRequire("8ppHd");

var $hFK9U = parcelRequire("hFK9U");

var $lIoQU = parcelRequire("lIoQU");

var $kL6gJ = parcelRequire("kL6gJ");

var $74z6M = parcelRequire("74z6M");

var $4vWp2 = parcelRequire("4vWp2");

var $9vuWT = parcelRequire("9vuWT");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $g1Zgk = parcelRequire("g1Zgk");

var $ah9g7 = parcelRequire("ah9g7");

var $fzDyP = parcelRequire("fzDyP");
// Right now we list all the available tasks manually.
const $8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks = [
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
    (0, $7dRgX.CHANGE_CONTROL_TASK),
    (0, $7dRgX.AUTOMATIONS_TASK),
    (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
    (0, $7dRgX.USER_MANAGEMENT_TASK),
    (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
    (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
    (0, $7dRgX.JWM_CALENDAR_TASK),
    (0, $7dRgX.JWM_TIMELINE_TASK),
    (0, $7dRgX.JWM_BUILD_FORM_TASK),
    (0, $7dRgX.JWM_FEEDBACK_TASK),
    (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
    (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
    (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
    (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
    (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
    (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
    (0, $7dRgX.DEVOPS_FIND_HELP_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.JWM_BOARD_TASK),
    (0, $7dRgX.JWM_SUMMARY_TASK),
    (0, $7dRgX.JWM_INVITE_TEAM_TASK),
    (0, $7dRgX.JWM_PAGES_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $8d23b98670e25122$var$allTasks = [
    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
    ...(0, $7dRgX.JSM_BUSINESS_TASKS)
];
const $8d23b98670e25122$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            // Open QS Checklist as default state if state cannot be determined from the backend
            updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {});
            backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, $7dRgX.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        }
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_TASK_GROUP),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                ...$8d23b98670e25122$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $74z6M.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = (0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? Object.keys(backendState).filter((key)=>[
                    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true) : Object.keys(backendState).filter((key)=>$8d23b98670e25122$var$allTasks.includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        if (atlassianAccountId && projectType === (0, $7ZZxN.CORE_PROJECT) && (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)()) try {
            const userTraits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
                cloudId: cloudId,
                userId: atlassianAccountId
            });
            const userTraitsPersona = userTraits?.find((trait)=>trait.name === (0, $4vWp2.PERSONA_TRAIT_NAME));
            const personaExperience = (0, $fzDyP.mapPersonaTraitsToExperience)(userTraitsPersona);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState settingPersonaExperienceFromTraits', {
                personaExperience: personaExperience,
                persona: userTraitsPersona?.value,
                tailoredOnboardingExperiment1: (0, $hFK9U.getTailoredOnboardingExperimentCohort)()
            });
            if (personaExperience) updatedState.personaExperience = personaExperience;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'fetchSiteUserPersonalization');
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $6WXNs.PREMIUM_EDITION)) {
            dispatch((0, $ah9g7.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $9z6Oy.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $kL6gJ.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $4sxuP.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (!shouldSimplifyKanbanQs && !isReverseTrialForJSW && appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
            dispatch((0, $jssF8.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $g1Zgk.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $ah9g7.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("9z6Oy", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $d04aec276ef38a16$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $d04aec276ef38a16$export$6da79f996c267010);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/site/`;
const $d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/user/`;
const $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $d04aec276ef38a16$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $lRmyA.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $d04aec276ef38a16$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes.find((att)=>att.name === traitName);
    };
const $d04aec276ef38a16$export$686752df505238be = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $d04aec276ef38a16$export$6da79f996c267010 = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


parcelRegister("4sxuP", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $1907cbeebd30077d$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $1907cbeebd30077d$export$ef676f7f369f74fe);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $1lUvF = parcelRequire("1lUvF");
const $1907cbeebd30077d$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $1907cbeebd30077d$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $1lUvF.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $1lUvF.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $lRmyA.performGetRequestWithRetry)($1907cbeebd30077d$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $1lUvF.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $1lUvF.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $1907cbeebd30077d$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $1907cbeebd30077d$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("1lUvF", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$f389f8ca168b4a3a);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $d5d23c94342aad01$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $d5d23c94342aad01$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $d5d23c94342aad01$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $d5d23c94342aad01$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$c3378895d06b5528 = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $d5d23c94342aad01$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});




parcelRegister("6kCnW", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $72b53773fb858e3c$export$8420ef0cee98de);

var $95f8K = parcelRequire("95f8K");

var $6vrw7 = parcelRequire("6vrw7");

var $7dRgX = parcelRequire("7dRgX");
const $72b53773fb858e3c$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $95f8K.get)((0, $6vrw7.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("95f8K", function(module, exports) {

$parcel$export(module.exports, "get", () => $4b3de6acfae5f7c4$export$3988ae62b71be9a3);

var $fUTZC = parcelRequire("fUTZC");

var $4vTMF = parcelRequire("4vTMF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
const $4b3de6acfae5f7c4$var$getUfoExperience = (key)=>{
    if (!$4b3de6acfae5f7c4$var$ufoExperiencesMap[key]) $4b3de6acfae5f7c4$var$ufoExperiencesMap[key] = new (0, $kDfSL.UFOExperience)(key, {
        type: (0, $12kyE.ExperienceTypes).Operation,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
    });
    return $4b3de6acfae5f7c4$var$ufoExperiencesMap[key];
};
const $4b3de6acfae5f7c4$export$c907f169d33b2e25 = ()=>{
    $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
};
const $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b3de6acfae5f7c4$var$patchProperties = (response, propertiesPath)=>(0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $4b3de6acfae5f7c4$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $4b3de6acfae5f7c4$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $lRmyA.performGetRequest)(url);
        $4b3de6acfae5f7c4$var$patchProperties(response, 'user');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'instance');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("hFK9U", function(module, exports) {

$parcel$export(module.exports, "getTailoredOnboardingExperimentCohort", () => $7643a0c0824fb12c$export$fcb264347c366122);
$parcel$export(module.exports, "isUserEnrolledInTailoredOnboardingExperiment", () => $7643a0c0824fb12c$export$7b8159a372d92686);
$parcel$export(module.exports, "isTailoredQuickstartEnabled", () => $7643a0c0824fb12c$export$65a9481ea376f1be);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $4vWp2 = parcelRequire("4vWp2");
const $7643a0c0824fb12c$export$fcb264347c366122 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_tailored_onboarding');
    return expConfig.get('cohort', 'not-enrolled');
};
const $7643a0c0824fb12c$export$7b8159a372d92686 = ()=>{
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_gate')) {
        const userCohort = $7643a0c0824fb12c$export$fcb264347c366122();
        return userCohort !== 'not-enrolled';
    }
    return false;
};
const $7643a0c0824fb12c$export$65a9481ea376f1be = (personaExperience)=>Boolean(personaExperience && (0, $4vWp2.SUPPORTED_PERSONA_EXPERIENCES).includes(personaExperience) && (0, $79xbN.expValEquals)('jwm_tailored_onboarding', 'cohort', 'variation'));

});
parcelRegister("4vWp2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TYPE", () => $9d1a089e61b3d8e4$export$19cb56bee281315d);
$parcel$export(module.exports, "PERSONA_TYPE", () => $9d1a089e61b3d8e4$export$4fea3380347f1b0);
$parcel$export(module.exports, "PERSONA_TRAIT_NAME", () => $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d);
$parcel$export(module.exports, "SUPPORTED_PERSONA_EXPERIENCES", () => $9d1a089e61b3d8e4$export$cbc64427de2881a9);
const $9d1a089e61b3d8e4$export$19cb56bee281315d = {
    MARKETER_LEAD: 'Campaign Management Marketing Lead',
    MARKETER_PROJECT: 'Project Management Marketing Lead',
    MARKETER_CONTENT: 'Content Management Content Marketer',
    MARKETER_PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$4fea3380347f1b0 = {
    MARKETING_GENERIC: 'Marketing Generic',
    PROJECT_MARKETING_LEAD: 'Project Management Marketing Lead',
    CAMPAIGN_MARKETING_LEAD: 'Campaign Management Marketing Lead',
    CONTENT_MARKETING_LEAD: 'Content Management Content Marketer',
    PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d = 'marketing_track_tailored_onboarding_initialized_wacprovisioningscreen_changed';
const $9d1a089e61b3d8e4$export$cbc64427de2881a9 = [
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_LEAD,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PROJECT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_CONTENT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PMM
];

});


parcelRegister("lIoQU", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $d6df15178ffe1f85$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $d6df15178ffe1f85$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $d6df15178ffe1f85$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $d6df15178ffe1f85$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $d6df15178ffe1f85$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $d6df15178ffe1f85$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $d6df15178ffe1f85$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $d6df15178ffe1f85$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $d6df15178ffe1f85$export$6c39ca65ca354e59);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");
parcelRequire("bnszi");
var $eVkIs = parcelRequire("eVkIs");
const $d6df15178ffe1f85$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $7dRgX.ACTION_SUBJECT_ID), attributes);
};
const $d6df15178ffe1f85$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $d6df15178ffe1f85$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $d6df15178ffe1f85$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $eVkIs.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $d6df15178ffe1f85$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $d6df15178ffe1f85$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("bnszi", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $1a376c852d3b72fa$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $1a376c852d3b72fa$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $1a376c852d3b72fa$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $1a376c852d3b72fa$export$293f6b2affa6ea5a);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => (parcelRequire("eVkIs")).convertTaskIdToActionSubjectId);

var $eVkIs = parcelRequire("eVkIs");

var $8ppHd = parcelRequire("8ppHd");

var $6kCnW = parcelRequire("6kCnW");

var $cY793 = parcelRequire("cY793");

var $jTgI9 = parcelRequire("jTgI9");

var $6JZfU = parcelRequire("6JZfU");

var $iZV3I = parcelRequire("iZV3I");
const $1a376c852d3b72fa$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $1a376c852d3b72fa$export$9711f11998d5795c = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $1a376c852d3b72fa$export$995248f3b43d8505 = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $1a376c852d3b72fa$export$293f6b2affa6ea5a = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});
parcelRegister("eVkIs", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $0947b77be3ed825c$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $0947b77be3ed825c$export$3b914201960fa7a6);

var $jh2R9 = parcelRequire("jh2R9");

var $7ZZxN = parcelRequire("7ZZxN");
const $0947b77be3ed825c$export$d64a7dd8c7cd80e0 = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'workManagement',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $0947b77be3ed825c$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $0947b77be3ed825c$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType);
    return null;
};
const $0947b77be3ed825c$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(taskId.split('.').pop());
};

});

parcelRegister("cY793", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $f403f41047806be6$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $f403f41047806be6$export$f2666fae743fa5f);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $7dRgX = parcelRequire("7dRgX");
const $f403f41047806be6$var$DAYS_BEFORE_EXPIRY = 1;
const $f403f41047806be6$var$DAY = 86400000;
const $f403f41047806be6$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $f403f41047806be6$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $f403f41047806be6$var$DAYS_BEFORE_EXPIRY * $f403f41047806be6$var$DAY;
};
let $f403f41047806be6$var$localStorage;
const $f403f41047806be6$export$aa821bfb3308a1f5 = ()=>{
    if ($f403f41047806be6$var$localStorage) return $f403f41047806be6$var$localStorage;
    const provider = (0, $89bO2.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }), value, $f403f41047806be6$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    $f403f41047806be6$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $f403f41047806be6$var$localStorage;
};
const $f403f41047806be6$export$f2666fae743fa5f = (value)=>{
    $f403f41047806be6$export$aa821bfb3308a1f5().set({
        accountId: (0, $7dRgX.ACCOUNT_ID),
        key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});



parcelRegister("jTgI9", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $2e4ffaed7bae8e69$export$d1fa67c1ffb68871);

var $exb0h = parcelRequire("exb0h");
const $2e4ffaed7bae8e69$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC;
};

});

parcelRegister("6JZfU", function(module, exports) {

$parcel$export(module.exports, "getAdminHubUrl", () => $962b8ae814600457$export$631ba87ff5b9e288);

var $bW292 = parcelRequire("bW292");
const $962b8ae814600457$export$631ba87ff5b9e288 = ({ suffix: suffix, cloudId: cloudId, orgId: orgId })=>{
    const instanceUrl = (0, $bW292.getATLContextUrl)('admin');
    if (orgId !== undefined && orgId !== '') return `${instanceUrl}/o/${orgId}/${suffix}`;
    if (cloudId) return `${instanceUrl}/s/${cloudId}/${suffix}`;
    return `${instanceUrl}/${suffix}`;
};

});

parcelRegister("iZV3I", function(module, exports) {

$parcel$export(module.exports, "getConnectActionLinkProps", () => $71c2f501f2f8e99c$export$8a467272e65de2b7);

var $jxzG5 = parcelRequire("jxzG5");

var $jMP2a = parcelRequire("jMP2a");
const $71c2f501f2f8e99c$export$8a467272e65de2b7 = (integrationKey, linkActionSubjectId, message)=>{
    // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
    const link = (0, $jxzG5.getEmceeAppListingLink)(integrationKey, {
        source: 'quickstart',
        installDialogOpen: true
    });
    return {
        message: message,
        onClick: (event, analyticsEvent)=>{
            event.stopPropagation();
            const eventName = `${linkActionSubjectId}ConnectApp`;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, eventName, {
                link: link,
                integration: integrationKey
            });
        },
        link: link
    };
};

});
parcelRegister("jxzG5", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $20f94d12e4a0a9d7$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $20f94d12e4a0a9d7$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $20f94d12e4a0a9d7$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $20f94d12e4a0a9d7$export$350ca33eed6a2742);

var $1ybV0 = parcelRequire("1ybV0");
const $20f94d12e4a0a9d7$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $20f94d12e4a0a9d7$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $20f94d12e4a0a9d7$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
    let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
    if (jiraQueryParams) connectDiscoverUrl = $20f94d12e4a0a9d7$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
    return connectDiscoverUrl;
};
const $20f94d12e4a0a9d7$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? $20f94d12e4a0a9d7$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`) : $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, `${$20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, // @ts-expect-error - TS2345 - Argument of type 'JiraQueryParams | null | undefined' is not assignable to parameter of type 'JiraQueryParams | undefined'.
    jiraQueryParams)}#!/discover/app/${appKey}`);
const $20f94d12e4a0a9d7$export$7ab8c48f9081e976 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$350ca33eed6a2742 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};

});




parcelRegister("kL6gJ", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $2a787116be621779$export$7f2186c37a3d095d);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $lmEST = parcelRequire("lmEST");
const $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $2a787116be621779$var$ONE_DAY = 86400000;
const $2a787116be621779$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $lRmyA.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $7dRgX.PACKAGE_NAME),
                teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $2a787116be621779$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $lmEST.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $2a787116be621779$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $2a787116be621779$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("lmEST", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $6d7ad5c5e3880914$export$99f3e48748c2a8c3);

var $89bO2 = parcelRequire("89bO2");

const $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider = (0, $89bO2.createSessionExpirableStorageProvider)((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
const $6d7ad5c5e3880914$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.set((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.get((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $e2fa640244aa9949$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("74z6M", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $22fff37650eaf366$export$88ee873472aa9bb7);

var $7dRgX = parcelRequire("7dRgX");
const $22fff37650eaf366$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $7dRgX.KEY_IS_DEVOPS_PROJECT}`;
const $22fff37650eaf366$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $22fff37650eaf366$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("9vuWT", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $c73311db2e118d57$export$980c26b6f100081d);

var $lRmyA = parcelRequire("lRmyA");
const $c73311db2e118d57$export$980c26b6f100081d = ()=>(0, $lRmyA.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("jssF8", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $ad333f190549603d$export$f24c05f83b880547);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $ahbtR = parcelRequire("ahbtR");
const $ad333f190549603d$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) // if state has not been updated we just return
            return;
            const quickstartStatus = isDismissed ? (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED : (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with Quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: true
            });
            else // When setting IsDismissed, also toggle the open state of the checklist to match.
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: false
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_DISMISSED),
                value: isDismissed
            });
            return;
        }
        /* Grab current state of is isDismissed */ const { isDismissed: currentIsDismissed } = getState();
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        setState({
            isDismissed: isDismissed
        });
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(false));
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_DISMISSED),
            value: isDismissed
        });
    };

});
parcelRegister("ahbtR", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $42c7858c3f713220$export$4249eabbb34e2e69);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $42c7858c3f713220$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen,
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };

});


parcelRegister("g1Zgk", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $13a2c09b85cecff0$export$d6628d41a3bec42d);

var $8ppHd = parcelRequire("8ppHd");
const $13a2c09b85cecff0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $8ppHd.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("fzDyP", function(module, exports) {

$parcel$export(module.exports, "mapPersonaTraitsToExperience", () => $b7c30df71a7183dd$export$54560e73c5a0e8ff);

var $4vWp2 = parcelRequire("4vWp2");
const $b7c30df71a7183dd$export$54560e73c5a0e8ff = (userTraitsPersona)=>{
    switch(userTraitsPersona?.value){
        case (0, $4vWp2.PERSONA_TYPE).MARKETING_GENERIC:
        case (0, $4vWp2.PERSONA_TYPE).CAMPAIGN_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD;
        case (0, $4vWp2.PERSONA_TYPE).PROJECT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT;
        case (0, $4vWp2.PERSONA_TYPE).CONTENT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT;
        case (0, $4vWp2.PERSONA_TYPE).PMM:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM;
        default:
            return undefined;
    }
};

});


parcelRegister("aI5eR", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $970ae6c28ea9ba56$export$4debc323813b6997);
const $970ae6c28ea9ba56$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $970ae6c28ea9ba56$export$2e2bcd8739ae039 = $970ae6c28ea9ba56$export$4debc323813b6997;

});

parcelRegister("1jaP6", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d76ba5c46e283800$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d76ba5c46e283800$export$748f4cda8ab98c91);
const $d76ba5c46e283800$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d76ba5c46e283800$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("lCKeP", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $3e69fb4a25487c6b$export$1f9c6770ed938b6e);
const $3e69fb4a25487c6b$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $3e69fb4a25487c6b$export$2e2bcd8739ae039 = $3e69fb4a25487c6b$export$1f9c6770ed938b6e;

});

parcelRegister("9FTSc", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $e8f28a5d91b40a98$export$1ba498e440c0a1e4);
const $e8f28a5d91b40a98$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $e8f28a5d91b40a98$export$2e2bcd8739ae039 = $e8f28a5d91b40a98$export$1ba498e440c0a1e4;

});

parcelRegister("iq74h", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $d5d9f3bbfe59a243$export$497c281e6eb0786e);
const $d5d9f3bbfe59a243$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $d5d9f3bbfe59a243$export$2e2bcd8739ae039 = $d5d9f3bbfe59a243$export$497c281e6eb0786e;

});

parcelRegister("cKB0H", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $395e6590b72e7adc$export$6d1ed97b83a62e8e);
// We use this action in cases where we want to hide the nudge no matter what.
const $395e6590b72e7adc$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("8n1zQ", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $9526def4b4979224$export$28e0a4314a1ce52f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $9526def4b4979224$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $9526def4b4979224$export$2e2bcd8739ae039 = $9526def4b4979224$export$28e0a4314a1ce52f;

});

parcelRegister("ioWKV", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $3aa7d72125406d8f$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $3aa7d72125406d8f$export$932967764e7a0b31);
const $3aa7d72125406d8f$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $3aa7d72125406d8f$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("P9NN5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $cc1aff9593d14250$export$867dbb6d61569ae9);

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $cc1aff9593d14250$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $egHFE.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("egHFE", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $e5132247b337604d$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $e5132247b337604d$export$404421ce8f3cbf9a);

var $bnszi = parcelRequire("bnszi");
const $e5132247b337604d$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $e5132247b337604d$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};

});

parcelRegister("gn07r", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $4f8f6eacc80982cf$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $4f8f6eacc80982cf$export$cc5f3544a6cb2922);

var $79xbN = parcelRequire("79xbN");


var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $aI5eR = parcelRequire("aI5eR");

var $iq74h = parcelRequire("iq74h");
const $4f8f6eacc80982cf$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $4f8f6eacc80982cf$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $iq74h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.SCRUM_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.KANBAN_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else if (shouldSimplifyKanbanQs && taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.ADD_COLUMNS_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else dispatch((0, $aI5eR.setNudgeStep)(''));
    };
const $4f8f6eacc80982cf$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        dispatch((0, $aI5eR.setNudgeStep)(''));
    };

});


parcelRegister("6GDwI", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $cf59d5b51193e99b$export$bda085a823763e5a);

var $7dRgX = parcelRequire("7dRgX");

var $5OjXh = parcelRequire("5OjXh");
const $cf59d5b51193e99b$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("dn2YB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $ae4dc9d92cd110b5$export$4eac017dcde0be8f);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $gn07r = parcelRequire("gn07r");
const $ae4dc9d92cd110b5$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const hasSeenTaskId = (0, $7dRgX.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.convertToHaveSeenItTask)(taskId),
            value: true
        });
        // This will prioritise expanding this current taskId as the next card to expand.
        // For simplify kanban QS we don't want to expand hasSeen cards first
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (shouldSimplifyKanbanQs === false) dispatch((0, $gn07r.nextOpenTask)(taskId));
    };

});

parcelRegister("7I9OF", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $8c8cecc90fef13d0$export$3d24e97d30cfd09e);

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $8c8cecc90fef13d0$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $cY793.localStorageProvider)().get({
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $egHFE.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextAutoOpenTask)(taskIdToExpand));
    };

});

parcelRegister("cDYe7", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $3949917718560fd8$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $iq74h = parcelRequire("iq74h");
const $3949917718560fd8$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $cY793.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $iq74h.setHasNudgeActive)(true));
            (0, $cY793.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("kDmv4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $2cffb9be55c6d345$export$15d877e1f3abf489);

var $a0vMn = parcelRequire("a0vMn");
const $2cffb9be55c6d345$export$15d877e1f3abf489 = (props)=>({ setState: setState })=>{
        const tasks = (0, $a0vMn.getAllTasks)(props);
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("a0vMn", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $62ef3d093ab58a52$export$d1f442602a91e7cc);

var $dfBCt = parcelRequire("dfBCt");

var $exb0h = parcelRequire("exb0h");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $jTgI9 = parcelRequire("jTgI9");

var $hFK9U = parcelRequire("hFK9U");

var $fricC = parcelRequire("fricC");

var $4vWp2 = parcelRequire("4vWp2");

var $kxycg = parcelRequire("kxycg");
var $3sCLn = parcelRequire("3sCLn");
var $2UWYK = parcelRequire("2UWYK");
var $c2fmF = parcelRequire("c2fmF");

var $2hhuw = parcelRequire("2hhuw");

var $5f5jN = parcelRequire("5f5jN");
const $62ef3d093ab58a52$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    if (variants.includes((0, $2UWYK.JSW).experiment.jswReverseTrial)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $7dRgX.ROOT_TASK) ? (0, $7dRgX.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $7dRgX.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $7dRgX.ROOT_TASK];
    return {
        title: title,
        items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
    };
};
const $62ef3d093ab58a52$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $7dRgX.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
    const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
    const isEligibleForKanbanTour = mountedNudges.includes((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112));
    if ((0, $dfBCt.isFedRamp)()) variants.add((0, $2UWYK.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) variants.add((0, $2UWYK.JSW).experiment.jswReverseTrial);
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250') && isCustomerTemplateProject) variants.add((0, $2UWYK.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $2UWYK.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $2UWYK.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $2UWYK.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).experience.kanbanOnboarding);
    if (shouldSimplifyKanbanQs) variants.add((0, $2UWYK.JSW).experiment.simplifyKanbanQS);
    if (canCreateProject === false) variants.add((0, $2UWYK.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $2UWYK.JSW).projectStyle.teamManaged);
    else variants.add((0, $2UWYK.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $2UWYK.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.jiraAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.siteAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $6WXNs.FREE_EDITION)) variants.add((0, $2UWYK.JSW).edition.free);
    else if (projectState?.edition === (0, $6WXNs.STANDARD_EDITION)) variants.add((0, $2UWYK.JSW).edition.standard);
    else if (projectState?.edition === (0, $6WXNs.PREMIUM_EDITION)) variants.add((0, $2UWYK.JSW).edition.premium);
    if ((0, $jTgI9.isRoadmapRoute)(routeName)) variants.add((0, $2UWYK.JSW).route.softwareRoadmap);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG) variants.add((0, $2UWYK.JSW).route.softwareBacklog);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).route.softwareBoard);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC) variants.add((0, $2UWYK.JSW).route.softwareList);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_ACCESS) variants.add((0, $2UWYK.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).ISSUE) variants.add((0, $2UWYK.JSW).route.issue);
    else if ((0, $1ybV0.ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_CLASSIC)) variants.add((0, $2UWYK.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $2UWYK.JSW).experiment.customizeSiteName);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $2UWYK.JSW).taskVariants,
        taskList: (0, $2UWYK.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJwmTasks = (projectState, taskGroupParent, personaExperience)=>{
    const variants = [];
    variants.push((0, $c2fmF.JWM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $c2fmF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $c2fmF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $c2fmF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $c2fmF.JWM).experiments.isSampleProject);
    else variants.push((0, $c2fmF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $c2fmF.JWM).experiments.trelloCrossflow);
    if ((0, $hFK9U.isTailoredQuickstartEnabled)(personaExperience)) {
        variants.push((0, $c2fmF.JWM).experiments.personalizedExperience);
        switch(personaExperience){
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.marketingLeader);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.projectMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.contentMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.productMarketingManager);
                break;
            default:
                break;
        }
    }
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c2fmF.JWM).taskVariants,
        taskList: (0, $c2fmF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3sCLn.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3sCLn.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $3sCLn.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $3sCLn.JSM).userRole.siteAdmin);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3sCLn.JSM).taskVariants,
        taskList: (0, $3sCLn.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $kxycg.DEVOPS).taskVariants,
        taskList: (0, $kxycg.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, personaExperience: personaExperience })=>{
    if ((0, $5f5jN.isJwmProject)(projectState)) return $62ef3d093ab58a52$var$createJwmTasks(projectState, taskGroupParent, personaExperience);
    if ((0, $5f5jN.isJsmProject)(projectState)) return $62ef3d093ab58a52$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $62ef3d093ab58a52$var$createDevopsTasks(taskGroupParent);
    return $62ef3d093ab58a52$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("fricC", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $3def7289adf5e608$export$8eeb199b23203523);
const $3def7289adf5e608$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("kxycg", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $503385b7e39437c3$export$bb75b6064c92010c);

var $bxltp = parcelRequire("bxltp");
const $503385b7e39437c3$export$bb75b6064c92010c = {
    taskList: (0, $bxltp.TASK_LIST),
    taskVariants: (0, $bxltp.TASK_VARIANTS),
    experiment: (0, $bxltp.Experiment)
};

});
parcelRegister("bxltp", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7cc3b723e4b7a76f$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $ePWG3 = parcelRequire("ePWG3");
const $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009 = {};
const $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ePWG3.messages).rootTitle,
        items: [
            (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $7dRgX.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7cc3b723e4b7a76f$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("ePWG3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c9ac3fc1eb167f1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c9ac3fc1eb167f1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3sCLn", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $9ce9aa4e7fe0438e$export$63f289f2da861d35);

var $4Euci = parcelRequire("4Euci");
const $9ce9aa4e7fe0438e$export$63f289f2da861d35 = {
    taskList: (0, $4Euci.JSM_TASK_LIST),
    taskVariants: (0, $4Euci.JSM_TASK_VARIANTS),
    userRole: (0, $4Euci.UserRole),
    experiments: (0, $4Euci.Experiments)
};

});
parcelRegister("4Euci", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $fb74ace10b289ae1$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $fb74ace10b289ae1$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $fb74ace10b289ae1$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $fb74ace10b289ae1$export$5b68aef408c932d9);

var $7dRgX = parcelRequire("7dRgX");

var $aC2eo = parcelRequire("aC2eo");
const $fb74ace10b289ae1$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $aC2eo.messages).rootTitle,
        items: [
            (0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $fb74ace10b289ae1$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $fb74ace10b289ae1$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $fb74ace10b289ae1$export$5b68aef408c932d9 = {
    [(0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("aC2eo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c73088a9cd2645bf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c73088a9cd2645bf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("2UWYK", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $bddfc54f60451b1f$export$4cfe6e52f2e72a54);

var $8nR1z = parcelRequire("8nR1z");
const $bddfc54f60451b1f$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8nR1z.TASK_LIST),
    taskVariants: (0, $8nR1z.TASK_VARIANTS),
    experiment: (0, $8nR1z.Experiment),
    experience: (0, $8nR1z.Experience),
    projectStyle: (0, $8nR1z.ProjectStyle),
    projectProperties: (0, $8nR1z.ProjectProperties),
    userRole: (0, $8nR1z.UserRole),
    edition: (0, $8nR1z.Edition),
    route: (0, $8nR1z.Route),
    permissions: (0, $8nR1z.Permissions),
    trait: (0, $8nR1z.Trait)
};

});
parcelRegister("8nR1z", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7a9145b1fc208f16$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $7a9145b1fc208f16$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $7a9145b1fc208f16$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $7a9145b1fc208f16$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $7a9145b1fc208f16$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $7a9145b1fc208f16$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $7a9145b1fc208f16$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $7a9145b1fc208f16$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $7a9145b1fc208f16$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $7a9145b1fc208f16$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7a9145b1fc208f16$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $inMFY = parcelRequire("inMFY");
const $7a9145b1fc208f16$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    simplifyKanbanQS: 'experiment.simplifyKanbanQS'
};
const $7a9145b1fc208f16$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $7a9145b1fc208f16$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $7a9145b1fc208f16$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $7a9145b1fc208f16$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $7a9145b1fc208f16$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $7a9145b1fc208f16$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $7a9145b1fc208f16$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $7a9145b1fc208f16$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $7a9145b1fc208f16$var$DEFAULT_TASK_LIST = [
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $7a9145b1fc208f16$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $inMFY.messages).rootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $inMFY.messages).reverseTrialRootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $inMFY.messages).reverseTrialCardTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK)
        ]
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).standardPlanTitle,
        items: [
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS = {
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$export$36f4d47dfe11b613 = {
    ...$7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS,
    ...$7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $7dRgX.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $7dRgX.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.KANBAN_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("inMFY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52d99860e7a60493$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52d99860e7a60493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("c2fmF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $562f552a719c049d$export$3ff26c80cb588e12);

var $l40o4 = parcelRequire("l40o4");

var $hBhFD = parcelRequire("hBhFD");

var $kN5DK = parcelRequire("kN5DK");
const $562f552a719c049d$export$3ff26c80cb588e12 = {
    taskList: (0, $l40o4.TASK_LIST),
    taskVariants: (0, $l40o4.TASK_VARIANTS),
    userRole: (0, $kN5DK.UserRole),
    experiments: (0, $hBhFD.Experiments),
    personalizedExperienceExperiments: (0, $hBhFD.PersonalizedExperienceExperiments)
};

});
parcelRegister("l40o4", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $0a485b7af0b81750$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $0a485b7af0b81750$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $hBhFD = parcelRequire("hBhFD");

var $1deRh = parcelRequire("1deRh");

var $kN5DK = parcelRequire("kN5DK");
const $0a485b7af0b81750$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1deRh.messages).rootTitle,
        items: [
            (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
            (0, $7dRgX.GET_STARTED_LIST_TASK),
            (0, $7dRgX.JWM_CALENDAR_TASK),
            (0, $7dRgX.JWM_BOARD_TASK),
            (0, $7dRgX.JWM_TIMELINE_TASK),
            (0, $7dRgX.JWM_BUILD_FORM_TASK),
            (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
            (0, $7dRgX.JWM_FEEDBACK_TASK),
            (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
            (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
            (0, $7dRgX.JWM_SUMMARY_TASK),
            (0, $7dRgX.JWM_INVITE_TEAM_TASK),
            (0, $7dRgX.JWM_PAGES_TASK)
        ]
    }
});
const $0a485b7af0b81750$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: 60
                }
            ]
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BOARD_TASK)]: {
        position: {
            default: 250
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PAGES_TASK)]: {
        position: {
            default: 375,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: 325
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).marketingLeader
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_INVITE_TEAM_TASK)]: {
        position: {
            default: 550
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("hBhFD", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $602d627ebd2e1820$export$c8d6ffd15214553a);
$parcel$export(module.exports, "PersonalizedExperienceExperiments", () => $602d627ebd2e1820$export$ce14e6ba2f059143);
const $602d627ebd2e1820$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow',
    personalizedExperience: 'personalizedExperience'
};
const $602d627ebd2e1820$export$ce14e6ba2f059143 = {
    marketingLeader: 'personalizedExperience.marketing-leader',
    contentMarketer: 'personalizedExperience.content-marketer',
    projectMarketer: 'personalizedExperience.project-marketer',
    productMarketingManager: 'personalizedExperience.pmm'
};

});

parcelRegister("1deRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c87cc11a21af694$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c87cc11a21af694$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("kN5DK", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $c7f18eb8f889bc31$export$eb3485a690c2f0b8);
const $c7f18eb8f889bc31$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("2hhuw", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $1a771609d4c77a5c$export$20b82b4a32771893);

var $kfb7k = parcelRequire("kfb7k");
const $1a771609d4c77a5c$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $kfb7k.getConditional)(visibility, variants) : true;
const $1a771609d4c77a5c$var$getTaskPosition = (variants, position)=>(0, $kfb7k.getConditional)(position, variants);
const $1a771609d4c77a5c$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$1a771609d4c77a5c$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskA].position) - $1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("kfb7k", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $75b9324579affeba$export$fe3161cde0106bba);
const $75b9324579affeba$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("5f5jN", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $4c12cc14f77b8d26$export$a972ed853ed1d469);

var $7ZZxN = parcelRequire("7ZZxN");
const $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $7ZZxN.CORE_PROJECT);
const $4c12cc14f77b8d26$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});




parcelRegister("lCsoa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba3eaa3fc426760$export$d4c72bab9d6cc13a);

var $7dRgX = parcelRequire("7dRgX");
const $eba3eaa3fc426760$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $7dRgX.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});

parcelRegister("7AH2S", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $eea7a281b809b1c9$export$52a03a3207af3687);

var $eUqFw = parcelRequire("eUqFw");

var $dWLk9 = parcelRequire("dWLk9");
var $1R3n5 = parcelRequire("1R3n5");

var $9qoWk = parcelRequire("9qoWk");
const $eea7a281b809b1c9$export$52a03a3207af3687 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [{ value: value }, { fetchOrgId: fetchOrgId }] = (0, $9qoWk.useLinkedOrg)();
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) fetchOrgId(cloudId);
    }, [
        fetchOrgId,
        isSiteAdmin,
        cloudId
    ]);
    return value;
};

});
parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("1R3n5", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $ae5c0c470cafb895$export$f9f8a5cdb0c565ef);

var $gd0Sp = parcelRequire("gd0Sp");
const $ae5c0c470cafb895$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("9qoWk", function(module, exports) {

$parcel$export(module.exports, "useLinkedOrg", () => $136457ccda5882c7$export$cefa7c513db62fe3);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k0YUt = parcelRequire("k0YUt");
const $136457ccda5882c7$var$actions = {
    fetchOrgId: $k0YUt.fetchOrgId
};
const $136457ccda5882c7$var$initialState = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false
};
const $136457ccda5882c7$var$Store = (0, $a61MH.createStore)({
    initialState: $136457ccda5882c7$var$initialState,
    actions: $136457ccda5882c7$var$actions,
    name: 'jsw-onboarding-quickstart-linked-org'
});
const $136457ccda5882c7$export$cefa7c513db62fe3 = (0, $ggKAj.createHook)($136457ccda5882c7$var$Store);

});
parcelRegister("k0YUt", function(module, exports) {

$parcel$export(module.exports, "fetchOrgId", () => $1a44f805e278eb93$export$c78d9b18cf152ce8);

var $lIoQU = parcelRequire("lIoQU");

var $5IvqT = parcelRequire("5IvqT");

var $38Uht = parcelRequire("38Uht");
const $1a44f805e278eb93$export$5a762450d50ca901 = async (cloudId)=>{
    try {
        const result = await (0, $38Uht.getLinkedOrg)(cloudId);
        return result.id;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lIoQU.fireAPIErrorAnalytics)(error, 'getLinkedOrg');
    }
    return null;
};
const $1a44f805e278eb93$export$c78d9b18cf152ce8 = (0, $5IvqT.cachedEndpointCall)($1a44f805e278eb93$export$5a762450d50ca901);

});
parcelRegister("5IvqT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $a81d42548e97f6e6$export$9ab04ab45a9b99da);
const $a81d42548e97f6e6$export$9ab04ab45a9b99da = (call)=>(props)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching) return;
            if (wasFetched) return;
            setState({
                isFetching: true
            });
            const value = await call(props);
            if (value !== null) setState({
                value: value,
                isFetching: false,
                wasFetched: true,
                fetchedOnce: true
            });
            else setState({
                isFetching: false,
                wasFetched: fetchedOnce,
                fetchedOnce: true
            });
        };

});

parcelRegister("38Uht", function(module, exports) {

$parcel$export(module.exports, "getLinkedOrg", () => $3ce7ef8e40b0a0d5$export$fee654dbe03c901f);

var $2OdyW = parcelRequire("2OdyW");
const $3ce7ef8e40b0a0d5$export$fee654dbe03c901f = (cloudId)=>(0, $2OdyW.default)(`/gateway/api/adminhub/sites/${cloudId}/linked-org`, {
        method: 'GET'
    });

});





parcelRegister("6yplV", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b);

var $gd0Sp = parcelRequire("gd0Sp");
const $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("57SqH", function(module, exports) {

$parcel$export(module.exports, "useSidebarData", () => $d2cfb77d49815540$export$f9257874e114985c);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $44GOl = parcelRequire("44GOl");

var $dQZ5c = parcelRequire("dQZ5c");

var $f26dB = parcelRequire("f26dB");

var $3xyNB = parcelRequire("3xyNB");
const $d2cfb77d49815540$export$f9257874e114985c = ()=>{
    const { project: currentProject } = (0, $44GOl.useNavigationProject)();
    const { data: data, update: update, refresh: refresh, loading: loading } = (0, $f26dB.useNavigationResource)();
    const { changeFavourite: changeFavourite, items: { projects: changedItems } } = (0, $dQZ5c.useChangeFavourite)();
    const isRefreshingFavorites = (0, $eUqFw.useRef)(false);
    const hasRefreshedOnce = (0, $eUqFw.useRef)(false);
    const onFavoriteToggle = (0, $eUqFw.useCallback)((project)=>{
        changeFavourite({
            id: String(project.id),
            type: 'projects',
            value: !project.isFavorite
        });
    }, [
        changeFavourite
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
            isRefreshingFavorites.current = true;
            refresh();
        }
    }, [
        changedItems,
        refresh
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isRefreshingFavorites.current = false;
    }, [
        data
    ]);
    let recents;
    let favorites;
    let hasMoreFavorite;
    let overviews;
    let overviewsError;
    let isPremiumUserSeat;
    let showPlansOnboarding;
    let shouldHideOverviews;
    if (data == null || data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        // if the resource was initially fetched for a not applicable project (i.e. not a business project)
        // on the initial page load, then we have not yet fetched the list of sidebar business projects
        // we thus refresh the resource in the background now that we are in a business project
        if (data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
            hasRefreshedOnce.current = true;
            refresh();
        }
        recents = [];
        favorites = [];
        hasMoreFavorite = false;
        overviews = [];
        overviewsError = null;
        isPremiumUserSeat = false;
        showPlansOnboarding = false;
        shouldHideOverviews = false;
    } else {
        recents = data.recents;
        favorites = data.favorites;
        hasMoreFavorite = data.hasMoreFavorite;
        overviews = data.overviews;
        overviewsError = data.overviewsError;
        isPremiumUserSeat = data.isPremiumUserSeat;
        showPlansOnboarding = data.showPlansOnboarding;
        shouldHideOverviews = data.shouldHideOverviews;
    }
    // if the current is not in either recents or favorites, push it to the top of recents
    if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
        recents = (0, $3xyNB.prependProject)(currentProject, recents);
        // make sure that the reference doesn't get overwritten for the resource update below
        const newRecents = recents;
        update(()=>({
                recents: newRecents,
                favorites: favorites,
                hasMoreFavorite: hasMoreFavorite,
                overviews: overviews,
                overviewsError: overviewsError,
                isPremiumUserSeat: isPremiumUserSeat,
                showPlansOnboarding: showPlansOnboarding,
                shouldHideOverviews: shouldHideOverviews
            }));
    }
    // if there are changes to favorites, update projects
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems)) {
        recents = recents.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
        favorites = favorites.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
    }
    return {
        currentProject: currentProject,
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: hasMoreFavorite,
        onFavoriteToggle: onFavoriteToggle,
        overviews: overviews,
        overviewsError: overviewsError,
        shouldHideOverviews: shouldHideOverviews,
        loading: loading && !isRefreshingFavorites.current
    };
};

});
parcelRegister("44GOl", function(module, exports) {

$parcel$export(module.exports, "useNavigationProject", () => $8449ba04d8e31c91$export$befd5d7ebc77f264);

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $aeIT6 = parcelRequire("aeIT6");
const $8449ba04d8e31c91$export$befd5d7ebc77f264 = ()=>{
    const { data: currentProject, loading: currentProjectLoading } = (0, $aeIT6.useProject)();
    const { data: navigationData, loading: navigationDataLoading } = (0, $f26dB.useNavigationResource)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    if (currentProject != null) return {
        project: currentProject,
        loading: currentProjectLoading
    };
    if (projectKey != null && navigationData != null && navigationData !== (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
        return {
            project: project,
            loading: navigationDataLoading
        };
    }
    return {
        project: null,
        loading: currentProjectLoading || navigationDataLoading
    };
};

});
const $02a4cc31089f6443$export$3349219a88ac77cd = 10;
const $02a4cc31089f6443$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';


parcelRegister("dQZ5c", function(module, exports) {

$parcel$export(module.exports, "FavouriteChangeContext", () => $5cd604b288cea09a$export$f4b82b57923ca30e);
$parcel$export(module.exports, "FavouriteChangeProvider", () => $5cd604b288cea09a$export$bda08f0693c12637);
$parcel$export(module.exports, "FavouriteChangeConsumer", () => $5cd604b288cea09a$export$2d027011594c72e1);
$parcel$export(module.exports, "useChangeFavourite", () => $5cd604b288cea09a$export$5619d506724e6a05);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");

var $4Tdfn = parcelRequire("4Tdfn");

var $jrdvV = parcelRequire("jrdvV");

var $eZWIs = parcelRequire("eZWIs");

var $duxfp = parcelRequire("duxfp");
const $5cd604b288cea09a$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $5cd604b288cea09a$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $5cd604b288cea09a$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavourite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))),
    updateFavouriteState: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $5cd604b288cea09a$export$f4b82b57923ca30e = /*#__PURE__*/ (0, $eUqFw.createContext)($5cd604b288cea09a$export$b212ddc707077772);
// supports project types only for now
const $5cd604b288cea09a$var$useRelayFavouriteUpdate = ()=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const commitUpdate = (0, $eUqFw.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $jrdvV.PROJECTS_ITEM_TYPE)) (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $4Tdfn.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favouriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favouriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $5cd604b288cea09a$export$bda08f0693c12637 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $5cd604b288cea09a$var$useRelayFavouriteUpdate();
    const [items, setItems] = (0, $eUqFw.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const changeFavourite = (0, $eUqFw.useCallback)((item, analyticsEvent)=>{
        const performChange = async ()=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $eZWIs.default)(item);
                setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                    ...item,
                    pending: false
                }));
                if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
                `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                    ...item,
                    value: !item.value,
                    pending: false
                }));
                if (onShowFlag) onShowFlag((0, $duxfp.errorFlag)());
            }
        };
        return performChange();
    }, [
        onShowFlag,
        commitUpdate
    ]);
    const updateFavouriteState = (0, $eUqFw.useCallback)((item)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const providerValue = (0, $eUqFw.useMemo)(()=>({
            items: items,
            changeFavourite: changeFavourite,
            updateFavouriteState: updateFavouriteState
        }), [
        items,
        changeFavourite,
        updateFavouriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$f4b82b57923ca30e.Provider, {
        value: providerValue
    }, children);
};
const $5cd604b288cea09a$export$2d027011594c72e1 = $5cd604b288cea09a$export$f4b82b57923ca30e.Consumer;
const $5cd604b288cea09a$export$51e54aab6602cac7 = (WrappedComponent)=>{
    const WithFavouriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$2d027011594c72e1, null, (favouriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favouriteChangeContext: FavouriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                favouriteChangeContext: favouriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavouriteChangeConsumer.displayName = `WithFavouriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavouriteChangeConsumer;
};
const $5cd604b288cea09a$export$5619d506724e6a05 = ()=>(0, $eUqFw.useContext)($5cd604b288cea09a$export$f4b82b57923ca30e);

});
parcelRegister("jrdvV", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $0f4349785a7b5234$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $0f4349785a7b5234$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $0f4349785a7b5234$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $0f4349785a7b5234$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $0f4349785a7b5234$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $0f4349785a7b5234$export$9c8cfad65800ddfb);
const $0f4349785a7b5234$export$aade82542e73ffc8 = 'boards';
const $0f4349785a7b5234$export$a448ebfa10cebc74 = 'filters';
const $0f4349785a7b5234$export$f8099f229527572c = 'dashboards';
const $0f4349785a7b5234$export$8e58083dcbb878d = 'issues';
const $0f4349785a7b5234$export$2fd44a6cb58b66cb = 'plans';
const $0f4349785a7b5234$export$8e2cd98172988d7e = 'projects';
const $0f4349785a7b5234$export$6b0c8e47d2c7f1d9 = 'queues';
const $0f4349785a7b5234$export$9c8cfad65800ddfb = [
    $0f4349785a7b5234$export$aade82542e73ffc8,
    $0f4349785a7b5234$export$f8099f229527572c,
    $0f4349785a7b5234$export$a448ebfa10cebc74,
    $0f4349785a7b5234$export$8e58083dcbb878d,
    $0f4349785a7b5234$export$2fd44a6cb58b66cb,
    $0f4349785a7b5234$export$8e2cd98172988d7e,
    $0f4349785a7b5234$export$6b0c8e47d2c7f1d9
];

});

parcelRegister("eZWIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba51d1acd2ac333$export$2e2bcd8739ae039);

var $bTuoX = parcelRequire("bTuoX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ba51d1acd2ac333$export$2e2bcd8739ae039 = async (request)=>(0, $bTuoX.updateFavourite)(request);

});
parcelRegister("bTuoX", function(module, exports) {

$parcel$export(module.exports, "updateFavourite", () => $7eaa8c7b4405eae0$export$c3c67dbb1f3a5ce5);

var $lRmyA = parcelRequire("lRmyA");
const $7eaa8c7b4405eae0$export$c3c67dbb1f3a5ce5 = async (request)=>{
    if (request.value) return (0, $lRmyA.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $lRmyA.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("duxfp", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $bec77f1a045d66e4$export$b9a7f1ebeaa76953);

var $jsurv = parcelRequire("jsurv");
const $bec77f1a045d66e4$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $jsurv.default)
    });

});
parcelRegister("jsurv", function(module, exports) {

$parcel$export(module.exports, "default", () => $973c51bdbf11215e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $973c51bdbf11215e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("3xyNB", function(module, exports) {

$parcel$export(module.exports, "prependProject", () => $1f9254ac774c5f12$export$9e33a1a4f95ad56f);
$parcel$export(module.exports, "mapProjectChanges", () => $1f9254ac774c5f12$export$6cb16ed8ac180dfc);

const $1f9254ac774c5f12$export$9e33a1a4f95ad56f = (project, projects)=>[
        project,
        ...projects
    ].slice(0, (0, $02a4cc31089f6443$export$3349219a88ac77cd));
const $1f9254ac774c5f12$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
        ...project,
        isFavorite: changedItems[project.id].value
    } : project;

});


parcelRegister("lym21", function(module, exports) {

$parcel$export(module.exports, "CallToActionType", () => $a66fc9a417117294$export$f6430504236946cc);
$parcel$export(module.exports, "getCallToActionType", () => $a66fc9a417117294$export$2e8902356a23bf22);

var $41WOo = parcelRequire("41WOo");

var $fUoOQ = parcelRequire("fUoOQ");
const $a66fc9a417117294$export$f6430504236946cc = {
    CREATE_PROJECT_BANNER: 'createProjectBanner',
    CREATE_PROJECT_BUTTON: 'createProjectButton',
    CREATE_PROJECT_NONE: 'createProjectNone',
    TRIAL_BANNER: 'trialBanner',
    NONE: 'none'
};
const $a66fc9a417117294$export$2e8902356a23bf22 = (isSampleProject)=>{
    const isProjectStateLoaded = typeof isSampleProject === 'boolean';
    if (isProjectStateLoaded) {
        let createProjectCtaType = 'none';
        if (isSampleProject) {
            // check the cohort, but don't fire the exposure event
            createProjectCtaType = (0, $41WOo.getJwmHelpSampleUsersCreateProjectsCtaType)();
            if (createProjectCtaType === 'button') return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_BUTTON;
            if (createProjectCtaType === 'banner') return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_BANNER;
            return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_NONE;
        }
        if ((0, $41WOo.isJwmMonetizationExperimentEnabled)()) return $a66fc9a417117294$export$f6430504236946cc.TRIAL_BANNER;
    }
    /*
    we should end up here in the following cases:
    - we don't know whether we're in a sample project
    - we're not in a sample project and the monetization experiment is not enabled
    */ return $a66fc9a417117294$export$f6430504236946cc.NONE;
};

});
parcelRegister("fUoOQ", function(module, exports) {

$parcel$export(module.exports, "CreateProjectCta", () => $4c9b0d5298cf5830$export$f49a4235d24dbad0);

var $eUqFw = parcelRequire("eUqFw");

var $j1JdL = parcelRequire("j1JdL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");
const $4c9b0d5298cf5830$var$runtimeProps = {};
const $4c9b0d5298cf5830$var$entryPointParams = {};
const $4c9b0d5298cf5830$export$f49a4235d24dbad0 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $j1JdL.createProjectCtaEntryPoint), $4c9b0d5298cf5830$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-business-create-project-cta-entrypoint",
        packageName: "@atlassian/jira-business-create-project-cta",
        teamName: "A4T-Werewolves",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $4c9b0d5298cf5830$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("j1JdL", function(module, exports) {

$parcel$export(module.exports, "createProjectCtaEntryPoint", () => $20f4d66eaf9284b5$export$7dadecc7d161da03);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $20f4d66eaf9284b5$export$7dadecc7d161da03 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lwXpd")), {
        moduleId: "0c73c6d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lwXpd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gcXnX')
        ]);
        const value = parcelRequire('1kWB8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gcXnX")
    ]).then(()=>parcelRequire('1kWB8'));
}

});




parcelRegister("gTasH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c51ef7ea6f1c863$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $eFKPp = parcelRequire("eFKPp");

var $5xIu6 = parcelRequire("5xIu6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1pW4J = parcelRequire("1pW4J");

var $hWTey = parcelRequire("hWTey");

var $3PsZt = parcelRequire("3PsZt");
const $8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
const $8c51ef7ea6f1c863$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const renderNudgeWrapper = (0, $eUqFw.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hWTey.FeedbackNudgeAsync), null, children), []);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal($8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), buttonRef);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pW4J.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eFKPp))), {
            label: "",
            size: "small"
        }),
        appearance: "subtle-link",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c51ef7ea6f1c863$var$Content, null, formatMessage((0, $3PsZt.default).feedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8c51ef7ea6f1c863$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf",
            __cmplp.className
        ])
    });
});
var $8c51ef7ea6f1c863$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8c51ef7ea6f1c863$var$FeedbackButton);

});
parcelRegister("eFKPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae9381df7a9f99a$var$_react = $aae9381df7a9f99a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aae9381df7a9f99a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aae9381df7a9f99a$var$EditorFeedbackIcon = (props)=>/*#__PURE__*/ $aae9381df7a9f99a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.922 14.517L5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654l-3.14-1.142zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009v-3.782zm11.224-4.78a.5.5 0 11-.448-.894l2-1a.5.5 0 11.448.894l-2 1zm-.448 4a.5.5 0 01.448-.894l2 1a.5.5 0 01-.448.894l-2-1zM17 11.5a.5.5 0 110-1h3a.5.5 0 110 1h-3z" fill="currentColor"/></svg>`
    }, props));
$aae9381df7a9f99a$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
var $aae9381df7a9f99a$var$_default = $aae9381df7a9f99a$var$EditorFeedbackIcon;
module.exports.default = $aae9381df7a9f99a$var$_default;

});

parcelRegister("5xIu6", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $41c842a9ff9149b0$export$4be696be8a3bff13);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");
var $gd0Sp = parcelRequire("gd0Sp");

var $6YoSc = parcelRequire("6YoSc");

var $loHEm = parcelRequire("loHEm");
const $41c842a9ff9149b0$export$698ff856156a88fe = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $6YoSc.default).canContactPromptLink)));
});
const $41c842a9ff9149b0$export$4f77effad9540593 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $6YoSc.default).enrollInResearchLink))
    }));
});
const $41c842a9ff9149b0$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const getFeedbackContext = (0, $eUqFw.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $1c02D.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $1c02D.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $loHEm.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $eUqFw.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("bNe1g", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $a10c8c1f49371370$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $a10c8c1f49371370$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $a10c8c1f49371370$export$a85f6b5857d2176);

var $eUqFw = parcelRequire("eUqFw");

var $OUdnA = parcelRequire("OUdnA");

var $iZJHG = parcelRequire("iZJHG");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $a10c8c1f49371370$var$useProjectContextNew = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $ixwgj.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$var$useProjectContextOld = (_)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResourceWithCache));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$export$8f31c2503e1efa93 = (0, $OUdnA.functionWithFF)('passing-projectid-to-useisgettingstartedpageenabled', $a10c8c1f49371370$var$useProjectContextNew, $a10c8c1f49371370$var$useProjectContextOld);
const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("OUdnA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $4f946782842d29a3$export$3b8cbae22108d228);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");
const $4f946782842d29a3$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), functionTrue, functionFalse);

});


parcelRegister("6YoSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bddfc6628ca4ec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7bddfc6628ca4ec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("loHEm", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $7f7875a39a6a39a8$export$f57a7f1d32485807);
const $7f7875a39a6a39a8$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("1pW4J", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $8dd307db4ae4d7c5$export$bd61ee610c74db6c);

var $eUqFw = parcelRequire("eUqFw");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $8dd307db4ae4d7c5$export$bd61ee610c74db6c = (0, $16WDb.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});

});
parcelRegister("ekN4Q", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $b942586713a4c8ae$export$7212b6b01271f5d1);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $b942586713a4c8ae$var$TIMEOUT = 500;
const $b942586713a4c8ae$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eUqFw.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $b942586713a4c8ae$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("kpmC0", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $57fa1b4d662f99dc$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $57fa1b4d662f99dc$export$900f29014a48fb23);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $1GeZ8 = parcelRequire("1GeZ8");

var $53ucm = parcelRequire("53ucm");
const $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $57fa1b4d662f99dc$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $57fa1b4d662f99dc$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $1GeZ8.usePageLayoutResize)();
    return (0, $eUqFw.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("1GeZ8", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $e83852d7c3641ad5$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $e83852d7c3641ad5$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $e83852d7c3641ad5$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $e83852d7c3641ad5$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $e83852d7c3641ad5$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $e83852d7c3641ad5$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $e83852d7c3641ad5$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $e83852d7c3641ad5$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $e83852d7c3641ad5$export$84d58c19c21f637f);
$parcel$export(module.exports, "useCustomSkipLink", () => $e83852d7c3641ad5$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $e83852d7c3641ad5$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $e83852d7c3641ad5$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $e83852d7c3641ad5$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $e83852d7c3641ad5$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $e83852d7c3641ad5$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $e83852d7c3641ad5$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $e83852d7c3641ad5$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $e83852d7c3641ad5$export$d697087c06fd5e25);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $ahaFU = parcelRequire("ahaFU");
var $ho1Ek = parcelRequire("ho1Ek");
var $780tS = parcelRequire("780tS");
var $1EvZ6 = parcelRequire("1EvZ6");
var $66hOn = parcelRequire("66hOn");
var $2Lkx0 = parcelRequire("2Lkx0");
var $hNH8O = parcelRequire("hNH8O");
var $4NoTP = parcelRequire("4NoTP");
var $epaF7 = parcelRequire("epaF7");
var $mtJGd = parcelRequire("mtJGd");
var $jnGaC = parcelRequire("jnGaC");
var $ikQZw = parcelRequire("ikQZw");
var $GP1qj = parcelRequire("GP1qj");

var $XHGTv = parcelRequire("XHGTv");

var $b5l09 = parcelRequire("b5l09");

var $6JlSS = parcelRequire("6JlSS");

var $3jdLC = parcelRequire("3jdLC");

var $19w0L = parcelRequire("19w0L");
function $e83852d7c3641ad5$export$6d1402fb58384e4f(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4NoTP.default), props);
}
function $e83852d7c3641ad5$export$3b4e64e77073e307(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Banner), {
        UNSAFE_height: props.height
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ahaFU.default), props);
}
function $e83852d7c3641ad5$export$8a421bddecb2bf5b(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.TopBar), {
        UNSAFE_height: props.height
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnGaC.default), props);
}
function $e83852d7c3641ad5$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EvZ6.default), props);
}
function $e83852d7c3641ad5$export$43ae342508cf8cc9(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.SideNav), {
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Lkx0.default), props);
}
function $e83852d7c3641ad5$export$3cabf771c4f2de(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66hOn.default), props);
}
function $e83852d7c3641ad5$export$861edd1ccea2f746(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Main), {
        isFixed: props.isFixed
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNH8O.default), props);
}
function $e83852d7c3641ad5$export$7c6e2c02157bb7d2(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $780tS.default), props);
}
function $e83852d7c3641ad5$export$84d58c19c21f637f(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mtJGd.default), props);
}
function $e83852d7c3641ad5$export$364a989a35814102(props) {
    return (0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Panel), {
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epaF7.default), props);
}
const $e83852d7c3641ad5$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? {} : (0, $GP1qj.useCustomSkipLink)(id, title, index);
const $e83852d7c3641ad5$export$94561f6055639ef7 = ()=>(0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? {} : (0, $ikQZw.useLeftSidebarFlyoutLock)();
const $e83852d7c3641ad5$export$f37b9b9b883352cf = ()=>(0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? (0, $5Q9wj.default) : (0, $ikQZw.UNSAFE_useSetLeftSidebarState)();
// A mock value is needed to match the signature of the hook
const $e83852d7c3641ad5$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5Q9wj.default),
    collapseLeftSidebar: (0, $5Q9wj.default),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    },
    setLeftSidebarState: (0, $5Q9wj.default),
    toggleLeftSidebar: (0, $5Q9wj.default)
};
const $e83852d7c3641ad5$export$10c7104037a7af62 = ()=>(0, $XHGTv.fg)('platform.atlassian.griffin-new-page-layout') ? $e83852d7c3641ad5$var$mockPageLayoutResize : (0, $ikQZw.usePageLayoutResize)();
const $e83852d7c3641ad5$export$991ef8098f87814a = (0, $ho1Ek.BANNER_HEIGHT);
const $e83852d7c3641ad5$export$7eaf986ecb4d5cac = (0, $ho1Ek.LEFT_PANEL_WIDTH);
const $e83852d7c3641ad5$export$e95b388ca8c92019 = (0, $ho1Ek.LEFT_SIDEBAR_WIDTH);
const $e83852d7c3641ad5$export$2ab8b83eed76656c = (0, $ho1Ek.RIGHT_PANEL_WIDTH);
const $e83852d7c3641ad5$export$ac017575d43f5da = (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH);
const $e83852d7c3641ad5$export$d697087c06fd5e25 = (0, $ho1Ek.TOP_NAVIGATION_HEIGHT);

});
parcelRegister("ahaFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e67e66af393013$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $e6e67e66af393013$var$bannerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.BANNER)
});
const $e6e67e66af393013$var$bannerFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e6e67e66af393013$var$Banner = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $e6e67e66af393013$var$bannerStyles,
                isFixed && $e6e67e66af393013$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $e6e67e66af393013$export$2e2bcd8739ae039 = $e6e67e66af393013$var$Banner;

});
parcelRegister("a353s", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $0a6a711fa684a053$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $0a6a711fa684a053$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $0a6a711fa684a053$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $0a6a711fa684a053$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $0a6a711fa684a053$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $0a6a711fa684a053$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $0a6a711fa684a053$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $0a6a711fa684a053$export$218ece2c32b7db0e);

var $ho1Ek = parcelRequire("ho1Ek");

var $5o7nc = parcelRequire("5o7nc");
const $0a6a711fa684a053$export$576dabd404a1ed99 = (0, $ho1Ek.DIMENSIONS).reduce((acc, currentValue)=>({
        ...acc,
        [currentValue]: 0
    }), {});
const $0a6a711fa684a053$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $0a6a711fa684a053$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $0a6a711fa684a053$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $0a6a711fa684a053$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $0a6a711fa684a053$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $0a6a711fa684a053$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $0a6a711fa684a053$export$218ece2c32b7db0e = (slotName)=>`[${0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("5o7nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d809f573a3653667$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $d809f573a3653667$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $d809f573a3653667$var$safeLocalStorage = ()=>{
    if ($d809f573a3653667$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $d809f573a3653667$export$2e2bcd8739ae039 = $d809f573a3653667$var$safeLocalStorage;

});


parcelRegister("cXUwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $06373a48b343ca71$export$2e2bcd8739ae039);

var $a353s = parcelRequire("a353s");
const $06373a48b343ca71$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $a353s.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $a353s.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $06373a48b343ca71$export$2e2bcd8739ae039 = $06373a48b343ca71$var$publishGridState;

});

parcelRegister("6cmgz", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $73ff71be83e0ab1c$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $73ff71be83e0ab1c$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $73ff71be83e0ab1c$export$89d9323301efc7d6);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $73ff71be83e0ab1c$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $5Q9wj.default),
    unregisterSkipLink: (0, $5Q9wj.default)
});
const $73ff71be83e0ab1c$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($73ff71be83e0ab1c$export$4c5cc3b14c7678a);
const $73ff71be83e0ab1c$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $73ff71be83e0ab1c$export$c9d9cb2ee9590f87();
    (0, $eUqFw.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("gl6Cr", function(module, exports) {

$parcel$export(module.exports, "default", () => $769062fa7cdcfd96$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $769062fa7cdcfd96$var$focusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $769062fa7cdcfd96$var$sidebarFocusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $769062fa7cdcfd96$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($769062fa7cdcfd96$var$sidebarFocusStyles) : css($769062fa7cdcfd96$var$focusStyles)
        }));
};
var $769062fa7cdcfd96$export$2e2bcd8739ae039 = $769062fa7cdcfd96$var$SlotFocusRing;

});

parcelRegister("8cbHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df357f02f294910$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Ywu9 = parcelRequire("4Ywu9");
var $5df357f02f294910$export$2e2bcd8739ae039 = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $4Ywu9.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
};

});


parcelRegister("780tS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1254209de2b99d0a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");
const $1254209de2b99d0a$var$contentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $1254209de2b99d0a$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $1254209de2b99d0a$var$contentStyles
    }, children);
};
var $1254209de2b99d0a$export$2e2bcd8739ae039 = $1254209de2b99d0a$var$Content;

});

parcelRegister("1EvZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee1fe777273abc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $cee1fe777273abc5$var$leftPanelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.LEFT_PANEL)
});
const $cee1fe777273abc5$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $cee1fe777273abc5$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $cee1fe777273abc5$var$leftPanelStyles,
                isFixed && $cee1fe777273abc5$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_LEFT_PANEL_WIDTH),
            value: leftPanelWidth
        }), children));
};
var $cee1fe777273abc5$export$2e2bcd8739ae039 = $cee1fe777273abc5$var$LeftPanel;

});

parcelRegister("66hOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba986c6a8de8190f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kVO3J = parcelRequire("kVO3J");


var $eT0WN = parcelRequire("eT0WN");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $3QLIJ = parcelRequire("3QLIJ");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $bxILY = parcelRequire("bxILY");

var $8cbHW = parcelRequire("8cbHW");
const $ba986c6a8de8190f$var$openBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $PdmhA.N100A)})`,
    opacity: 1
});
const $ba986c6a8de8190f$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ba986c6a8de8190f$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $eUqFw.useRef)();
    const mouseOverEventRef = (0, $eUqFw.useRef)();
    const leftSideBarRef = (0, $eUqFw.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $eUqFw.useRef)(isLocked);
    const mouseXRef = (0, $eUqFw.useRef)(0);
    const handlerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $eUqFw.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $a353s.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $a353s.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $kVO3J.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $ba986c6a8de8190f$var$hiddenBackdropStyles,
            isFlyoutOpen && $ba986c6a8de8190f$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bxILY.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $3QLIJ.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $ba986c6a8de8190f$export$2e2bcd8739ae039 = $ba986c6a8de8190f$var$LeftSidebar;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("ikQZw", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $9a41c619a58ecd93$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $9a41c619a58ecd93$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $9a41c619a58ecd93$export$94561f6055639ef7);
$parcel$export(module.exports, "UNSAFE_useSetLeftSidebarState", () => $9a41c619a58ecd93$export$f37b9b9b883352cf);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");
const $9a41c619a58ecd93$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true
};
const $9a41c619a58ecd93$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5Q9wj.default),
    collapseLeftSidebar: (0, $5Q9wj.default),
    leftSidebarState: $9a41c619a58ecd93$var$leftSidebarState,
    setLeftSidebarState: (0, $5Q9wj.default),
    toggleLeftSidebar: (0, $5Q9wj.default)
});
const $9a41c619a58ecd93$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    return context;
};
const $9a41c619a58ecd93$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    (0, $eUqFw.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
const $9a41c619a58ecd93$export$f37b9b9b883352cf = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-navigation-redesign') ? setLeftSidebarState : (0, $5Q9wj.default);
};

});

parcelRegister("3QLIJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf1435c6e64160e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $e1gck = parcelRequire("e1gck");

var $i4a2R = parcelRequire("i4a2R");

var $4xMfW = parcelRequire("4xMfW");
function $2cf1435c6e64160e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2cf1435c6e64160e$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_CONTROL_SELECTOR)]: true
};
const $2cf1435c6e64160e$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $2cf1435c6e64160e$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $2cf1435c6e64160e$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $2cf1435c6e64160e$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $eUqFw.useRef)(leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $eUqFw.useRef)(0);
    const keyboardEventTimeout = (0, $eUqFw.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $eUqFw.useState)(false);
    const unbindEvents = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $eUqFw.useRef)(leftSidebarState);
    (0, $eUqFw.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $eUqFw.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH] - (0, $a353s.getLeftPanelWidth)();
        unbindEvents.current = (0, $74BVL.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $eUqFw.useState)(()=>(0, $8yx6O.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $a353s.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $eUqFw.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $a353s.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$2cf1435c6e64160e$var$cssSelector,
        css: [
            $2cf1435c6e64160e$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $2cf1435c6e64160e$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4xMfW.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $byn9U.jsx)((0, $e1gck.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $i4a2R.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
        styles: $2cf1435c6e64160e$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2cf1435c6e64160e$export$2e2bcd8739ae039 = $2cf1435c6e64160e$var$ResizeControl;

});
parcelRegister("e1gck", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a25b5d5d6a7f6f0$export$2e2bcd8739ae039);
/* eslint-disable react/react-in-jsx-scope */ /**
                                               * @jsxRuntime classic
                                               */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");
function $8a25b5d5d6a7f6f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $8a25b5d5d6a7f6f0$var$varLineColor = '--ds-line';
const $8a25b5d5d6a7f6f0$var$grabAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$8a25b5d5d6a7f6f0$var$varLineColor]: `var(--ds-border-selected, ${(0, $PdmhA.B200)})`
    }
});
const $8a25b5d5d6a7f6f0$var$grabAreaReducedHeightStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    position: 'absolute',
    insetBlockEnd: 0
});
const $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles = {
    name: "19x2bwh",
    styles: "padding:0;background-color:transparent;border:0;cursor:default"
};
const $8a25b5d5d6a7f6f0$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $8a25b5d5d6a7f6f0$var$grabAreaLineSelector = {
    [(0, $ho1Ek.GRAB_AREA_LINE_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$grabAreaSelector = {
    [(0, $ho1Ek.GRAB_AREA_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$8a25b5d5d6a7f6f0$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $8a25b5d5d6a7f6f0$var$grabAreaStyles,
            isLeftSidebarCollapsed && $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.page-layout-resize-button-fix_u0qxv') && isLeftSidebarCollapsed && $8a25b5d5d6a7f6f0$var$grabAreaReducedHeightStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8a25b5d5d6a7f6f0$var$lineStyles,
        ...$8a25b5d5d6a7f6f0$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a25b5d5d6a7f6f0$export$2e2bcd8739ae039 = $8a25b5d5d6a7f6f0$var$GrabArea;

});

parcelRegister("i4a2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dae62e53e3b7495$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $dtaN9 = parcelRequire("dtaN9");


var $5LHuc = parcelRequire("5LHuc");

var $XHGTv = parcelRequire("XHGTv");

var $4Ywu9 = parcelRequire("4Ywu9");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");
function $2dae62e53e3b7495$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2dae62e53e3b7495$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-100, -8px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-100, -8px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $2dae62e53e3b7495$var$furtherIncreasedHitAreasStyles = /*#__PURE__*/ (0, $byn9U.css)({
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`
});
const $2dae62e53e3b7495$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- TODO: https://product-fabric.atlassian.net/browse/DSP-3392; this boxShadow needs further investigation, along with the hover and active background colors.
    boxShadow: `0 0 0 1px ${(0, $PdmhA.N30A)}, 0 2px 4px 1px ${(0, $PdmhA.N30A)}`,
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $5LHuc.smallDurationMs)}ms linear,
    color ${(0, $5LHuc.smallDurationMs)}ms linear,
    opacity ${(0, $5LHuc.mediumDurationMs)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $PdmhA.B100)})`,
        color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B200)})`,
        color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $2dae62e53e3b7495$var$preventDefault = (event)=>event.preventDefault();
const $2dae62e53e3b7495$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)]: true
};
const $2dae62e53e3b7495$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$2dae62e53e3b7495$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $2dae62e53e3b7495$var$resizeIconButtonStyles,
            $2dae62e53e3b7495$var$mobileStyles,
            !isLeftSidebarCollapsed && $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $2dae62e53e3b7495$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    }), (0, $XHGTv.getBooleanFF)('platform.design-system-team.page-layout-resize-button-fix_u0qxv') ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $2dae62e53e3b7495$var$increaseHitAreaStyles,
            $2dae62e53e3b7495$var$furtherIncreasedHitAreasStyles
        ]
    }) : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2dae62e53e3b7495$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2dae62e53e3b7495$export$2e2bcd8739ae039 = $2dae62e53e3b7495$var$ResizeButton;

});

parcelRegister("4xMfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6598dc29fb8ee8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $1RrwL = parcelRequire("1RrwL");
const $6f6598dc29fb8ee8$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $6f6598dc29fb8ee8$var$direction = 'to left';
const $6f6598dc29fb8ee8$var$transitionDuration = '0.22s';
const $6f6598dc29fb8ee8$var$shadowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $6f6598dc29fb8ee8$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
});
const $6f6598dc29fb8ee8$var$draggingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $6f6598dc29fb8ee8$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6f6598dc29fb8ee8$var$shadowStyles,
            isDragging && $6f6598dc29fb8ee8$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f6598dc29fb8ee8$export$2e2bcd8739ae039 = $6f6598dc29fb8ee8$var$Shadow;

});
parcelRegister("1RrwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34927c3d83b90ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f34927c3d83b90ce$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $f34927c3d83b90ce$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)($f34927c3d83b90ce$var$getIsDragging);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($f34927c3d83b90ce$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $f34927c3d83b90ce$export$2e2bcd8739ae039 = $f34927c3d83b90ce$var$useIsSidebarDragging;

});



parcelRegister("cJoHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edc19a03a491edc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");
function $4edc19a03a491edc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $4edc19a03a491edc$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $4edc19a03a491edc$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
const $4edc19a03a491edc$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $4edc19a03a491edc$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $4edc19a03a491edc$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $4edc19a03a491edc$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $4edc19a03a491edc$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $4edc19a03a491edc$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // mobile viewport styles
            $4edc19a03a491edc$var$mobileStyles,
            isFlyoutOpen && $4edc19a03a491edc$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $4edc19a03a491edc$var$staticInnerStyles,
            isFixed && $4edc19a03a491edc$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $4edc19a03a491edc$var$fixedInnerFlyoutStyles,
            isDragging && $4edc19a03a491edc$var$draggingStyles,
            $4edc19a03a491edc$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4edc19a03a491edc$export$2e2bcd8739ae039 = $4edc19a03a491edc$var$LeftSidebarInner;

});

parcelRegister("c9QmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a594c1cfdafacace$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $gl6Cr = parcelRequire("gl6Cr");
function $a594c1cfdafacace$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a594c1cfdafacace$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $a594c1cfdafacace$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $a594c1cfdafacace$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $a594c1cfdafacace$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $a594c1cfdafacace$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a594c1cfdafacace$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $a594c1cfdafacace$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $a594c1cfdafacace$var$flyoutFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $a594c1cfdafacace$var$selector = (0, $a353s.getPageLayoutSlotSelector)('left-sidebar');
const $a594c1cfdafacace$var$LeftSidebarOuter = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                // mobile viewport styles
                $a594c1cfdafacace$var$mobileStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$mobileFlyoutStyles,
                // generic styles
                $a594c1cfdafacace$var$outerStyles,
                isFixed && $a594c1cfdafacace$var$fixedStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$flyoutStyles,
                isFlyoutOpen && isFixed && $a594c1cfdafacace$var$flyoutFixedStyles,
                isDragging && $a594c1cfdafacace$var$draggingStyles,
                $a594c1cfdafacace$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$a594c1cfdafacace$var$selector
        }, children));
};
var $a594c1cfdafacace$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($a594c1cfdafacace$var$LeftSidebarOuter);

});

parcelRegister("bxILY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1473b5175591b507$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $ho1Ek = parcelRequire("ho1Ek");

var $eeFjl = parcelRequire("eeFjl");
function $1473b5175591b507$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1473b5175591b507$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $1473b5175591b507$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    transition: `opacity 0ms linear, visibility 0ms linear`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $ho1Ek.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $1473b5175591b507$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $1473b5175591b507$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $1473b5175591b507$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $eeFjl.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $1473b5175591b507$var$resizableChildrenWrapperStyles,
            isHidden && $1473b5175591b507$var$hideLeftSidebarContentsStyles,
            $1473b5175591b507$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1473b5175591b507$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1473b5175591b507$export$2e2bcd8739ae039 = $1473b5175591b507$var$ResizableChildrenWrapper;

});
parcelRegister("eeFjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c649bebf5f6629$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f4c649bebf5f6629$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $f4c649bebf5f6629$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $eUqFw.useState)($f4c649bebf5f6629$var$getIsCollapsing);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($f4c649bebf5f6629$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $f4c649bebf5f6629$export$2e2bcd8739ae039 = $f4c649bebf5f6629$var$useIsSidebarCollapsing;

});



parcelRegister("2Lkx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeb7ceda1832e15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $8cbHW = parcelRequire("8cbHW");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ddeb7ceda1832e15$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed
    }, children));
};
var $ddeb7ceda1832e15$export$2e2bcd8739ae039 = $ddeb7ceda1832e15$var$LeftSidebarWithoutResize;

});

parcelRegister("hNH8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaee6b83a63d3216$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");


var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");
function $eaee6b83a63d3216$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $eaee6b83a63d3216$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $eaee6b83a63d3216$var$mainStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $eaee6b83a63d3216$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $eaee6b83a63d3216$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $eaee6b83a63d3216$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("main", {
            "data-testid": testId,
            css: [
                $eaee6b83a63d3216$var$mainStyles,
                isDragging && $eaee6b83a63d3216$var$draggingStyles,
                isFlyoutOpen && !isFixed && $eaee6b83a63d3216$var$flyoutStyles,
                $eaee6b83a63d3216$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('main')
        }, children));
};
var $eaee6b83a63d3216$export$2e2bcd8739ae039 = $eaee6b83a63d3216$var$Main;

});

parcelRegister("4NoTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecc4fbcc1004c95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $lDBEs = parcelRequire("lDBEs");
var $5cR7w = parcelRequire("5cR7w");

var $dFFYu = parcelRequire("dFFYu");
const $5ecc4fbcc1004c95$var$pageLayoutSelector = {
    [(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $5ecc4fbcc1004c95$var$gridTemplateAreasMobile = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)}"
 `;
const $5ecc4fbcc1004c95$var$gridTemplateAreas = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)} ${(0, $ho1Ek.RIGHT_PANEL)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)} ${(0, $ho1Ek.RIGHT_PANEL)}"
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)} ${(0, $ho1Ek.RIGHT_PANEL)}"
 `;
const $5ecc4fbcc1004c95$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $ho1Ek.BANNER_HEIGHT)} ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $5ecc4fbcc1004c95$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5ecc4fbcc1004c95$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5cR7w.SkipLinksController), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFFYu.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$5ecc4fbcc1004c95$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $5ecc4fbcc1004c95$var$gridStyles,
            $5ecc4fbcc1004c95$var$gridStylesMobileStyles
        ],
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lDBEs.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $5ecc4fbcc1004c95$export$2e2bcd8739ae039 = $5ecc4fbcc1004c95$var$PageLayout;

});
parcelRegister("lDBEs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $d470ef5b352c70d4$export$850bd1bba41f1448);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $8YJjX = parcelRequire("8YJjX");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
const $d470ef5b352c70d4$var$handleDataAttributesAndCb = (callback = (0, $5Q9wj.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $d470ef5b352c70d4$var$leftSidebarSelector = (0, $a353s.getPageLayoutSlotCSSSelector)('left-sidebar');
const $d470ef5b352c70d4$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $eUqFw.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $eUqFw.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $eUqFw.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth
    ]);
    const collapseLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ikQZw.SidebarResizeContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("5cR7w", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $4539942660e627fc$export$da7be99d6a868f3d);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
const $4539942660e627fc$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $4539942660e627fc$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $eUqFw.useState)([]);
    const registerSkipLink = (0, $eUqFw.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($4539942660e627fc$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $eUqFw.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cmgz.SkipLinksContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("dFFYu", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $7927022d7be1354d$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5OdZ3 = parcelRequire("5OdZ3");

var $8YJjX = parcelRequire("8YJjX");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
function $7927022d7be1354d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7927022d7be1354d$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $7927022d7be1354d$var$skipLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N30A)}, 0 2px 10px ${(0, $PdmhA.N30A)}, 0 0 20px -4px ${(0, $PdmhA.N60A)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $7927022d7be1354d$var$skipLinkHeadingStyles = {
    name: "16ceglb",
    styles: "font-weight:600"
};
const $7927022d7be1354d$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $7927022d7be1354d$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $7927022d7be1354d$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $7927022d7be1354d$var$assignIndex(num + 1, arr);
};
const $7927022d7be1354d$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $6cmgz.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $7927022d7be1354d$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $7927022d7be1354d$var$skipLinkStyles,
            $7927022d7be1354d$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $byn9U.jsx)("p", {
        css: $7927022d7be1354d$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        css: $7927022d7be1354d$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $byn9U.jsx)($7927022d7be1354d$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};
const $7927022d7be1354d$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $7927022d7be1354d$var$handleBlur);
};
const $7927022d7be1354d$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $7927022d7be1354d$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $7927022d7be1354d$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $7927022d7be1354d$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5OdZ3.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $7927022d7be1354d$var$focusTargetRef(href)
    }, children));
};

});
parcelRegister("5OdZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a459d0ad400a9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");
function $b9a459d0ad400a9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b9a459d0ad400a9b$var$commonLinkStyles = (0, $1ZAYh.xcss)({
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:hover': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $b9a459d0ad400a9b$var$defaultAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'underline',
    color: 'color.link',
    ':hover': {
        color: 'color.link',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $b9a459d0ad400a9b$var$subtleAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtle',
    ':hover': {
        color: 'color.text.subtle',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});
// Prevent the icon from wrapping onto a new line by itself
// Using this technique involving a zero-width space: https://snook.ca/archives/html_and_css/icon-wrap-after-text
const $b9a459d0ad400a9b$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    whiteSpace: 'nowrap'
});
const $b9a459d0ad400a9b$var$iconStyles = {
    name: "11149m5",
    styles: "width:1em;height:1em;margin-inline-start:.3em"
};
const $b9a459d0ad400a9b$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4kMup.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            $b9a459d0ad400a9b$var$commonLinkStyles,
            appearance === 'default' && $b9a459d0ad400a9b$var$defaultAppearanceStyles,
            appearance === 'subtle' && $b9a459d0ad400a9b$var$subtleAppearanceStyles
        ],
        testId: testId,
        componentName: "Link"
    }, children, target === '_blank' && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        as: "span",
        xcss: $b9a459d0ad400a9b$var$iconWrapperStyles,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        css: $b9a459d0ad400a9b$var$iconStyles,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $b9a459d0ad400a9b$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)($b9a459d0ad400a9b$var$LinkWithoutRef);
var $b9a459d0ad400a9b$export$2e2bcd8739ae039 = $b9a459d0ad400a9b$var$Link;

});



parcelRegister("epaF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7898ff788c8bd5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $ed7898ff788c8bd5$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.RIGHT_PANEL)
});
const $ed7898ff788c8bd5$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ed7898ff788c8bd5$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $ed7898ff788c8bd5$var$baseStyles,
                isFixed && $ed7898ff788c8bd5$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH),
            value: rightPanelWidth
        }), children));
};
var $ed7898ff788c8bd5$export$2e2bcd8739ae039 = $ed7898ff788c8bd5$var$RightPanel;

});

parcelRegister("mtJGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bb915aea8f70d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
function $01bb915aea8f70d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $01bb915aea8f70d5$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $ho1Ek.RIGHT_PANEL_WIDTH)})`
});
const $01bb915aea8f70d5$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $01bb915aea8f70d5$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $01bb915aea8f70d5$var$fixedOuterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $01bb915aea8f70d5$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $ho1Ek.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": testId,
            css: [
                $01bb915aea8f70d5$var$outerStyles,
                isFixed && $01bb915aea8f70d5$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                isFixed && $01bb915aea8f70d5$var$fixedInnerStyles,
                !isFixed && $01bb915aea8f70d5$var$staticInnerStyles
            ]
        }, children)));
};
var $01bb915aea8f70d5$export$2e2bcd8739ae039 = $01bb915aea8f70d5$var$RightSidebar;

});

parcelRegister("jnGaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0177ccf962ce75b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $0177ccf962ce75b6$var$topNavigationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.TOP_NAVIGATION)
});
const $0177ccf962ce75b6$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0177ccf962ce75b6$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $0177ccf962ce75b6$var$topNavigationStyles,
                isFixed && $0177ccf962ce75b6$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $0177ccf962ce75b6$export$2e2bcd8739ae039 = $0177ccf962ce75b6$var$TopNavigation;

});

parcelRegister("GP1qj", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $40616bd8cab79850$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $6cmgz = parcelRequire("6cmgz");
const $40616bd8cab79850$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $6cmgz.useSkipLinks)();
    (0, $eUqFw.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("b5l09", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $2a40d5d061eb57b6$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $2a40d5d061eb57b6$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "SideNavButton", () => $2a40d5d061eb57b6$export$4188957cd63b68ba);
$parcel$export(module.exports, "Banner", () => $2a40d5d061eb57b6$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopBar", () => $2a40d5d061eb57b6$export$c4e96258f3b6511);
$parcel$export(module.exports, "Panel", () => $2a40d5d061eb57b6$export$2ddb90ad54e5f587);
$parcel$export(module.exports, "Main", () => $2a40d5d061eb57b6$export$861edd1ccea2f746);
$parcel$export(module.exports, "SideNav", () => $2a40d5d061eb57b6$export$1a35787d6353cf6a);
$parcel$export(module.exports, "Aside", () => $2a40d5d061eb57b6$export$ac3bdfe4cb17f64e);
/* layout.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $j9fWg = parcelRequire("j9fWg");

var $b8123 = parcelRequire("b8123");

var $4Ywu9 = parcelRequire("4Ywu9");

var $59HcT = parcelRequire("59HcT");

var $lWATQ = parcelRequire("lWATQ");
// These are "compressed" to discourage usage.
const $2a40d5d061eb57b6$var$sideNavVar = '--n_sNvw';
const $2a40d5d061eb57b6$var$asideVar = '--n_asDw';
const $2a40d5d061eb57b6$var$panelVar = '--n_pnlW';
const $2a40d5d061eb57b6$var$bannerMountedVar = '--n_bnrM';
const $2a40d5d061eb57b6$var$topBarMountedVar = '--n_tbrM';
// We aren't using template literals here because Compiled can't compiled them in platform ATM.
const $2a40d5d061eb57b6$var$contentHeightWhenFixed = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $2a40d5d061eb57b6$var$contentInsetBlockStart = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
// We define variables as they can change their size depending on the viewport width. That isn't needed for
// general grid item slots because, well, they just take up the size of the grid item! In this instance since
// the UNSAFE absolutely positioned sibling isn't on the grid it needs extra layout information.
// Note: THESE ARE THE SAME VALUES AS THE LEGACY PAGE LAYOUT.
// WHEN WE ELIMINATE USAGE OF THOSE VARIABLES THESE CAN BE RENAMED TO BE HASHED.
const $2a40d5d061eb57b6$var$UNSAFE_topBarVar = '--topNavigationHeight';
const $2a40d5d061eb57b6$var$UNSAFE_bannerVar = '--bannerHeight';
const $2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar = '--leftSidebarWidth';
const $2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar = '--rightSidebarWidth';
const $2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar = '--rightPanelWidth';
const $2a40d5d061eb57b6$export$6460bd6a2446260 = `calc(var(${$2a40d5d061eb57b6$var$UNSAFE_bannerVar}, 0px) + var(${$2a40d5d061eb57b6$var$UNSAFE_topBarVar}, 0px))`;
const $2a40d5d061eb57b6$export$3055529fab2b4edf = `var(${$2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar}, 0px)`;
const $2a40d5d061eb57b6$export$166d8fd766c3eb92 = `calc(var(${$2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar}, 0px) + var(${$2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar}, 0px))`;
const $2a40d5d061eb57b6$var$panelSplitterResizingVar = '--localPanelSplitterResizingWidth';
const $2a40d5d061eb57b6$var$sideNavWidthResizeBounds = {
    min: '240px',
    max: '50vw'
};
const $2a40d5d061eb57b6$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
/**
 * We define the z-indexes here so each page slot can be locally layered against each other.
 * For globally defined values such as flag, modal, etc, we can continue to
 * rely on accessing them through global means.
 */ const $2a40d5d061eb57b6$var$localSlotLayers = {
    // Panel should be above banner and top bar slos.
    panel: 3,
    // Banner and top bar should be above all other slots.
    banner: 2,
    topBar: 2,
    // Side nav should be above all other content slots.
    sideNav: 1
};
const $2a40d5d061eb57b6$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8",
    banner: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbycs5v _1reo15vq _18m915vq",
    topBar: "_bfhkvuon _179rzgxb _vchhusvi _nd5l8cbt _4t3i2mmk _152t1nws _kqsw1if8 _1pbycs5v _1reo15vq _18m915vq",
    sideNav: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1vuk _1pbykb7n _14b515li _4ap3vuon _p5clzgxb _scbpglyw _qilnk0mc",
    sideNavHiddenMobileAndDesktop: "_1e0cglyw",
    sideNavHiddenMobileOnly: "_1e0cglyw _dm2518uv",
    sideNavHiddenDesktopOnly: "_dm25glyw",
    main: "_nd5l1gzg",
    aside: "_nd5lns35 _kqswpfqs _glte12il _ndwch9n0",
    panel: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _10fph9n0 _1bsb1g7f _1pby11wp _1j46vuon _ehorzgxb _1sjdglyw _1dhy1c6w",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _kqsw1if8 _165t1run"
};
const $2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $2a40d5d061eb57b6$var$ToggleSideNavVisibility = /*#__PURE__*/ (0, $eUqFw.createContext)({
    current: null
});
function $2a40d5d061eb57b6$var$toggleReducer(state) {
    return !state;
}
function $2a40d5d061eb57b6$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false }) {
    const ref = (0, $eUqFw.useRef)(null);
    const toggleSideNavRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$var$ToggleSideNavVisibility.Provider, {
        value: toggleSideNavRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes.Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.root,
            xcss
        ]),
        id: $2a40d5d061eb57b6$export$a6d827031bcb31d1
    }, children)));
}
function $2a40d5d061eb57b6$export$4188957cd63b68ba() {
    const ref = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$ToggleSideNavVisibility);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        label: "Toggle Side Navigation Visibility",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8123))),
        onClick: ()=>{
            if (ref.current) ref.current();
        }
    });
}
function $2a40d5d061eb57b6$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.banner,
            xcss
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: $2a40d5d061eb57b6$var$bannerMountedVar,
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_bannerVar,
        value: UNSAFE_height
    }), children);
}
function $2a40d5d061eb57b6$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 56 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.topBar,
            xcss
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: $2a40d5d061eb57b6$var$topBarMountedVar,
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_topBarVar,
        value: UNSAFE_height
    }), children);
}
function $2a40d5d061eb57b6$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            [$2a40d5d061eb57b6$var$panelVar]: `${defaultWidth}px`
        },
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.panel,
            $2a40d5d061eb57b6$var$styles.fixedContentArea
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.lg,
        responsiveValue: defaultWidth
    }), children);
}
function $2a40d5d061eb57b6$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.main,
            isFixed && $2a40d5d061eb57b6$var$styles.fixedContentArea,
            xcss
        ]),
        role: "main"
    }, children);
}
function $2a40d5d061eb57b6$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed = false, label: label = 'main', defaultWidth: defaultWidth = 320, testId: testId }) {
    const toggleSideNavVisibilityRef = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$ToggleSideNavVisibility);
    const [visibleOnDesktop, toggleVisibleOnDesktop] = (0, $eUqFw.useReducer)($2a40d5d061eb57b6$var$toggleReducer, !defaultCollapsed);
    const [visibleOnMobile, toggleVisibleOnMobile] = (0, $eUqFw.useReducer)($2a40d5d061eb57b6$var$toggleReducer, false);
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    const panelSplitterParentRef = (0, $eUqFw.useRef)(null);
    const sideNavVariableWidth = `clamp(${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.min}, ${width}px, ${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.max})`;
    const devTimeOnlyAttributes = {};
    const toggleSideNavVisibility = (0, $eUqFw.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) toggleVisibleOnDesktop();
        else toggleVisibleOnMobile();
    }, []);
    (0, $eUqFw.useLayoutEffect)(()=>{
        toggleSideNavVisibilityRef.current = toggleSideNavVisibility;
    }, [
        toggleSideNavVisibility,
        toggleSideNavVisibilityRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $74BVL.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (visibleOnMobile && !visibleOnDesktop) toggleVisibleOnDesktop();
                }
            }
        });
    }, [
        visibleOnDesktop,
        visibleOnMobile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("nav", {
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$2a40d5d061eb57b6$var$sideNavVar]: sideNavVariableWidth
        },
        ref: panelSplitterParentRef,
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.sideNav,
            !visibleOnMobile && visibleOnDesktop && $2a40d5d061eb57b6$var$styles.sideNavHiddenMobileOnly,
            visibleOnMobile && !visibleOnDesktop && $2a40d5d061eb57b6$var$styles.sideNavHiddenDesktopOnly,
            !visibleOnMobile && !visibleOnDesktop && $2a40d5d061eb57b6$var$styles.sideNavHiddenMobileAndDesktop
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: visibleOnDesktop ? sideNavVariableWidth : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWATQ.PanelSplitterProvider), {
        panelRef: panelSplitterParentRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        onClick: toggleSideNavVisibility,
        resizeBounds: $2a40d5d061eb57b6$var$sideNavWidthResizeBounds,
        resizingCssVar: $2a40d5d061eb57b6$var$panelSplitterResizingVar
    }, children));
}
function $2a40d5d061eb57b6$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.aside,
            isFixed && $2a40d5d061eb57b6$var$styles.fixedContentArea,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            [$2a40d5d061eb57b6$var$asideVar]: `${defaultWidth}px`
        }
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: defaultWidth
    }), children);
}

});
parcelRegister("b8123", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81a13e0001b9fa39$var$_react = $81a13e0001b9fa39$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $81a13e0001b9fa39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $81a13e0001b9fa39$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $81a13e0001b9fa39$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z" fill="currentColor"/></svg>`
    }, props));
$81a13e0001b9fa39$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $81a13e0001b9fa39$var$_default = $81a13e0001b9fa39$var$MenuExpandIcon;
module.exports.default = $81a13e0001b9fa39$var$_default;

});

parcelRegister("59HcT", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $71e37afe5eb208b7$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $71e37afe5eb208b7$export$9f45a1325e3cdfb8);

var $eUqFw = parcelRequire("eUqFw");

var $b5l09 = parcelRequire("b5l09");
const $71e37afe5eb208b7$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, `#${(0, $b5l09.gridRootId)} { ${variableName}: ${value}px }`);
const $71e37afe5eb208b7$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $71e37afe5eb208b7$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
};

});

parcelRegister("lWATQ", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $294fcdaee6e5d8fd$export$f662bfb764348932);
$parcel$export(module.exports, "PanelSplitter", () => $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $8ynlC = parcelRequire("8ynlC");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("cbxSN");
var $iYy22 = parcelRequire("iYy22");
parcelRequire("jTs7k");
var $1xLt0 = parcelRequire("1xLt0");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $exYPH = parcelRequire("exYPH");

var $gahth = parcelRequire("gahth");
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $294fcdaee6e5d8fd$var$lineColorVar = '--panelSplitterLineColor'; // Widening type to string to satisfy @compiled/react typing https://atlassian.slack.com/archives/C017XR8K1RB/p1718071105514759
const $294fcdaee6e5d8fd$var$styles = {
    root: "_1e0cglyw _181n1ule _1rqistnw _11ekidpf _12hoidpf _isaet94y _1qie1r31 _3mkmglyw _1y6k1o36",
    grabArea: "_1bsb7vkz _4t3i1osq _1yt4ze3t _bfhk18uv _19itglyw _kqswstnw _nt751r31 _49pcglyw _1hvw1o36 _d0aluf7j _1lf31fvw _d2p71fvw _15p518hz",
    line: "_1e0c1ule _1bsbjfq9 _4t3i1osq _bfhk17tf _v564z97a",
    panelChildrenWrapper: "_1reo1wug _18m91wug _4t3i1osq",
    buttonContent: "_1bsb1osq _4t3i1osq"
};
const $294fcdaee6e5d8fd$var$PanelSplitterContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $294fcdaee6e5d8fd$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, onClick: onClick, panelRef: panelRef, children: children })=>{
    const portalRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$PanelSplitterContext.Provider, {
        value: {
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            resizeBounds: resizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            onClick: onClick,
            panelRef: panelRef
        }
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.panelChildrenWrapper
        ])
    }, children)), /*#__PURE__*/ $eUqFw.createElement("div", {
        ref: portalRef
    }));
};
const $294fcdaee6e5d8fd$var$PortaledPanelSplitter = ({ children: children })=>{
    const splitterRef = (0, $eUqFw.useRef)(null);
    const panelSplitterContext = (0, $eUqFw.useContext)($294fcdaee6e5d8fd$var$PanelSplitterContext);
    (0, $8ynlC.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef } = panelSplitterContext;
    (0, $8ynlC.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $exYPH.useTextDirection)(portalRef.current);
    (0, $eUqFw.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $8ynlC.default)(splitter, 'Splitter ref must be set');
        return (0, $9wCS5.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $iYy22.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $1xLt0.preventUnhandled).start();
            },
            getInitialData () {
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return {
                    initialWidth: (0, $gahth.getComputedWidth)(panelRef.current)
                };
            },
            onDrag ({ location: location, source: source }) {
                if (typeof source.data.initialWidth !== 'number') return;
                panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $gahth.getWidthFromDragLocation)({
                    initialWidth: source.data.initialWidth,
                    location: location,
                    direction: direction
                })}px, ${resizeBounds.max})`);
            },
            onDrop () {
                (0, $1xLt0.preventUnhandled).stop();
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                onCompleteResize((0, $gahth.getComputedWidth)(panelRef.current));
                panelRef.current?.style.removeProperty(resizingCssVar);
            }
        });
    }, [
        onCompleteResize,
        panelRef,
        resizingCssVar,
        panelWidth,
        resizeBounds,
        direction
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.root
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $4ZL0y.default), {
        ref: splitterRef,
        xcss: $294fcdaee6e5d8fd$var$styles.grabArea,
        onClick: panelSplitterContext.onClick
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.buttonContent
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $lkPEe.default), null, children), /*#__PURE__*/ $eUqFw.createElement("span", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.line
        ])
    })))), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $294fcdaee6e5d8fd$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, hasMounted ? children : null);
};
const $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f = ({ children: children })=>/*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$ClientOnly, null, /*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$PortaledPanelSplitter, null, children));

});
parcelRegister("eo9PV", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("9wCS5")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("9wCS5")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9wCS5")).monitorForElements);

var $9wCS5 = parcelRequire("9wCS5");

});
parcelRegister("9wCS5", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $713a693c74f5088c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $713a693c74f5088c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $713a693c74f5088c$export$c746a5152d4ba26c);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $8pyWR = parcelRequire("8pyWR");

var $4PCWk = parcelRequire("4PCWk");

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");

var $eDT75 = parcelRequire("eDT75");

var $kb9dc = parcelRequire("kb9dc");



const $713a693c74f5088c$var$draggableRegistry = new WeakMap();
function $713a693c74f5088c$var$addToRegistry(args) {
    $713a693c74f5088c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $713a693c74f5088c$var$draggableRegistry.delete(args.element);
    };
}
const $713a693c74f5088c$var$honeyPotFix = (0, $8pyWR.makeHoneyPotFix)();
const $713a693c74f5088c$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $jFl9L.combine)($713a693c74f5088c$var$honeyPotFix.bindEvents(), (0, $74BVL.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $713a693c74f5088c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                const input = (0, $kb9dc.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ const { types: types } = event.dataTransfer;
                if ((0, $eDT75.isAndroid)() && !types.includes((0, $559dbbdafee2f66d$export$fd3d00026297c0ad)) && !types.includes((0, $63b7ad043dd75799$export$bc594fb6cfea5e58))) event.dataTransfer.setData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad), (0, $eDT75.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $4df75fb0870d0fce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $713a693c74f5088c$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $713a693c74f5088c$var$honeyPotFix.getOnPostDispatch()
});
const $713a693c74f5088c$export$e7140b68045b5036 = $713a693c74f5088c$var$adapter.dropTarget;
const $713a693c74f5088c$export$59a074bac4c54f54 = $713a693c74f5088c$var$adapter.monitor;
function $713a693c74f5088c$export$c746a5152d4ba26c(args) {
    return (0, $jFl9L.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $713a693c74f5088c$var$adapter.registerUsage(), $713a693c74f5088c$var$addToRegistry(args), (0, $ggbKc.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("cHW1B", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $4de7b3023d657aff$export$81d0353f25f5dd);

var $7HOOK = parcelRequire("7HOOK");
function $4de7b3023d657aff$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $7HOOK.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("7HOOK", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $40cb98f5bdb41c1d$export$821bdcd739a2706b);

function $40cb98f5bdb41c1d$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $d783bf87f05fb737$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("8pyWR", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $be63984178d64c97$export$8ecad27c959e89e0);

var $74BVL = parcelRequire("74BVL");


const $be63984178d64c97$var$honeyPotSize = 2;
const $be63984178d64c97$var$halfHoneyPotSize = $be63984178d64c97$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $be63984178d64c97$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $be63984178d64c97$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $be63984178d64c97$var$halfHoneyPotSize,
        y: point.y - $be63984178d64c97$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $be63984178d64c97$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $be63984178d64c97$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $be63984178d64c97$var$getHoneyPotRectFor({ client: client }) {
    const point = $be63984178d64c97$var$preventGoingForwardsOffScreen($be63984178d64c97$var$preventGoingBackwardsOffScreen($be63984178d64c97$var$pullBackByHalfHoneyPotSize($be63984178d64c97$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $be63984178d64c97$var$honeyPotSize,
        height: $be63984178d64c97$var$honeyPotSize
    });
}
function $be63984178d64c97$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $be63984178d64c97$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $be63984178d64c97$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$be63984178d64c97$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $74BVL.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $be63984178d64c97$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($be63984178d64c97$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $be63984178d64c97$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $74BVL.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $be63984178d64c97$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;


parcelRegister("4PCWk", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $e5ed704461f1a07b$export$2aa3a33160990d96);

var $jlxyb = parcelRequire("jlxyb");

var $buJNg = parcelRequire("buJNg");

var $gItnR = parcelRequire("gItnR");

var $j14G1 = parcelRequire("j14G1");
function $e5ed704461f1a07b$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $j14G1.makeMonitor)();
    const dropTargetAPI = (0, $gItnR.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $jlxyb.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $jlxyb.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $buJNg.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("jlxyb", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $6868b9e56fe4f659$export$3efdceeb8ca25c51);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $7HOOK = parcelRequire("7HOOK");

var $coJJ5 = parcelRequire("coJJ5");

var $fURjR = parcelRequire("fURjR");

var $kb9dc = parcelRequire("kb9dc");

var $9A5IM = parcelRequire("9A5IM");
const $6868b9e56fe4f659$var$globalState = {
    isActive: false
};
function $6868b9e56fe4f659$var$canStart() {
    return !$6868b9e56fe4f659$var$globalState.isActive;
}
function $6868b9e56fe4f659$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $6868b9e56fe4f659$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $6868b9e56fe4f659$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$6868b9e56fe4f659$var$canStart()) return;
    const initial = $6868b9e56fe4f659$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $6868b9e56fe4f659$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $6868b9e56fe4f659$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $9A5IM.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $6868b9e56fe4f659$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $kb9dc.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $7HOOK.isHoneyPotElement)(event.target) ? (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $6868b9e56fe4f659$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $6868b9e56fe4f659$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $coJJ5.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $6868b9e56fe4f659$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $6868b9e56fe4f659$var$getNativeSetDragImage(event)
    });
}
function $6868b9e56fe4f659$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $6868b9e56fe4f659$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $kb9dc.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $6868b9e56fe4f659$export$3efdceeb8ca25c51 = {
    canStart: $6868b9e56fe4f659$var$canStart,
    start: $6868b9e56fe4f659$var$start
};

});
parcelRegister("coJJ5", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $f35fe00a678b780a$export$57d220c74e84a273);

var $enquP = parcelRequire("enquP");

var $Fx8Dp = parcelRequire("Fx8Dp");

var $jivNo = parcelRequire("jivNo");

var $ehWpG = parcelRequire("ehWpG");
function $f35fe00a678b780a$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $Fx8Dp.isSafari)()) return (0, $jivNo.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $enquP.isFirefox)()) return (0, $ehWpG.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("enquP", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $e614166849bdfbc2$export$b7d78993b74f766d);

var $KsGIL = parcelRequire("KsGIL");
const $e614166849bdfbc2$export$b7d78993b74f766d = (0, $KsGIL.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("KsGIL", function(module, exports) {

$parcel$export(module.exports, "once", () => $60659947ef15ccf3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $60659947ef15ccf3$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("Fx8Dp", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $4c39b3d87a6f2982$export$95df08bae54cb4df);

var $KsGIL = parcelRequire("KsGIL");
const $4c39b3d87a6f2982$export$95df08bae54cb4df = (0, $KsGIL.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jivNo", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindowInSafari", () => $988fa06fa869765d$export$f21837c338005454);

var $74BVL = parcelRequire("74BVL");

var $Fx8Dp = parcelRequire("Fx8Dp");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $988fa06fa869765d$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $988fa06fa869765d$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragEnter.hasOwnProperty($988fa06fa869765d$var$symbols.isEnteringWindow);
}
function $988fa06fa869765d$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragLeave.hasOwnProperty($988fa06fa869765d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $Fx8Dp.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$988fa06fa869765d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$988fa06fa869765d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("ehWpG", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $395b6cf20e8aa0ab$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $395b6cf20e8aa0ab$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $395b6cf20e8aa0ab$export$e46810fef53b5b0e(eventTarget) {
    return $395b6cf20e8aa0ab$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("fURjR", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $e1eef5448bb32238$export$ac5e5b0daf997b2);
function $e1eef5448bb32238$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("kb9dc", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $661957bb1ab51692$export$7c112ceec8941e67);
function $661957bb1ab51692$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("9A5IM", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $6674e392a266d08a$export$9f13ecc44e83d682);

var $8yx6O = parcelRequire("8yx6O");
const $6674e392a266d08a$var$scheduleOnDrag = (0, $8yx6O.default)((fn)=>fn());
const $6674e392a266d08a$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $6674e392a266d08a$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $6674e392a266d08a$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $6674e392a266d08a$var$scheduleOnDrag(()=>{
                $6674e392a266d08a$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("buJNg", function(module, exports) {

$parcel$export(module.exports, "register", () => $16255e18a8cdf5a6$export$6503ec6e8aabbaf);
const $16255e18a8cdf5a6$var$ledger = new Map();
function $16255e18a8cdf5a6$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $16255e18a8cdf5a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $16255e18a8cdf5a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $16255e18a8cdf5a6$export$6503ec6e8aabbaf(args) {
    const entry = $16255e18a8cdf5a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $16255e18a8cdf5a6$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("gItnR", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $4df313649e179712$export$47d10e7bd9c81890);

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");
function $4df313649e179712$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $4df313649e179712$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $jFl9L.combine)((0, $ggbKc.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $4df313649e179712$var$copyReverse(current);
        const actualCaptureOrdered = $4df313649e179712$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $4df313649e179712$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jFl9L", function(module, exports) {

$parcel$export(module.exports, "combine", () => $e825059ee70ef631$export$1be1fc439b849fdf);
function $e825059ee70ef631$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("ggbKc", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $df9d12eec6804e85$export$5dcb5c23b6ba980a);
function $df9d12eec6804e85$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("j14G1", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $aec9bd094a175c02$export$5dd4ed888d5b12ca);
function $aec9bd094a175c02$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eDT75", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $773300f3a724036a$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $773300f3a724036a$export$aceb3ed8b7f7bd2c);

var $KsGIL = parcelRequire("KsGIL");
const $773300f3a724036a$export$a11b0059900ceec8 = (0, $KsGIL.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $773300f3a724036a$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $559dbbdafee2f66d$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $63b7ad043dd75799$export$bc594fb6cfea5e58 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $4df75fb0870d0fce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("cbxSN", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("iYy22")).disableNativeDragPreview);

var $iYy22 = parcelRequire("iYy22");

});
parcelRegister("iYy22", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $f96526f07b5b7d85$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $f96526f07b5b7d85$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $f96526f07b5b7d85$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $f96526f07b5b7d85$var$tinyTransparentImage) nativeSetDragImage($f96526f07b5b7d85$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("jTs7k", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("1xLt0")).preventUnhandled);

var $1xLt0 = parcelRequire("1xLt0");

});
parcelRegister("1xLt0", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $6e73835b1fb5a057$export$453c0582481cc59d);

var $74BVL = parcelRequire("74BVL");

var $fURjR = parcelRequire("fURjR");
function $6e73835b1fb5a057$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $6e73835b1fb5a057$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $6e73835b1fb5a057$var$start() {
    $6e73835b1fb5a057$var$cleanup();
    $6e73835b1fb5a057$var$unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragover',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $6e73835b1fb5a057$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $6e73835b1fb5a057$var$cleanup
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: $6e73835b1fb5a057$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $6e73835b1fb5a057$var$cleanup() {
    $6e73835b1fb5a057$var$unbindEvents?.();
    $6e73835b1fb5a057$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $6e73835b1fb5a057$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $6e73835b1fb5a057$var$cleanup();
}
const $6e73835b1fb5a057$export$453c0582481cc59d = {
    start: $6e73835b1fb5a057$var$start,
    stop: $6e73835b1fb5a057$var$stop
};

});


parcelRegister("exYPH", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $4d81149f9603ea38$export$cf24a79f32f45545);

var $eUqFw = parcelRequire("eUqFw");
const $4d81149f9603ea38$export$cf24a79f32f45545 = (element)=>(0, $eUqFw.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});

parcelRegister("gahth", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $32dabdf2c83724a8$export$e360234971cb95b8);
$parcel$export(module.exports, "getComputedWidth", () => $32dabdf2c83724a8$export$4b8bb339e24d513f);
const $32dabdf2c83724a8$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    return direction === 'rtl' ? initialWidth - diffX : initialWidth + diffX;
};
const $32dabdf2c83724a8$export$4b8bb339e24d513f = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});




parcelRegister("53ucm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $775b7b0f5d2674bd$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $775b7b0f5d2674bd$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $775b7b0f5d2674bd$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $775b7b0f5d2674bd$export$99e05a60cac05e86);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3roBA = parcelRequire("3roBA");
const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
const $775b7b0f5d2674bd$var$initialState = {
    isChromeless: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $775b7b0f5d2674bd$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $a61MH.createStore)({
    initialState: $775b7b0f5d2674bd$var$initialState,
    actions: $3roBA.actions,
    name: 'JiraLayoutStore'
});
const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
    selector: null
});
const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $a61MH.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $ggKAj.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);

});
parcelRegister("3roBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7de3ed8fccc77236$export$e324594224ef24da);

var $3OanE = parcelRequire("3OanE");

var $gDr9R = parcelRequire("gDr9R");

var $aoZTG = parcelRequire("aoZTG");

var $f9nrb = parcelRequire("f9nrb");

var $hqpfO = parcelRequire("hqpfO");
const $7de3ed8fccc77236$export$e324594224ef24da = {
    setIsChromeless: // global
    $aoZTG.setIsChromeless,
    showBanner: // banner
    $3OanE.showBanner,
    dismissCurrentBanner: $3OanE.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $f9nrb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $hqpfO.setRightSidebarState,
    openRightSidebar: $hqpfO.openRightSidebar,
    closeRightSidebar: $hqpfO.closeRightSidebar,
    closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
    closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
    minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $gDr9R.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
};

});
parcelRegister("3OanE", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $1ca96d140cb009a0$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $1ca96d140cb009a0$export$a45bccc0cc9ac424);
const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("gDr9R", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $ce70661c3da7d088$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $ce70661c3da7d088$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $ce70661c3da7d088$export$928bf7e228ce06d2);
const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("aoZTG", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $1199e64f89ce3554$export$1998c4816ad37edb);
const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("f9nrb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $a9b20025b1de3529$export$3e0fd2d894ef83c8);
const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("hqpfO", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $bea3cfbec26c4bd1$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $bea3cfbec26c4bd1$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $bea3cfbec26c4bd1$export$c8dafe074328c4ca);

var $hTLlD = parcelRequire("hTLlD");
const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});





parcelRegister("16WDb", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $6f4a5382247c5f3b$export$ee1cb2a8280d8710);

var $eUqFw = parcelRequire("eUqFw");

var $cgrgx = parcelRequire("cgrgx");

var $knPb9 = parcelRequire("knPb9");
const $6f4a5382247c5f3b$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $cgrgx.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $knPb9.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("knPb9", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $e1b771d5f606c17c$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $e1b771d5f606c17c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e1b771d5f606c17c$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $e1b771d5f606c17c$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$e1b771d5f606c17c$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $e1b771d5f606c17c$export$2e2bcd8739ae039 = $e1b771d5f606c17c$var$withInjectedProps;

});



parcelRegister("hWTey", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $0bc9252b272e4d4e$export$be3f2958452e7be9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc9252b272e4d4e$var$FeedbackNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hKj93")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $0bc9252b272e4d4e$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc9252b272e4d4e$var$FeedbackNudgeLazy, null, children)));
$0bc9252b272e4d4e$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("ewdMq", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $adec59c10c54d3d1$export$3915a8814b99f0b);

var $eUqFw = parcelRequire("eUqFw");

var $kMhLP = parcelRequire("kMhLP");

var $7dRgX = parcelRequire("7dRgX");
const $adec59c10c54d3d1$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $7dRgX.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("kMhLP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $5bd50febcd8eec1e$export$9171acf2e93b7d4d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $7Aqzu = parcelRequire("7Aqzu");
const $5bd50febcd8eec1e$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $7Aqzu.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("7Aqzu", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $eee5ff621608f776$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $eee5ff621608f776$export$807be5f3f1ea996);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
const $eee5ff621608f776$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $eee5ff621608f776$export$807be5f3f1ea996 = (attributes = {})=>(0, $eUqFw.useCallback)((error)=>({
            ...attributes,
            ...$eee5ff621608f776$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("hKj93", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1VDSh');
        const value = parcelRequire('kaG0t');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1VDSh").then(()=>parcelRequire('kaG0t'));
}

});


parcelRegister("3PsZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d43629c675088b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $18d43629c675088b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedback: {
        "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("8l70H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7d12471fcc325f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d7d12471fcc325f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    companyManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
        "defaultMessage": "You're in a company-managed project"
    },
    navigationLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
        "defaultMessage": "Side"
    },
    teamManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
        "defaultMessage": "You're in a team-managed project"
    },
    viewAllStarred: {
        "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
        "defaultMessage": "View all starred projects"
    }
});

});

parcelRegister("4h0Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $905750f428147679$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $dxopF = parcelRequire("dxopF");

var $fIhju = parcelRequire("fIhju");

var $3236p = parcelRequire("3236p");

var $5qKeD = parcelRequire("5qKeD");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $lg3mT = parcelRequire("lg3mT");

var $94rY2 = parcelRequire("94rY2");

var $dSHCZ = parcelRequire("dSHCZ");

var $gmtu6 = parcelRequire("gmtu6");

var $8MaWo = parcelRequire("8MaWo");
const $905750f428147679$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const refresh = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const routeOverviewId = match.params?.overviewId;
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $eUqFw.useState)(false);
    const openCreateModal = (0, $eUqFw.useCallback)(()=>{
        setIsCreateModalOpen(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
    }, [
        createAnalyticsEvent
    ]);
    const closeCreateModal = (0, $eUqFw.useCallback)(()=>setIsCreateModalOpen(false), []);
    const showOverviewChangeboarding = (0, $f26dB.useTriggerOverviewChangeboarding)();
    if ((0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && showOverviewChangeboarding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qKeD.AsyncMigrationMessage), null));
    let content;
    if (hasError) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorWrapper, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorMessage, null, formatMessage((0, $gmtu6.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: refresh
    }, formatMessage((0, $gmtu6.default).refreshPage)));
    else if (overviews.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$EmptyState, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: openCreateModal
    }, formatMessage((0, $gmtu6.default).createOverview)));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$List, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
    }, overviews.map((overview)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: overview.id
        }, routeOverviewId === overview.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview),
            isActive: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview, route)
        }))));
    const hasReachedLimit = overviews?.length >= (0, $lg3mT.OVERVIEW_MAX_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSHCZ.default), {
        onClick: openCreateModal,
        hasReachedLimit: hasReachedLimit
    })), content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isCreateModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3236p.default), {
        onClose: closeCreateModal
    })));
};
var $905750f428147679$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($905750f428147679$var$Overviews);
const $905750f428147679$var$EmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $905750f428147679$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s85axq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fIhju", function(module, exports) {

$parcel$export(module.exports, "getOverviewUrl", () => $3ba1ebdf548dd4c6$export$e314405e3f098e61);
$parcel$export(module.exports, "getProjectUrl", () => $3ba1ebdf548dd4c6$export$951b86b8e730b952);

var $exb0h = parcelRequire("exb0h");
const $3ba1ebdf548dd4c6$export$e314405e3f098e61 = (overview, currentRoute)=>{
    switch(currentRoute?.name){
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY:
            return `/jira/core/overviews/${overview.id}/summary`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR:
            return `/jira/core/overviews/${overview.id}/calendar`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE:
            return `/jira/core/overviews/${overview.id}/timeline`;
        default:
            return `/jira/core/overviews/${overview.id}`;
    }
};
const $3ba1ebdf548dd4c6$export$951b86b8e730b952 = (project, currentRoute)=>{
    switch(currentRoute?.name){
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY:
            return `/jira/core/projects/${project.key}/summary`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD:
            return `/jira/core/projects/${project.key}/board`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST:
            return `/jira/core/projects/${project.key}/list`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR:
            return `/jira/core/projects/${project.key}/calendar`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE:
            return `/jira/core/projects/${project.key}/timeline`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_BUILDER:
            return `/jira/core/projects/${project.key}/form`;
        case (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES:
            return `/jira/core/projects/${project.key}/pages`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_ATTACHMENTS:
            return `/jira/core/projects/${project.key}/attachments`;
        default:
            if (currentRoute?.group === (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR) return `/jira/core/projects/${project.key}/issues`;
            return `/jira/core/projects/${project.key}`;
    }
};

});

parcelRegister("3236p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de253836bffed60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4G5xU = parcelRequire("4G5xU");

var $gGtKh = parcelRequire("gGtKh");

var $jXDc6 = parcelRequire("jXDc6");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7de253836bffed60$var$LazyCreateOverviewModal = (0, $7rh0R.lazy)(()=>(parcelRequire("kNQTV")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7de253836bffed60$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $jXDc6.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7de253836bffed60$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("4G5xU", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $0afb98966ec8ac3d$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $0afb98966ec8ac3d$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $0afb98966ec8ac3d$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $0afb98966ec8ac3d$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $0afb98966ec8ac3d$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $0afb98966ec8ac3d$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $0afb98966ec8ac3d$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $0afb98966ec8ac3d$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $0afb98966ec8ac3d$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $gCyQH = parcelRequire("gCyQH");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $fDZ6r = parcelRequire("fDZ6r");
var $1Fr7E = parcelRequire("1Fr7E");
var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
const $0afb98966ec8ac3d$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $bDhRl.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $0afb98966ec8ac3d$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $1Fr7E.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $0afb98966ec8ac3d$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $fDZ6r.useExperienceSuccess)({
        experience: experience
    });
const $0afb98966ec8ac3d$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $eUqFw.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $guiFP.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $0afb98966ec8ac3d$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $eUqFw.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $eUqFw.useState)(false);
    const startExperience = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    const onSuccess = $0afb98966ec8ac3d$export$e94f0da4fc0603c6(experience);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error);
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $0afb98966ec8ac3d$export$f20b867e738a222c = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience })=>{
    const start = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    (0, $eUqFw.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience, error: error })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    (0, $eUqFw.useEffect)(()=>{
        onFail(experience.experience, error);
    }, [
        error,
        experience,
        onFail
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $gCyQH.ErrorPage), children: children })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0afb98966ec8ac3d$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $0afb98966ec8ac3d$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: experience.experience,
        attributes: experience.experienceId == null ? undefined : {
            experienceId: experience.experienceId
        }
    }));

});
parcelRegister("gCyQH", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $6c8115aba8656cec$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEZRh = parcelRequire("bEZRh");
const $6c8115aba8656cec$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c8115aba8656cec$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c8115aba8656cec$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Fr7E", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $f0f298b79da53f61$export$cc92b7ce453f4403);

var $eUqFw = parcelRequire("eUqFw");

var $gtrMw = parcelRequire("gtrMw");
const $f0f298b79da53f61$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("jXDc6", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $92a66ffd6a5018dc$export$3d931b64f46140b3);

var $c9TLT = parcelRequire("c9TLT");
const $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
const $92a66ffd6a5018dc$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$d03d4e78ea5b909a = (0, $c9TLT.gridSize) * 2;
const $92a66ffd6a5018dc$export$57ee5df6bad94642 = 400;
const $92a66ffd6a5018dc$export$5785b84269e3e763 = 340;
const $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 = (0, $c9TLT.gridSize) * 3;
const $92a66ffd6a5018dc$export$c4232794452dc6e3 = 480;
const $92a66ffd6a5018dc$export$3d931b64f46140b3 = $92a66ffd6a5018dc$export$c4232794452dc6e3 + $92a66ffd6a5018dc$export$57ee5df6bad94642 + $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 * 2 + $92a66ffd6a5018dc$export$d03d4e78ea5b909a * 2;
const $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN = 120;
const $92a66ffd6a5018dc$export$68bc124b0fa13de0 = $92a66ffd6a5018dc$export$3d931b64f46140b3 + $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN;

});
parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});


parcelRegister("kNQTV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('he5e3')
        ]);
        const value = parcelRequire('jthZP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("he5e3")
    ]).then(()=>parcelRequire('jthZP'));
}

});


parcelRegister("5qKeD", function(module, exports) {

$parcel$export(module.exports, "AsyncMigrationMessage", () => $20b69e266ccb1e91$export$93794b6cb00009c5);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $fXgkp = parcelRequire("fXgkp");
const $20b69e266ccb1e91$var$runtimeProps = {};
const $20b69e266ccb1e91$var$entryPointParams = {};
const $20b69e266ccb1e91$export$93794b6cb00009c5 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fXgkp.migrationMessageEntrypoint), $20b69e266ccb1e91$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "overviews-plans-onboarding-migration-message",
        packageName: "jiraBusinessOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $20b69e266ccb1e91$var$runtimeProps
    });
};

});
parcelRegister("fXgkp", function(module, exports) {

$parcel$export(module.exports, "migrationMessageEntrypoint", () => $8c5cd663e92125c4$export$2dea5f3fdc0ae86);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $8c5cd663e92125c4$export$2dea5f3fdc0ae86 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("hEPtV")).then((module)=>module.MigrationMessage), {
        moduleId: "cb473cb0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hEPtV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cyvEN')
        ]);
        const value = parcelRequire('7Sxem');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cyvEN")
    ]).then(()=>parcelRequire('7Sxem'));
}

});



parcelRegister("lg3mT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $f1a163edcd3bb430$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MENU_ID", () => $f1a163edcd3bb430$export$d4cd258d01c03112);
$parcel$export(module.exports, "SECTION_ID", () => $f1a163edcd3bb430$export$501955bd67991a25);
$parcel$export(module.exports, "REPORTS_ROUTES_SET", () => $f1a163edcd3bb430$export$f746f9acd7a66bdb);
$parcel$export(module.exports, "SETTINGS_ROUTES_SET", () => $f1a163edcd3bb430$export$e8d6319ab0eb2a27);
$parcel$export(module.exports, "ISSUES_ROUTES_SET", () => $f1a163edcd3bb430$export$6ca9a18cdf1b5a79);
$parcel$export(module.exports, "FORGE_ROUTES_SET", () => $f1a163edcd3bb430$export$6ad6f0faae6ab404);
$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $f1a163edcd3bb430$export$75d31ae45b00712c);
$parcel$export(module.exports, "LOCATION", () => $f1a163edcd3bb430$export$87d0ca22edb7493a);
$parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", () => $f1a163edcd3bb430$export$96f465f51836d3a2);

var $exb0h = parcelRequire("exb0h");

var $c9TLT = parcelRequire("c9TLT");
const $f1a163edcd3bb430$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
const $f1a163edcd3bb430$export$d4cd258d01c03112 = 'project/core';
const $f1a163edcd3bb430$export$501955bd67991a25 = {
    ISSUES: 'issues',
    REPORTS: 'reports',
    SETTINGS: 'settings',
    ISSUE_TYPES: 'issuetypes'
};
const $f1a163edcd3bb430$export$f746f9acd7a66bdb = new Set([
    (0, $exb0h.ROUTE_NAMES).LEGACY_ALL_REPORTS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_CONFIG,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_AVERAGE_AGE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_CREATED_VS_RESOLVED,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_PIE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_RECENTLY_CREATED,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_RESOLUTION_TIME,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_TIME_SINCE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_TIME_TRACKING_REPORT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_DEVELOPER_WORKLOAD,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_VERSION_WORKLOAD,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_WORKLOAD_PIE
]);
const $f1a163edcd3bb430$export$e8d6319ab0eb2a27 = new Set([
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS,
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_EDIT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_CONFIG,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_FIELDS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_TYPES,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_NOTIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_OPSGENIE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PERMISSIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SCREENS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SUMMARY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_WORKFLOWS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_COLLECTORS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PEOPLE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DEV
]);
const $f1a163edcd3bb430$export$6ca9a18cdf1b5a79 = new Set([
    (0, $exb0h.ROUTE_NAMES).LEGACY_PIN,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CORE
]);
const $f1a163edcd3bb430$export$6ad6f0faae6ab404 = new Set([
    (0, $exb0h.ROUTE_NAMES).FORGE_PROJECT,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_FORGE_APPS
]);
const $f1a163edcd3bb430$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $f1a163edcd3bb430$export$33abecf3eb4ba30b = (0, $c9TLT.gridSize) * 5;
const $f1a163edcd3bb430$export$76ca6e18b275dcad = 24;
const $f1a163edcd3bb430$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
const $f1a163edcd3bb430$export$96f465f51836d3a2 = 10;

});

parcelRegister("94rY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2cfaa3cc51cd03b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $41WOo = parcelRequire("41WOo");
const $d2cfaa3cc51cd03b$var$SectionHeader = ({ children: children, title: title, elemAfter: elemAfter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$960a49cc3d27a090, null, (0, $41WOo.isVariationOnJwmMonetizationExperiment)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$var$ElemAfterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$8b251419efc915eb, null, title), elemAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$8b251419efc915eb, null, title), children);
var $d2cfaa3cc51cd03b$export$2e2bcd8739ae039 = $d2cfaa3cc51cd03b$var$SectionHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2cfaa3cc51cd03b$var$ElemAfterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $d2cfaa3cc51cd03b$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
            __cmplp.className
        ])
    });
});
const $d2cfaa3cc51cd03b$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kw7 _19pkidpf _11c81bk4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dSHCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9b6c8e2a461a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $rRiBz = parcelRequire("rRiBz");

var $hOFzv = parcelRequire("hOFzv");

var $gxlwv = parcelRequire("gxlwv");
const $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
const $aab9b6c8e2a461a8$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isWarningOpen, setIsWarningOpen] = (0, $eUqFw.useState)(false);
    if (hasReachedLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        isOpen: isWarningOpen,
        onClose: ()=>setIsWarningOpen(false),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
                ...triggerProps,
                onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                label: formatMessage((0, $hOFzv.default).createOverviewLabel),
                testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID,
                ref: ref
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxlwv.default), null)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        onClick: onClick,
        label: formatMessage((0, $hOFzv.default).createOverviewLabel),
        testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID
    });
};
var $aab9b6c8e2a461a8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aab9b6c8e2a461a8$var$CreateOverview);

});
parcelRegister("rRiBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $76157c9c7cef0bf6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $bUVhp = parcelRequire("bUVhp");
const $76157c9c7cef0bf6$var$RoundCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bUVhp.StyledButton), {
        ...props,
        ref: ref,
        testId: testId,
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: label,
            primaryColor: `var(--ds-text, ${(0, $PdmhA).N800})`,
            size: "small"
        }),
        onClick: onClick
    })));
var $76157c9c7cef0bf6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($76157c9c7cef0bf6$var$RoundCreateButton);

});
parcelRegister("bUVhp", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1njd _1pbykb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hOFzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $413e172b8c878b47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $413e172b8c878b47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverviewLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
        "defaultMessage": "Create overview"
    }
});

});

parcelRegister("gxlwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b10dfebf342cc5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lg3mT = parcelRequire("lg3mT");

var $4VuJA = parcelRequire("4VuJA");
const $f0b10dfebf342cc5$var$OverviewLimitPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0b10dfebf342cc5$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: "var(--ds-icon-warning, #ffab00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $4VuJA.default).overviewLimitReached, {
        overviewMaxLimit: (0, $lg3mT.OVERVIEW_MAX_LIMIT)
    })));
};
var $f0b10dfebf342cc5$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $eUqFw.memo)($f0b10dfebf342cc5$var$OverviewLimitPopup);
const $f0b10dfebf342cc5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4VuJA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6d7d156ba1ad3d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f6d7d156ba1ad3d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    overviewLimitReached: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
        "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
    }
});

});



parcelRegister("gmtu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69d68e991d71af7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c69d68e991d71af7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverview: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
        "defaultMessage": "Create an overview"
    },
    overviewsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
        "defaultMessage": "Overviews"
    },
    errorMessage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
        "defaultMessage": "We couldn't load overviews"
    },
    refreshPage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
        "defaultMessage": "Refresh page"
    }
});

});

parcelRegister("8MaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $85de1c4527c5fda3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gotST = parcelRequire("gotST");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $2Ucfd = parcelRequire("2Ucfd");

var $3YFEG = parcelRequire("3YFEG");
const $85de1c4527c5fda3$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
    const { name: name, theme: theme } = overview;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        isActive: isActive,
        prefetch: "hover",
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85de1c4527c5fda3$export$399e54fcdf2a48ec, {
        size: "small",
        themeName: theme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ucfd.default), null, name));
    return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), null, content) : content;
};
var $85de1c4527c5fda3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($85de1c4527c5fda3$var$OverviewLink);
const $85de1c4527c5fda3$export$399e54fcdf2a48ec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gotST.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gotST", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ce495d3d442ffd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8tfNS = parcelRequire("8tfNS");

var $kar7l = parcelRequire("kar7l");

var $i4XFs = parcelRequire("i4XFs");
const $56ce495d3d442ffd$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
    const theme = themeName ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
    const Wrapper = (0, $i4XFs.WRAPPER)[size][theme];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": "business-entity-overview.common.ui.overview-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))), {
        label: "",
        size: size
    }));
};
var $56ce495d3d442ffd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($56ce495d3d442ffd$var$OverviewIcon);

});
parcelRegister("8tfNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad4a6c20067d20$var$_react = $62ad4a6c20067d20$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $62ad4a6c20067d20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $62ad4a6c20067d20$var$WorldIcon = (props)=>/*#__PURE__*/ $62ad4a6c20067d20$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21a9 9 0 100-18 9 9 0 000 18zm-.9-1.863A7.19 7.19 0 014.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8v1.737zm6.21-2.286A1.786 1.786 0 0015.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$62ad4a6c20067d20$var$WorldIcon.displayName = 'WorldIcon';
var $62ad4a6c20067d20$var$_default = $62ad4a6c20067d20$var$WorldIcon;
module.exports.default = $62ad4a6c20067d20$var$_default;

});

parcelRegister("i4XFs", function(module, exports) {

$parcel$export(module.exports, "WRAPPER", () => $4d118138298fb934$export$20b8431be300f03e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $4d118138298fb934$var$iconWrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N20A})`}`
};
const $4d118138298fb934$var$smallIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '24px',
    height: '24px'
};
const $4d118138298fb934$var$mediumIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '32px',
    height: '32px'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4d118138298fb934$var$WhiteSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$WhiteMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$export$20b8431be300f03e = {
    small: {
        white: $4d118138298fb934$var$WhiteSmallIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        dark: $4d118138298fb934$var$DarkSmallIconWrapper,
        purple: $4d118138298fb934$var$PurpleSmallIconWrapper,
        blue: $4d118138298fb934$var$BlueSmallIconWrapper,
        teal: $4d118138298fb934$var$TealSmallIconWrapper,
        green: $4d118138298fb934$var$GreenSmallIconWrapper,
        yellow: $4d118138298fb934$var$YellowSmallIconWrapper,
        red: $4d118138298fb934$var$RedSmallIconWrapper,
        magenta: $4d118138298fb934$var$MagentaSmallIconWrapper,
        orange: $4d118138298fb934$var$OrangeSmallIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darker-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteSmallIconWrapper
    },
    medium: {
        white: $4d118138298fb934$var$WhiteMediumIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        dark: $4d118138298fb934$var$DarkMediumIconWrapper,
        purple: $4d118138298fb934$var$PurpleMediumIconWrapper,
        blue: $4d118138298fb934$var$BlueMediumIconWrapper,
        teal: $4d118138298fb934$var$TealMediumIconWrapper,
        green: $4d118138298fb934$var$GreenMediumIconWrapper,
        yellow: $4d118138298fb934$var$YellowMediumIconWrapper,
        red: $4d118138298fb934$var$RedMediumIconWrapper,
        magenta: $4d118138298fb934$var$MagentaMediumIconWrapper,
        orange: $4d118138298fb934$var$OrangeMediumIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darker-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteMediumIconWrapper
    }
};

});


parcelRegister("7BoX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c30ceaf64f4777$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $87c30ceaf64f4777$var$ActiveItem = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87c30ceaf64f4777$var$ActiveItemWrapper, {
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87c30ceaf64f4777$var$ActiveItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1sit _bfhkiw92",
            __cmplp.className
        ])
    });
});
var $87c30ceaf64f4777$export$2e2bcd8739ae039 = $87c30ceaf64f4777$var$ActiveItem;

});

parcelRegister("2Ucfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f309bbea3103a655$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f309bbea3103a655$var$LinkLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48pbfng _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
var $f309bbea3103a655$export$2e2bcd8739ae039 = $f309bbea3103a655$var$LinkLabel;

});

parcelRegister("3YFEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b3c14587c33fc56$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $kJlBc = parcelRequire("kJlBc");
const $1b3c14587c33fc56$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$Wrapper, {
        isActive: isActive,
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$StyledLink, {
        "aria-current": isActive ? 'page' : undefined,
        ...other
    }, children), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$ElementAfterWrapper, {
        "data-component-selector": "sidebar-link-elem-after"
    }, elemAfter));
const $1b3c14587c33fc56$var$showElementAfter = {
    width: 'inherit !important',
    opacity: 1
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b3c14587c33fc56$var$ElementAfterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1b30gsy": (0, $9t7rW.default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`),
            "--_dpi1qg": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isActive && `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
var $1b3c14587c33fc56$export$2e2bcd8739ae039 = $1b3c14587c33fc56$var$SidebarLink;

});



parcelRegister("9QtHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7365cd4b1a70e60e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $PdmhA = parcelRequire("PdmhA");

var $15zK8 = parcelRequire("15zK8");

var $fIhju = parcelRequire("fIhju");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kMUsV = parcelRequire("kMUsV");

var $8RzJd = parcelRequire("8RzJd");

var $bVacK = parcelRequire("bVacK");

var $1nRKu = parcelRequire("1nRKu");
const $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
const $7365cd4b1a70e60e$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
const $7365cd4b1a70e60e$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, currentRoute: currentRoute, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const title = sectionId === 'starred' ? formatMessage((0, $bVacK.default).favorites) : formatMessage((0, $bVacK.default).recents);
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(true);
    const onToggleExpand = (0, $eUqFw.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
            sectionId: sectionId,
            collapse: isExpanded
        });
    }, [
        createAnalyticsEvent,
        isExpanded,
        sectionId
    ]);
    const chevronIcon = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$var$IconWrapper, {
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: formatMessage(isExpanded ? (0, $bVacK.default).collapseSection : (0, $bVacK.default).expandSection, {
                section: title
            }),
            primaryColor: `var(--ds-text-subtlest, ${(0, $PdmhA).N300})`
        })), [
        formatMessage,
        isExpanded,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$7d436a88869873b5, {
        "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$dca3dbf057c88c5f, {
        "aria-expanded": isExpanded,
        "aria-controls": `multi-project-menu-project-group-${sectionId}`,
        onClick: onToggleExpand,
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        iconBefore: chevronIcon
    }), title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15zK8.Collapsible), {
        id: `multi-project-menu-project-group-${sectionId}`,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RzJd.default), {
            project: project,
            to: (0, $1ybV0.ff)('jwm.custom-project-navigation') ? $7365cd4b1a70e60e$var$getDefaultProjectUrl(project) : (0, $fIhju.getProjectUrl)(project),
            onFavoriteToggle: ()=>onFavoriteToggle(project)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
            project: project,
            to: (0, $1ybV0.ff)('jwm.custom-project-navigation') ? $7365cd4b1a70e60e$var$getDefaultProjectUrl(project) : (0, $fIhju.getProjectUrl)(project, currentRoute),
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                    projectId: project.id,
                    starred: project.isFavorite,
                    current: false
                }),
            onFavoriteToggle: ()=>onFavoriteToggle(project),
            prefetch: "hover",
            testId: $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID
        }))), showViewAllProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nRKu.default), {
        label: viewAllProjectsLabel
    })))));
};
var $7365cd4b1a70e60e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($7365cd4b1a70e60e$var$ProjectGroup);
const $7365cd4b1a70e60e$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_v5641b1u _k8m01e03",
            __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$7d436a88869873b5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$dca3dbf057c88c5f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$99bffacbdbcb5195 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("15zK8", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $cd108e84fbd541ee$export$6eb0f7ddcda6131f);

var $eUqFw = parcelRequire("eUqFw");

var $4WrKv = parcelRequire("4WrKv");
const $cd108e84fbd541ee$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
    const didMountRef = (0, $eUqFw.useRef)(false);
    const [containerHeight, setContainerHeight] = (0, $eUqFw.useState)(isExpanded ? null : 0);
    const [isRendered, setIsRendered] = (0, $eUqFw.useState)(isExpanded);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const contentRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            setIsRendered(true);
            requestAnimationFrame(()=>{
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setContainerHeight(null);
                });
            });
        } else {
            setContainerHeight(contentRef.current?.offsetHeight ?? null);
            requestAnimationFrame(()=>{
                setContainerHeight(0);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setIsRendered(false);
                });
            });
        }
    }, [
        contentRef,
        isExpanded
    ]);
    if (!isRendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WrKv.CollapsibleWrapper), {
        animationDuration: animationDuration,
        containerHeight: containerHeight,
        id: id,
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: contentRef
    }, children));
};

});
parcelRegister("4WrKv", function(module, exports) {

$parcel$export(module.exports, "CollapsibleWrapper", () => $932f846aacdec0cd$export$417956c58046108f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $932f846aacdec0cd$export$417956c58046108f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3opy9g": (0, $9t7rW.default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
            "--_3k6n1g": (0, $9t7rW.default)(__cmplp.containerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _v564plo1",
            __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kMUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c19644e3c562f1f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JDHd = parcelRequire("5JDHd");

var $3YFEG = parcelRequire("3YFEG");
const $3c19644e3c562f1f$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        onClick: onClick,
        isActive: isActive,
        elemAfter: project.permissions.viewIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JDHd.default), {
            project: project,
            onToggle: onFavoriteToggle
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        testId: testId,
        prefetch: prefetch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$Avatar, {
        src: project.avatarUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$ProjectName, null, project.name));
var $3c19644e3c562f1f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3c19644e3c562f1f$var$ProjectItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c19644e3c562f1f$var$ProjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48pbfng",
            __cmplp.className
        ])
    });
});
const $3c19644e3c562f1f$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5JDHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54e45b65655165e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $b5IAe = parcelRequire("b5IAe");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bJdnT = parcelRequire("bJdnT");

var $fVRXn = parcelRequire("fVRXn");
const $e54e45b65655165e$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const label = project.isFavorite ? formatMessage((0, $bJdnT.default).unstar) : formatMessage((0, $bJdnT.default).star);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const star = !project.isFavorite;
        onToggle(star);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
            projectId: project.id,
            star: star
        });
    }, [
        project,
        onToggle,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVRXn.Button), {
        isFavorite: project.isFavorite ?? false,
        onClick: onClick,
        "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
    }, project.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        label: label
    }))));
};
var $e54e45b65655165e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e54e45b65655165e$var$FavoriteButton);

});
parcelRegister("bJdnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b07613b1e7eec39$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b07613b1e7eec39$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    star: {
        "id": "spa-apps-sidebar-core.common.favorite-button.star",
        "defaultMessage": "Add to Starred"
    },
    unstar: {
        "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
        "defaultMessage": "Remove from Starred"
    }
});

});

parcelRegister("fVRXn", function(module, exports) {

$parcel$export(module.exports, "Button", () => $2b3f0059348a9897$export$353f5b6fc5456de1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $2b3f0059348a9897$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4v77o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $2b3f0059348a9897$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
            __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
            __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("8RzJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e313fba1125d29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $kMUsV = parcelRequire("kMUsV");

var $4q3vw = parcelRequire("4q3vw");
const $37e313fba1125d29$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
const $37e313fba1125d29$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
            projectId: project.id,
            starred: project.isFavorite,
            current: true
        });
    }, [
        createAnalyticsEvent,
        project
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), {
        testId: $37e313fba1125d29$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
        project: project,
        to: to,
        isActive: true,
        onClick: onClick,
        onFavoriteToggle: onFavoriteToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4q3vw.default), null));
};
var $37e313fba1125d29$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($37e313fba1125d29$var$ActiveProject);

});
parcelRegister("4q3vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5df3a65802a7af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $exb0h = parcelRequire("exb0h");

var $hzZWH = parcelRequire("hzZWH");

var $zMQ0U = parcelRequire("zMQ0U");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $kFwR2 = parcelRequire("kFwR2");
var $k5Z6m = parcelRequire("k5Z6m");

var $4ZQun = parcelRequire("4ZQun");

var $44AZS = parcelRequire("44AZS");

var $bp2TG = parcelRequire("bp2TG");

var $8Xc28 = parcelRequire("8Xc28");

var $aZ40y = parcelRequire("aZ40y");
const $eb5df3a65802a7af$var$calculateStack = (route, connectStack, forgeStack)=>{
    const routeName = route && route.name || '';
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
    return [];
};
const $eb5df3a65802a7af$var$ProjectMenu = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $k5Z6m.default)();
    const { data: features, loading: isFeaturesLoading } = (0, $kFwR2.useFeatures)();
    const { stack: connectProjectStack } = (0, $kFwR2.useProjectConnectItems)();
    const { stack: connectReportsStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const { stack: connectSettingsStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
    const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES).FORGE_PROJECT);
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
    let content = null;
    if ((0, $lg3mT.ISSUES_ROUTES_SET).has(route.name)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bp2TG.default), {
        project: project
    });
    else if ((0, $lg3mT.REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xc28.default), null);
    else if ((0, $lg3mT.SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE || connectSettingsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZ40y.default), {
        project: project
    });
    else if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) || forgeStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44AZS.default), null);
    else if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZQun.default), {
        stack: stack,
        onStackChange: setStack,
        project: project
    });
    else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: (0, $lg3mT.MENU_ID),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5df3a65802a7af$export$42a852a2b6b56249, null, content));
};
const $eb5df3a65802a7af$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
            __cmplp.className
        ])
    });
});
var $eb5df3a65802a7af$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($eb5df3a65802a7af$var$ProjectMenu);

});
parcelRegister("hzZWH", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $9c9a74070e1186f3$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $9c9a74070e1186f3$export$bc7f6eebc16e6127);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8WuJm = parcelRequire("8WuJm");

var $cPEpP = parcelRequire("cPEpP");

var $eEZvV = parcelRequire("eEZvV");
const $9c9a74070e1186f3$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            viewId: (0, $eEZvV.generateViewId)(menuId, ...stack),
            navVersion: '3',
            navigationLayer: 'container'
        }
    });
const $9c9a74070e1186f3$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $cPEpP.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("eEZvV", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $ff2c3a925d418d98$export$5b5545ed894dc47a);
const $ff2c3a925d418d98$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("zMQ0U", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $9e96c2833d013144$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $9e96c2833d013144$export$80e84933a3e2f677);

var $eUqFw = parcelRequire("eUqFw");

var $fTsDx = parcelRequire("fTsDx");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $iZJHG = parcelRequire("iZJHG");

var $6ibpp = parcelRequire("6ibpp");
const $9e96c2833d013144$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)(projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(projectData, routeName);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const context = projectContext ? {
        projectKey: projectContext.projectKey,
        projectId: projectContext.projectId,
        projectName: projectContext.projectName,
        projectType: projectContext.projectType,
        isProjectAdmin: projectContext.isProjectAdmin,
        isProjectArchived: projectContext.isProjectArchived
    } : {};
    return (0, $eUqFw.useMemo)(()=>({
            data: projectData ? projectData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack,
        context
    ]);
};
const $9e96c2833d013144$export$80e84933a3e2f677 = (projectKey)=>$9e96c2833d013144$export$338edd25edcf3648(undefined, projectKey);

});
parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("6ibpp", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $f4e8d0de7e963f6a$export$462f82a278743d46);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $eOutC = parcelRequire("eOutC");

var $jMYeN = parcelRequire("jMYeN");
const $f4e8d0de7e963f6a$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $jMYeN.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("eOutC", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $503fa4d7a9769196$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $503fa4d7a9769196$export$25abed85383f0fbb);

var $eUqFw = parcelRequire("eUqFw");

var $70ON1 = parcelRequire("70ON1");
const $503fa4d7a9769196$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eUqFw.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $70ON1.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $503fa4d7a9769196$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});

parcelRegister("jMYeN", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $eb609126a990fbb2$export$29678d1e04c0e8c4);

var $5iWql = parcelRequire("5iWql");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $eb609126a990fbb2$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $eb609126a990fbb2$export$29678d1e04c0e8c4 = (0, $5iWql.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($eb609126a990fbb2$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($eb609126a990fbb2$var$normalizeSection);
    return [];
});

});



parcelRegister("kFwR2", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $07989a85c9068e6d$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useProjectConnectItems", () => $07989a85c9068e6d$export$f23d0c24c77d7608);
$parcel$export(module.exports, "useProjectReportsConnectItems", () => $07989a85c9068e6d$export$a1c75c386c088992);
$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $07989a85c9068e6d$export$41a50100db18b578);
$parcel$export(module.exports, "useProjectSettingsForgeItems", () => $07989a85c9068e6d$export$84761bbf25a4f51f);

var $c4mKR = parcelRequire("c4mKR");

var $kIUmN = parcelRequire("kIUmN");

var $2jFgb = parcelRequire("2jFgb");
var $fpWGf = parcelRequire("fpWGf");
var $2RJCt = parcelRequire("2RJCt");

var $j65a5 = parcelRequire("j65a5");

var $bRhBg = parcelRequire("bRhBg");

var $k5Z6m = parcelRequire("k5Z6m");

var $asnZU = parcelRequire("asnZU");
const $07989a85c9068e6d$export$4a39035bacc4ed76 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useFeatures));
const $07989a85c9068e6d$export$f23d0c24c77d7608 = (0, $kIUmN.withThrowOnError)((0, $2jFgb.useProjectConnectItems));
const $07989a85c9068e6d$export$a1c75c386c088992 = (0, $kIUmN.withThrowOnError)((0, $fpWGf.useProjectReportsConnectItems));
const $07989a85c9068e6d$export$41a50100db18b578 = (0, $kIUmN.withThrowOnError)((0, $2RJCt.useProjectSettingsConnectItems));
const $07989a85c9068e6d$export$84761bbf25a4f51f = (0, $j65a5.useProjectSettingsForgeAppsForMenu);
const $07989a85c9068e6d$export$96e8a0c1f4717705 = (0, $kIUmN.withThrowOnError)((0, $c4mKR.useJiraWorkManagementProjectPagesLink));

});
parcelRegister("c4mKR", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $17dbd504b329aecd$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $17dbd504b329aecd$export$96e8a0c1f4717705);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $2futN = parcelRequire("2futN");
const $17dbd504b329aecd$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
const $17dbd504b329aecd$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $17dbd504b329aecd$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $17dbd504b329aecd$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$disablePagesLinkUrl(baseUrl, projectKey));
const $17dbd504b329aecd$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $17dbd504b329aecd$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $17dbd504b329aecd$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $17dbd504b329aecd$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("kIUmN", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f76cf1e1bf710aa4$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $asu8X = parcelRequire("asu8X");
const $f76cf1e1bf710aa4$var$isDataEmpty = (data)=>data == null;
function $f76cf1e1bf710aa4$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $asu8X.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f76cf1e1bf710aa4$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("2jFgb", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $5f83aec5eda9bdea$export$f23d0c24c77d7608);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
const $5f83aec5eda9bdea$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $5f83aec5eda9bdea$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $5f83aec5eda9bdea$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("9I91h", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $d193dad52b41fe54$export$751e2e6237002565);

var $hTLlD = parcelRequire("hTLlD");

var $exb0h = parcelRequire("exb0h");
// JSPA-1062 remove qs items that might not always be there
const $d193dad52b41fe54$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $d193dad52b41fe54$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $d193dad52b41fe54$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $exb0h.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $d193dad52b41fe54$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $d193dad52b41fe54$var$splitRelevantQs(itemQs);
        const sameQuery = $d193dad52b41fe54$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $d193dad52b41fe54$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("kNXHh", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $2d642e9f9a6a4f93$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $2d642e9f9a6a4f93$export$27267b6b6650eaa5);
const $2d642e9f9a6a4f93$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($2d642e9f9a6a4f93$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $2d642e9f9a6a4f93$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($2d642e9f9a6a4f93$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("fpWGf", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $45778cdd51b28ac7$export$a1c75c386c088992);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
const $45778cdd51b28ac7$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $45778cdd51b28ac7$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data != null ? data.map((0, $kNXHh.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $45778cdd51b28ac7$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("2RJCt", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $06b43f573ecea160$export$41a50100db18b578);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $06b43f573ecea160$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $06b43f573ecea160$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $06b43f573ecea160$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("j65a5", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $952e927805fb78ba$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $952e927805fb78ba$export$b741e3e3cfb39b82);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $2Rqjr = parcelRequire("2Rqjr");

var $fTsDx = parcelRequire("fTsDx");

var $70ON1 = parcelRequire("70ON1");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $3HCkE = parcelRequire("3HCkE");

var $gd0Sp = parcelRequire("gd0Sp");

var $jMYeN = parcelRequire("jMYeN");
var $6ibpp = parcelRequire("6ibpp");
const $952e927805fb78ba$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $l90Gp.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const hasPermissions = (0, $eUqFw.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    const context = (0, $eUqFw.useMemo)(()=>projectContext ? {
            projectKey: projectContext.projectKey,
            projectId: projectContext.projectId,
            projectName: projectContext.projectName,
            projectType: projectContext.projectType
        } : {}, [
        projectContext
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions,
        context
    ]);
};
const $952e927805fb78ba$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $952e927805fb78ba$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$952e927805fb78ba$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $952e927805fb78ba$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = $952e927805fb78ba$export$bef2e514007d2f07();
    const stack = (0, $6ibpp.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $eUqFw.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $952e927805fb78ba$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $jMYeN.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});

parcelRegister("bRhBg", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $8d33e1dc80dc383e$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useSettingFeatures", () => $8d33e1dc80dc383e$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useReportFeatures", () => $8d33e1dc80dc383e$export$4adaea9828b7ff13);

var $eUqFw = parcelRequire("eUqFw");

var $eL2Xo = parcelRequire("eL2Xo");
var $2futN = parcelRequire("2futN");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");

var $ly8Gh = parcelRequire("ly8Gh");
const $8d33e1dc80dc383e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraData)(data, isPremiumUserSeat), [
        data,
        isPremiumUserSeat
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$56022a3b83c8ed6a = ()=>{
    const hasActiveSoftwareAccess = (0, $eL2Xo.useHasActiveSoftwareAccess)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraSettingsData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$4adaea9828b7ff13 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraReportData)(hasSoftwareAccess), [
        data,
        hasSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eL2Xo", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $154cbdbba7c6a38b$export$895f9b38ce00671e);

var $ab6rA = parcelRequire("ab6rA");
var $fz8wa = parcelRequire("fz8wa");
const $154cbdbba7c6a38b$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});
parcelRegister("fz8wa", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d53bf78e5b3b7ada$export$4d9cadb4042acc1b);

var $df4Sl = parcelRequire("df4Sl");

var $dYfll = parcelRequire("dYfll");

var $k4yit = parcelRequire("k4yit");

var $gd0Sp = parcelRequire("gd0Sp");
const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $dYfll.createSubscriber)((0, $k4yit.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d53bf78e5b3b7ada$var$selector
});
const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("ly8Gh", function(module, exports) {

$parcel$export(module.exports, "getExtraData", () => $755f4ca371b0583d$export$6c55c6c980ed2046);
$parcel$export(module.exports, "getExtraSettingsData", () => $755f4ca371b0583d$export$b77a5597b7177cfb);
$parcel$export(module.exports, "getExtraReportData", () => $755f4ca371b0583d$export$be58a1e7b06d1d3);
const $755f4ca371b0583d$export$6c55c6c980ed2046 = (data, isPremium)=>{
    const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
    const isSimplifiedProject = project.simplified;
    return {
        hasVersions: true,
        hasSettings: isProjectOrJiraAdmin,
        hasBoard: true,
        hasReports: true,
        hasAddItem: isProjectOrJiraAdmin,
        hasComponents: hasComponents,
        hasIssues: true,
        hasSummary: true,
        hasPages: true,
        hasChangeTheme: isProjectOrJiraAdmin,
        hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
    };
};
const $755f4ca371b0583d$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
    const hasDetails = isProjectOrJiraAdmin;
    const hasPeople = isProjectOrJiraAdmin;
    const hasSummary = true;
    const hasIssueTypes = isAdmin;
    const hasWorkflows = true;
    const hasScreens = true;
    const hasFields = true;
    const hasVersions = true;
    const hasComponents = true;
    const hasPermissions = true;
    const hasIssueSecurity = true;
    const hasNotifications = true;
    const hasIssueCollectors = true;
    const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
    return {
        hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
        hasIssueConfigSection: hasIssueTypes,
        hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasFields,
        hasProjectGroupThreeSection: hasVersions || hasComponents,
        hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
        hasgetIssueCollectorSection: hasIssueCollectors,
        hasComponents: hasComponents,
        hasDetails: hasDetails,
        hasFields: hasFields,
        hasIssueCollectors: hasIssueCollectors,
        hasIssueSecurity: hasIssueSecurity,
        hasIssueTypes: hasIssueTypes,
        hasNotifications: hasNotifications,
        hasPeople: hasPeople,
        hasPermissions: hasPermissions,
        hasScreens: hasScreens,
        hasSummary: hasSummary,
        hasVersions: hasVersions,
        hasWorkflows: hasWorkflows,
        hasDevtools: hasDevtools
    };
};
const $755f4ca371b0583d$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
        hasDeveloperWorkload: true,
        hasForcastSection: true,
        hasTimeTracking: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});


parcelRegister("k5Z6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6745ef0d4252c6$export$2e2bcd8739ae039);

var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");
const $3f6745ef0d4252c6$var$useProject = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
var $3f6745ef0d4252c6$export$2e2bcd8739ae039 = $3f6745ef0d4252c6$var$useProject;

});

parcelRegister("asnZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d95c59af01c6e5a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $7d95c59af01c6e5a$var$useAutoExpandSidebar = ()=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const sidebarExpandedRef = (0, $eUqFw.useRef)(!isCollapsed);
    (0, $eUqFw.useEffect)(()=>{
        if (!sidebarExpandedRef.current && isCollapsed) {
            expandLeftSidebar();
            sidebarExpandedRef.current = true;
        }
    }, [
        expandLeftSidebar,
        isCollapsed
    ]);
};
var $7d95c59af01c6e5a$export$2e2bcd8739ae039 = $7d95c59af01c6e5a$var$useAutoExpandSidebar;

});


parcelRegister("4ZQun", function(module, exports) {

$parcel$export(module.exports, "default", () => $812aa24afbef38fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWYQ8 = parcelRequire("aWYQ8");
var $2jFgb = parcelRequire("2jFgb");

var $asnZU = parcelRequire("asnZU");

var $6D5Hl = parcelRequire("6D5Hl");
const $812aa24afbef38fd$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
    (0, $asnZU.default)();
    const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, $2jFgb.useProjectConnectItems)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectKey = String(project?.key);
    const getBackMenuItem = (0, $eUqFw.useCallback)(()=>({
            href: `/jira/core/projects/${projectKey}`,
            title: formatMessage((0, $6D5Hl.messages).itemBack)
        }), [
        formatMessage,
        projectKey
    ]);
    if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: onStackChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWYQ8.ConnectMenu), {
        items: connectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: getBackMenuItem(),
            navigateOnBackMenuItemClick: true
        }
    })));
    return null;
};
var $812aa24afbef38fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($812aa24afbef38fd$var$ConnectAppMenu);

});
parcelRegister("8N3rk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $cc821c64d466644f$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $cc821c64d466644f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lSV8Z = parcelRequire("lSV8Z");

var $bM0x9 = parcelRequire("bM0x9");

var $9iAqW = parcelRequire("9iAqW");

var $1Z5iN = parcelRequire("1Z5iN");

var $cgrgx = parcelRequire("cgrgx");

var $C037h = parcelRequire("C037h");
function $cc821c64d466644f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc821c64d466644f$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $cc821c64d466644f$var$nestableNavigationContentStyles = {
    name: "hxjswn",
    styles: "height:100%;position:relative;outline:none"
};
const $cc821c64d466644f$var$nestingRootStyles = {
    name: "1klp5xc",
    styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
};
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $cc821c64d466644f$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator } = props;
    const [committedStack, setCommittedStack] = (0, $eUqFw.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $cc821c64d466644f$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eUqFw.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $bM0x9.default), props, "Go back");
    const { childIdsRef: childIdsRef } = (0, $1Z5iN.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eUqFw.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eUqFw.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId
    });
    const context = (0, $eUqFw.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $cc821c64d466644f$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $cc821c64d466644f$var$nestableNavigationContentStyles,
        ref: containerRef,
        tabIndex: -1,
        onClick: manageFocus
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $C037h.NestingMotion), {
        // Key is needed to have a unique react instance per stack name.
        // This enables us to easily animate it in & out with exiting persistence.
        key: currentStackId,
        enterFrom: transition === 'nesting' ? 'right' : 'left',
        exitTo: transition === 'nesting' ? 'left' : 'right',
        testId: testId && `${testId}-anim`
    }, (motion)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $cc821c64d466644f$var$nestingRootStyles,
            ...motion
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
            // This provider is inside the NestingMotion to ensure it keeps a stale
            // reference to the previous value.
            value: context
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9iAqW.default), {
            title: "",
            id: $cc821c64d466644f$export$ec71a3379b43ae5c
        }, children)))))));
};
var $cc821c64d466644f$export$2e2bcd8739ae039 = $cc821c64d466644f$var$NestableNavigationContent;

});
parcelRegister("bM0x9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f212f85e4c65f98$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fyp42 = parcelRequire("fyp42");

var $PdmhA = parcelRequire("PdmhA");

var $iaRDX = parcelRequire("iaRDX");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $4f212f85e4c65f98$var$GoBackItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
    secondaryColor: `var(--ds-surface, ${(0, $PdmhA.N10)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaRDX.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $4f212f85e4c65f98$export$2e2bcd8739ae039 = $4f212f85e4c65f98$var$GoBackItem;

});
parcelRegister("fyp42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b52d792fd039ccff$var$_react = $b52d792fd039ccff$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b52d792fd039ccff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b52d792fd039ccff$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $b52d792fd039ccff$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 000-1.421.996.996 0 00-1.415 0l-2.978 2.994a1.01 1.01 0 000 1.423l2.978 2.993a.999.999 0 001.415 0 1.01 1.01 0 000-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005 0-.555-.448-1.005-1-1.005" fill="inherit"/></svg>`
    }, props));
$b52d792fd039ccff$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $b52d792fd039ccff$var$_default = $b52d792fd039ccff$var$ArrowLeftCircleIcon;
module.exports.default = $b52d792fd039ccff$var$_default;

});

parcelRegister("iaRDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $214046ccd34b0757$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $214046ccd34b0757$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $214046ccd34b0757$export$2e2bcd8739ae039 = $214046ccd34b0757$var$ButtonItem;

});


parcelRegister("9iAqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $56cec1d16683bfce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $k4jc8 = parcelRequire("k4jc8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $jvM56 = parcelRequire("jvM56");

var $iaRDX = parcelRequire("iaRDX");
var $gMdj1 = parcelRequire("gMdj1");
var $8ZwXC = parcelRequire("8ZwXC");

var $8N3rk = parcelRequire("8N3rk");

var $cgrgx = parcelRequire("cgrgx");

var $1Z5iN = parcelRequire("1Z5iN");

var $kJUBw = parcelRequire("kJUBw");
const $56cec1d16683bfce$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline'
});
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $56cec1d16683bfce$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator } = (0, $cgrgx.useNestedContext)();
    const mergedStyles = (0, $jvM56.overrideStyleFunction)((0, $kJUBw.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`
    }) || contextualBackButton;
    const context = (0, $eUqFw.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator
    ]);
    (0, $1Z5iN.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
        value: context
    }, stack.length >= 1 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingBlock: "space.075",
        paddingInline: "space.100"
    }, backButton), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8ZwXC.default), {
        testId: testId,
        showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
    }, children));
    if ([
        (0, $8N3rk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, iconAfter ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            "data-custom-icon": true,
            as: "span"
        }, iconAfter) : null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            "data-right-arrow": true,
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            as: "span"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k4jc8))), {
            testId: testId && `${testId}--item--right-arrow`,
            secondaryColor: `var(--ds-surface, ${(0, $PdmhA.N10)})`,
            label: ""
        }))),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iaRDX.default), componentProps);
};
var $56cec1d16683bfce$export$2e2bcd8739ae039 = $56cec1d16683bfce$var$NestingItem;

});
parcelRegister("k4jc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9c31206c0c7e54b$var$_react = $e9c31206c0c7e54b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e9c31206c0c7e54b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e9c31206c0c7e54b$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $e9c31206c0c7e54b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"/><path d="M12.314 8.294a1.01 1.01 0 000 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005 0 .555.448 1.005 1.001 1.005h5.585l-1.271 1.279a1.01 1.01 0 000 1.422 1.001 1.001 0 001.415 0l2.978-2.995a1.01 1.01 0 000-1.422l-2.978-2.995a.998.998 0 00-1.415 0z" fill="inherit"/></g></svg>`
    }, props));
$e9c31206c0c7e54b$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $e9c31206c0c7e54b$var$_default = $e9c31206c0c7e54b$var$ArrowRightCircleIcon;
module.exports.default = $e9c31206c0c7e54b$var$_default;

});

parcelRegister("gMdj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5254fde102c89aa1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $eUqFw = parcelRequire("eUqFw");

var $e7PSD = parcelRequire("e7PSD");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $5254fde102c89aa1$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $5254fde102c89aa1$export$2e2bcd8739ae039 = $5254fde102c89aa1$var$CustomItem;

});

parcelRegister("8ZwXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79677661d4a83719$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxAkq = parcelRequire("dxAkq");

var $cgrgx = parcelRequire("cgrgx");

var $3KfxB = parcelRequire("3KfxB");
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $79677661d4a83719$var$NavigationContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    const scrollbar = (0, $dxAkq.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: typedRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $3KfxB.outerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator,
            scrollbarWidth: scrollbar.width
        }),
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: scrollbar.ref,
        css: (0, $3KfxB.innerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $3KfxB.containerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, children)));
});
var $79677661d4a83719$export$2e2bcd8739ae039 = $79677661d4a83719$var$NavigationContent;

});
parcelRegister("dxAkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bf491fcf88b5a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $61bf491fcf88b5a3$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eUqFw.useState)(0);
    const elementRef = (0, $eUqFw.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});

parcelRegister("3KfxB", function(module, exports) {

$parcel$export(module.exports, "outerContainerCSS", () => $cbf9fac083377857$export$3ff462c0176a504f);
$parcel$export(module.exports, "innerContainerCSS", () => $cbf9fac083377857$export$4d1aec15cfcfc2a4);
$parcel$export(module.exports, "containerCSS", () => $cbf9fac083377857$export$949392aeaf7d2e3a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

const $cbf9fac083377857$var$scrollIndicatorMaskZIndex = 2;
const $cbf9fac083377857$var$scrollIndicatorZIndex = 1;
const $cbf9fac083377857$var$scrollIndicatorHeight = 2;
const $cbf9fac083377857$var$scrollIndicatorBorderRadius = '1px';
const $cbf9fac083377857$var$containerPadding = 8;
const $cbf9fac083377857$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $cbf9fac083377857$var$skeletonHeadingHeight = $cbf9fac083377857$var$containerPadding;
const $cbf9fac083377857$var$skeletonHeadingMarginOffset = 3;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $cbf9fac083377857$var$skeletonHeadingTopMargin = $cbf9fac083377857$var$containerPadding * 2.5 + ($cbf9fac083377857$var$itemHeadingContentHeight - $cbf9fac083377857$var$skeletonHeadingHeight) - $cbf9fac083377857$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $cbf9fac083377857$var$skeletonHeadingBottomMargin = $cbf9fac083377857$var$containerPadding * 0.75 + $cbf9fac083377857$var$skeletonHeadingMarginOffset;
const $cbf9fac083377857$export$3ff462c0176a504f = (opts)=>({
        // Flex is needed to ensure the overflow indicators are positioned correctly.
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
            content: "''",
            display: 'block',
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $PdmhA.N30})`})`,
            position: 'absolute',
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex
        },
        '&::after': {
            content: "''",
            position: 'absolute',
            display: 'block',
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            bottom: 0,
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $PdmhA.N30})`})`
        }
    });
const $cbf9fac083377857$export$4d1aec15cfcfc2a4 = (opts)=>({
        display: 'flex',
        overflow: 'auto',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        flexDirection: 'column',
        // This before pseudo element is works by being positioned at the top of this scrolling
        // container - so when you scroll down it stops "masking" the actual scroll indicator.
        ...!opts.showTopScrollIndicator && {
            '&::before': {
                borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
                content: "''",
                left: 0,
                right: 0,
                height: $cbf9fac083377857$var$scrollIndicatorHeight,
                backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $PdmhA.N10})`})`,
                position: 'absolute',
                display: 'block',
                zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex
            }
        },
        // This after pseudo element abuses being a flex child and pushes itself down to the
        // very bottom of the container - doing so ends up "masking" the actual scroll indicator.
        '&::after': {
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            content: "''",
            display: 'block',
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            // This is used to "push" the element to the bottom of the flex container.
            marginTop: 'auto',
            position: 'relative',
            zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $PdmhA.N10})`})`
        }
    });
const $cbf9fac083377857$export$949392aeaf7d2e3a = (opts)=>({
        // When the scroll indicator is always shown we need to add some padding
        // so the spacing between matches what it would be if the indicator was a "block" element.
        // We use margin here so any child absolutely positioned elements are positioned correctly.
        marginTop: opts.showTopScrollIndicator ? $cbf9fac083377857$var$scrollIndicatorHeight : 0,
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        // Enables child absolutely positioned elements to be positioned relative to this element.
        position: 'relative',
        '& [data-ds--menu--heading-item]': {
            marginBottom: "var(--ds-space-075, 6px)",
            marginTop: "var(--ds-space-200, 16px)"
        },
        '& [data-ds--menu--skeleton-heading-item]': {
            marginTop: $cbf9fac083377857$var$skeletonHeadingTopMargin,
            marginBottom: $cbf9fac083377857$var$skeletonHeadingBottomMargin
        }
    });

});
const $653c080b5250656d$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $653c080b5250656d$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';



parcelRegister("1Z5iN", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $757bdf2b7228d1ef$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $757bdf2b7228d1ef$export$ea18c2b5f0e24612);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
const $757bdf2b7228d1ef$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eUqFw.useRef)(new Set());
    (0, $eUqFw.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $8N3rk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $757bdf2b7228d1ef$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("kJUBw", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $a9d327ba12673c0a$export$38e770f85519b259);
const $a9d327ba12673c0a$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $a9d327ba12673c0a$var$disabledCSS : $a9d327ba12673c0a$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("C037h", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $2EVgw = parcelRequire("2EVgw");
const $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EVgw.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: (_)=>(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
    }, (innerProps, direction)=>children({
            'data-enter-from': enterFrom,
            'data-exit-to': exitTo,
            'data-testid': testId && `${testId}-${direction}`,
            ...innerProps
        }));
};

});


parcelRegister("aWYQ8", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $449294194ac94025$export$19d0925d424b864a);

var $eUqFw = parcelRequire("eUqFw");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");
const $449294194ac94025$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $9ui8T.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("9ui8T", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $e919628f42726628$export$79762159776e61da);

var $eUqFw = parcelRequire("eUqFw");

var $bgNoL = parcelRequire("bgNoL");
const $e919628f42726628$export$79762159776e61da = (items, shouldFilter = true)=>(0, $eUqFw.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation"'.
        return items?.filter((item)=>!(0, $bgNoL.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fDNHa", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $689f0217773f024d$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $aqZcy = parcelRequire("aqZcy");
var $5RTd0 = parcelRequire("5RTd0");

var $422mK = parcelRequire("422mK");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $aDEKA = parcelRequire("aDEKA");
var $2DHQu = parcelRequire("2DHQu");
var $9kVcv = parcelRequire("9kVcv");
const $689f0217773f024d$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $422mK.useConnectItemClickHistory)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $eUqFw.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $eUqFw.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        item.url != null && addNew(item.url);
    }, [
        addNew,
        isNested,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDEKA.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $bS2FN.matchUrlExact)(),
        iconBefore: icon,
        href: item.url,
        legacyClassName: item.styleClass,
        onClick: onItemClick,
        ref: /*#__PURE__*/ (0, $eUqFw.createRef)()
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689f0217773f024d$var$ConnectIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5RTd0", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $c190ea8c356dcf3d$export$93509ff9a62ee022);

var $fT6gI = parcelRequire("fT6gI");
const $c190ea8c356dcf3d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $fT6gI.setStrictlyNecessaryCookie)(key, value, attributes);
};

});
parcelRegister("fT6gI", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $b910dae8829db4f5$export$93509ff9a62ee022);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");
const $b910dae8829db4f5$export$93509ff9a62ee022 = (key, value, attributes)=>{
    try {
        if ((0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls')) (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("422mK", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $e1e0c0027f44f3f6$export$c251e3fda1cce4a3);

var $eUqFw = parcelRequire("eUqFw");
// A single instance for the entire SPA session
const $e1e0c0027f44f3f6$var$history = {
    unique: []
};
const $e1e0c0027f44f3f6$export$c251e3fda1cce4a3 = ()=>{
    const addNew = (0, $eUqFw.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $e1e0c0027f44f3f6$var$history.unique.push(historyItem);
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            history: $e1e0c0027f44f3f6$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $e1e0c0027f44f3f6$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $e1e0c0027f44f3f6$var$history.unique.length = 0;
};

});

parcelRegister("bS2FN", function(module, exports) {

$parcel$export(module.exports, "matchUrlPathname", () => $efb2bb2763c0ed39$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $efb2bb2763c0ed39$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $efb2bb2763c0ed39$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $efb2bb2763c0ed39$export$63fdecce99465869);

var $046kq = parcelRequire("046kq");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $efb2bb2763c0ed39$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $efb2bb2763c0ed39$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$var$cleanPath(currentLocation.pathname) === $efb2bb2763c0ed39$var$cleanPath(itemLocation.pathname);
const $efb2bb2763c0ed39$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $efb2bb2763c0ed39$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($046kq)))(currentLocation.query, itemLocation.query);
const $efb2bb2763c0ed39$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("1UelU", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $df864800942e4b9a$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $gMdj1 = parcelRequire("gMdj1");

var $PdmhA = parcelRequire("PdmhA");

var $kJlBc = parcelRequire("kJlBc");

var $8n4Bi = parcelRequire("8n4Bi");

var $lPCnq = parcelRequire("lPCnq");
var $foHkv = parcelRequire("foHkv");
const $df864800942e4b9a$var$WrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df864800942e4b9a$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $df864800942e4b9a$var$customCssFn = (currentState = {})=>({
        '[data-item-title]': {
            lineHeight: 1.2
        },
        /* fixes CSS leaking from the monolith */ ...currentState.isSelected && {
            '& [data-item-title]': {
                color: "var(--ds-text-selected, rgb(12, 102, 228))"
            }
        },
        /* fixes CSS leaking from the monolith */ '&:focus, &:visited, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
            boxShadow: "var(--ds-shadow-overlay, transparent)",
            '& [data-item-title]': {
                color: "var(--ds-text, rgb(66, 82, 110))"
            }
        },
        '&:focus': {
            boxShadow: `${`var(--ds-border-focused, ${0, $PdmhA.B200})`} 0 0 0 2px inset`
        },
        /* fixes CSS for react-beautiful-dnd */ '&[data-rbd-draggable-id]': {
            cursor: 'pointer'
        }
    });
const $df864800942e4b9a$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $foHkv.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $kJlBc.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useCallback)((currentState)=>({
            ...outsideCssFn && outsideCssFn(currentState),
            ...$df864800942e4b9a$var$customCssFn(currentState),
            ...(0, $lPCnq.getCustomThemeCss)(theme)
        }), [
        theme,
        outsideCssFn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $df864800942e4b9a$var$WrapperComponent,
        cssFn: cssFn,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined
    };
    return overrides?.CustomItem?.render(customProps) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMdj1.default), customProps);
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df864800942e4b9a$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8n4Bi", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $3f50a441bbce6f7c$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $3f50a441bbce6f7c$export$b1a81b4626bc52c3);

var $eUqFw = parcelRequire("eUqFw");
const $3f50a441bbce6f7c$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3f50a441bbce6f7c$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f50a441bbce6f7c$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $3f50a441bbce6f7c$export$b1a81b4626bc52c3 = ()=>(0, $eUqFw.useContext)($3f50a441bbce6f7c$var$ThemeContext);

});

parcelRegister("lPCnq", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeCss", () => $6275288bde4e93f8$export$cc5a98b66b3e9306);
const $6275288bde4e93f8$export$cc5a98b66b3e9306 = (theme)=>{
    if (theme?.navigation) {
        const { navigation: { item: item, icon: icon } } = theme;
        return {
            backgroundColor: item?.background?.default ?? undefined,
            color: item?.color?.default ?? undefined,
            '& [data-item-title]': {
                color: item?.color?.default ?? undefined
            },
            '&:hover': {
                color: item?.color?.hover ?? undefined,
                backgroundColor: item?.background?.hover ?? undefined
            },
            /* fixes CSS leaking from the monolith */ '&:focus, &:visited': {
                color: item?.color?.default
            },
            '&:active': {
                color: item?.color?.active ?? undefined,
                backgroundColor: item?.background?.active ?? undefined
            },
            '&:active [data-item-title]': {
                color: item?.color?.active ?? undefined
            },
            '&:active [data-item-elem-before]': {
                color: item?.color?.active ?? undefined
            },
            '&:focus': {
                boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
            },
            '&[aria-current="page"]': {
                position: 'relative',
                backgroundColor: item?.background?.active ?? undefined,
                color: item?.color?.active ?? undefined
            },
            '&[aria-current="page"]:before': {
                background: item?.color?.active ?? undefined
            },
            '& [data-item-elem-after]': {
                color: icon?.secondary?.color?.hover ?? undefined
            }
        };
    }
    return {};
};

});

parcelRegister("foHkv", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $0b0be38cfe8462be$export$a81c45382e7253ac);

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $0b0be38cfe8462be$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("aDEKA", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $94d555cec3b0ee42$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $94d555cec3b0ee42$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $94d555cec3b0ee42$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $94d555cec3b0ee42$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $94d555cec3b0ee42$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $94d555cec3b0ee42$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $94d555cec3b0ee42$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationHeaderWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $94d555cec3b0ee42$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationContentWrapperContainer, {
        // @ts-expect-error - TS2322 - Type '{ children: ReactNode; navModuleLabelsHidden: boolean | undefined; nestedAppOpen: boolean | undefined; context: string | undefined; submenuActive: boolean | undefined; nestedMenuOpen: boolean | undefined; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
        navModuleLabelsHidden: props.navModuleLabelsHidden,
        nestedAppOpen: props.nestedAppOpen,
        context: props.context,
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $94d555cec3b0ee42$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ExpandableProjectContainer, null, props.children);
const $94d555cec3b0ee42$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94d555cec3b0ee42$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $9t7rW.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $9t7rW.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $c9TLT.gridSize), "px"),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2DHQu", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $caee9921c40abec1$export$4c594f24f8e4128a);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $2vzCR = parcelRequire("2vzCR");

var $fyp42 = parcelRequire("fyp42");

var $9iAqW = parcelRequire("9iAqW");

var $4C6RK = parcelRequire("4C6RK");

var $1UelU = parcelRequire("1UelU");

var $k4ysj = parcelRequire("k4ysj");
var $cFBmm = parcelRequire("cFBmm");

var $8n4Bi = parcelRequire("8n4Bi");

var $5vmRt = parcelRequire("5vmRt");

var $hLkCn = parcelRequire("hLkCn");
const $caee9921c40abec1$var$customCssFn = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $cFBmm.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStateAndStyles, newStyle);
});
const $caee9921c40abec1$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", props, props.children);
const $caee9921c40abec1$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const backButtonCssFn = (0, $k4ysj.generateBackButtonCssFn)(theme);
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eUqFw.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eUqFw.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $hLkCn.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            cssFn: backButtonCssFn
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backButtonCssFn,
        backTitle
    ]);
    const renderCustomItem = (0, $eUqFw.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iAqW.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $caee9921c40abec1$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
                customItemCssFn,
                $caee9921c40abec1$var$customCssFn
            ]) : $caee9921c40abec1$var$customCssFn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("k4ysj", function(module, exports) {

$parcel$export(module.exports, "generateBackButtonCssFn", () => $3713137157573d1a$export$56644251c3f2ea82);
const $3713137157573d1a$export$56644251c3f2ea82 = (theme)=>()=>{
        if (theme?.navigation) {
            const { icon: icon } = theme.navigation;
            return {
                '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                    color: icon?.secondary?.color?.active ?? undefined
                }
            };
        }
        return {};
    };

});

parcelRegister("cFBmm", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $3a6f1f8fdf334108$export$d722961e96b459c5);

var $2vzCR = parcelRequire("2vzCR");

var $c9TLT = parcelRequire("c9TLT");

var $5vmRt = parcelRequire("5vmRt");
const $3a6f1f8fdf334108$export$d722961e96b459c5 = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $c9TLT.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, newStyle);
});

});
parcelRegister("5vmRt", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $a9f42b05cf11af4c$export$3f662b014fa1806e);
function $a9f42b05cf11af4c$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $a9f42b05cf11af4c$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
const $a9f42b05cf11af4c$export$91011a0a572ef910 = {
    CONNECTED: 'CONNECTED',
    INCOMPLETE: 'INCOMPLETE',
    INITIAL: 'INITIAL',
    SEEN: 'SEEN',
    UNCONNECTED: 'UNCONNECTED'
};

});


parcelRegister("hLkCn", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $82cbad75889ad869$export$729f3684d5c2b9b9);
const $82cbad75889ad869$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("9kVcv", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $097fe38bc39869b0$export$de3705f3d2162955);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $8SnT0 = parcelRequire("8SnT0");

var $8n4Bi = parcelRequire("8n4Bi");

var $dHQr5 = parcelRequire("dHQr5");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $097fe38bc39869b0$var$overrideStyles = (currentStyles)=>({
        ...currentStyles,
        '[data-item-title]': {
            ...currentStyles['[data-item-title]'],
            whiteSpace: 'normal',
            lineHeight: 'initial'
        }
    });
const $097fe38bc39869b0$export$de3705f3d2162955 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            (0, $dHQr5.generateCustomThemeCssFn)(theme),
            $097fe38bc39869b0$var$overrideStyles
        ]), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SnT0.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("8SnT0", function(module, exports) {

$parcel$export(module.exports, "Container", () => $caa339108b3c8ef1$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $caa339108b3c8ef1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $jvM56 = parcelRequire("jvM56");

var $gMdj1 = parcelRequire("gMdj1");
function $caa339108b3c8ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caa339108b3c8ef1$var$containerStyles = {
    name: "4bgdod",
    styles: "display:block;position:relative"
};
const $caa339108b3c8ef1$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $caa339108b3c8ef1$var$containerStyles,
        ...safeProps
    }, children);
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $caa339108b3c8ef1$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const cssFn = (0, $jvM56.overrideStyleFunction)(()=>({
            userSelect: 'auto',
            ['[data-item-title]']: {
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.side-navigation-tokenised-typography-styles') ? {
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontSize: '0.875rem',
                    letterSpacing: '-0.003em',
                    fontWeight: "var(--ds-font-weight-semibold, 600)"
                },
                color: `var(--ds-text, ${0, $PdmhA.N500})`
            },
            // Will look interactive if the `component` is anything other than a div.
            'div&:hover': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                cursor: 'default'
            },
            'div&:active': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                color: `var(--ds-text, ${0, $PdmhA.N500})`
            }
        }), props.cssFn);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...props,
        ref: ref,
        component: props.component || $caa339108b3c8ef1$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("h2", props, children)
            }
        }
    });
});
var $caa339108b3c8ef1$export$2e2bcd8739ae039 = $caa339108b3c8ef1$var$Header;

});

parcelRegister("dHQr5", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $4df067d0bbc9b88e$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $4df067d0bbc9b88e$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});




parcelRegister("6D5Hl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef8bb497ae7cfecf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ef8bb497ae7cfecf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
        "defaultMessage": "Back to project"
    }
});

});


parcelRegister("44AZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffa02dd9401c05b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $l90Gp = parcelRequire("l90Gp");

var $hinm7 = parcelRequire("hinm7");
var $zMQ0U = parcelRequire("zMQ0U");

var $dCFoo = parcelRequire("dCFoo");

var $10fdS = parcelRequire("10fdS");

var $3HCkE = parcelRequire("3HCkE");

var $asnZU = parcelRequire("asnZU");
const $5ffa02dd9401c05b$var$ForgeMenu = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: forgeResourceData } = (0, $3HCkE.useResource)((0, $l90Gp.forgeProjectModuleResource));
    const projectData = (0, $eUqFw.useMemo)(()=>forgeResourceData?.extensions || null, [
        forgeResourceData
    ]);
    const selectedForgeApp = (0, $dCFoo.useForgeSelectedApp)(projectData, route.name);
    const { stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES).FORGE_PROJECT);
    if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hinm7.ForgeProjectSection), {
        overrides: {
            showSelectedAppMenuOnly: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedApp: selectedForgeApp
        }
    });
    return null;
};
var $5ffa02dd9401c05b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5ffa02dd9401c05b$var$ForgeMenu);

});
parcelRegister("hinm7", function(module, exports) {

$parcel$export(module.exports, "ForgeProjectSection", () => $db59aca7aa23a0f8$export$fb7da191295a7e22);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $5s6kd = parcelRequire("5s6kd");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $l3JmK = parcelRequire("l3JmK");

var $jMYeN = parcelRequire("jMYeN");

var $zMQ0U = parcelRequire("zMQ0U");

var $4Kgsn = parcelRequire("4Kgsn");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $db59aca7aa23a0f8$var$projectTypeRouteMap = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'core',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $db59aca7aa23a0f8$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$db59aca7aa23a0f8$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $db59aca7aa23a0f8$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $zMQ0U.useProjectForgeApps)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    const filteredForgeAppsData = overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5s6kd.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $4Kgsn.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $db59aca7aa23a0f8$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $jMYeN.toSections)(extension),
            moduleName: (0, $2Rqjr.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eUqFw.useRef)(performance.now());
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) (0, $eUqFw.useEffect)(()=>{
            if (!$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        else !$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId && (0, $d6g7g.forgeModulesLoadTime).start({
            startTime: performance.now()
        });
        const onError = (0, $eUqFw.useCallback)(()=>{
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).cancel();
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
                else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (!(0, $1ybV0.ff)('fix-forge-ui-type-detection_nmgpj')) {
        if (render != null && render !== 'native') return 'ui-kit';
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("d6f6c", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $6c42ad247d2b6151$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $6c42ad247d2b6151$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $6c42ad247d2b6151$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line jira/react/no-class-components
class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $2jDha.default)()($6c42ad247d2b6151$var$FireComponent);
const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "UI"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
    });
const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "TRACK"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
    });
const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "OPERATIONAL"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$12346a674644c156)
    });
const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "SCREEN"; eventName: string; attributes?: { [key: string]: any; } | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});


parcelRegister("5s6kd", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $c4eafcc07a5a74f2$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $c4eafcc07a5a74f2$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("l3JmK", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $62555c33c4fca39e$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $62555c33c4fca39e$export$26a5287439a1d287);

var $eUqFw = parcelRequire("eUqFw");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $d6g7g = parcelRequire("d6g7g");

var $7eMp1 = parcelRequire("7eMp1");

var $4aKCU = parcelRequire("4aKCU");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $2DHQu = parcelRequire("2DHQu");
var $5KxOv = parcelRequire("5KxOv");

var $jn9Rf = parcelRequire("jn9Rf");
const $62555c33c4fca39e$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $62555c33c4fca39e$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeIcon), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
        label: ""
    });
const $62555c33c4fca39e$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $bS2FN.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        },
        onClick: ()=>{
            (0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx') ? (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            }) : (0, $d6g7g.forgeModulesLoadTime).start({
                startTime: performance.now()
            });
        }
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $62555c33c4fca39e$var$nestedHeaderAlignmentFix = ()=>({
        paddingLeft: `${(0, $c9TLT.gridSize) * 2.625}px`
    });
const $62555c33c4fca39e$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $4aKCU.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        cssFn: // this to avoid sketchy-null-bool linting issue
        typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $62555c33c4fca39e$var$nestedHeaderAlignmentFix : undefined
    });
const $62555c33c4fca39e$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $eUqFw.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $bS2FN.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeSubpagesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KxOv.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $62555c33c4fca39e$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                },
                onClick: ()=>{
                    (0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx') ? (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                        startTime: performance.now()
                    }) : (0, $d6g7g.forgeModulesLoadTime).start({
                        startTime: performance.now()
                    });
                }
            }, page.title)))));
};
const $62555c33c4fca39e$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $eUqFw.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props));
};

});
parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("4aKCU", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $ee80f8e9038197e4$export$a4f83f6df17decd4);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $iJlfe = parcelRequire("iJlfe");

var $iFXD5 = parcelRequire("iFXD5");

var $8SnT0 = parcelRequire("8SnT0");

var $7eMp1 = parcelRequire("7eMp1");

var $8n4Bi = parcelRequire("8n4Bi");

var $hukpV = parcelRequire("hukpV");

var $5jn4M = parcelRequire("5jn4M");
const $ee80f8e9038197e4$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $iJlfe.default), AddonIcon: AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), CssFixContainer: CssFixContainer = (0, $5jn4M.CssFixContainerDI), Header: Header = (0, $8SnT0.default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, $7eMp1.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const headerCssFn = (0, $eUqFw.useMemo)(()=>cssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            cssFn,
            (0, $hukpV.generateCustomThemeCssFn)(theme)
        ]) : (0, $hukpV.generateCustomThemeCssFn)(theme), [
        cssFn,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CssFixContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        cssFn: headerCssFn,
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        // @ts-expect-error - TS2769 - No overload matches this call.
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EnvironmentLozenge, {
            environmentType: environmentType
        })
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey)));
};

});
parcelRegister("hukpV", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $a917a148f3dfadbc$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $a917a148f3dfadbc$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '[data-item-description]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});

parcelRegister("5jn4M", function(module, exports) {

$parcel$export(module.exports, "CssFixContainerDI", () => $cf127d0288738b67$export$eee12c3955319ddc);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cf127d0288738b67$export$eee12c3955319ddc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1lfu1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5KxOv", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $f60267b6fe4a2c5d$export$8adb256d999cd5a0);
/** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b4txA = parcelRequire("b4txA");

var $8n4Bi = parcelRequire("8n4Bi");

var $jkEVK = parcelRequire("jkEVK");
const $f60267b6fe4a2c5d$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, $jkEVK.generateCustomThemeCssFn)(theme), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4txA.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("b4txA", function(module, exports) {

$parcel$export(module.exports, "default", () => $587c53f185e0b1ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $587c53f185e0b1ef$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $jvM56.overrideStyleFunction)((0, $jvM56.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        ...props,
        cssFn: cssFn
    });
};
var $587c53f185e0b1ef$export$2e2bcd8739ae039 = $587c53f185e0b1ef$var$HeadingItem;

});

parcelRegister("jkEVK", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $0875611379df01fd$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $0875611379df01fd$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                color: item?.color?.default,
                opacity: item?.opacity
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});


parcelRegister("jn9Rf", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $d734c17ba92feb96$export$fe0464db4dc93ab4);
$parcel$export(module.exports, "ForgeSubpagesContainer", () => $d734c17ba92feb96$export$682ee8eb4890e553);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d734c17ba92feb96$export$fe0464db4dc93ab4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});
const $d734c17ba92feb96$export$682ee8eb4890e553 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14tkpxbi _t3zcv47k _1so4jjyb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4Kgsn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1af325f867f52a7e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1af325f867f52a7e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("dCFoo", function(module, exports) {

$parcel$export(module.exports, "useForgeSelectedApp", () => $4f01126c9b52390e$export$e6dee8b777476118);

var $kJlBc = parcelRequire("kJlBc");

var $eOutC = parcelRequire("eOutC");
const $4f01126c9b52390e$export$e6dee8b777476118 = (modules, routeName)=>{
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    if (route.name !== routeName || matchedExtension == null) return null;
    return matchedExtension;
};

});


parcelRegister("bp2TG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8601170973bccc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e00im = parcelRequire("e00im");
var $hzZWH = parcelRequire("hzZWH");

var $asnZU = parcelRequire("asnZU");

var $1V2xJ = parcelRequire("1V2xJ");
const $1b8601170973bccc$var$EMPTY_STACK = [];
const $1b8601170973bccc$var$IssuesMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        initialStack: $1b8601170973bccc$var$EMPTY_STACK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e00im.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
        titleHeaderText: formatMessage((0, $1V2xJ.default).issues)
    }))));
};
var $1b8601170973bccc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b8601170973bccc$var$IssuesMenu);

});
parcelRegister("e00im", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $da22c620e9d06640$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $2ijRB = parcelRequire("2ijRB");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $bgNoL = parcelRequire("bgNoL");

var $1UelU = parcelRequire("1UelU");

var $jvL3n = parcelRequire("jvL3n");

var $1jPif = parcelRequire("1jPif");

var $9kVcv = parcelRequire("9kVcv");

var $J5kh6 = parcelRequire("J5kh6");

var $bS2FN = parcelRequire("bS2FN");

var $auisD = parcelRequire("auisD");

var $41gRk = parcelRequire("41gRk");

var $gs1oK = parcelRequire("gs1oK");

var $8lbgA = parcelRequire("8lbgA");
const $da22c620e9d06640$var$IssuesNew = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const StyleOverrideWrapper = (0, $1ybV0.ff)('nin.global-scope_aqec8') ? $da22c620e9d06640$var$CompiledWrapper : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auisD.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
    ), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jPif.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvL3n.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gs1oK.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
const $da22c620e9d06640$export$9bf0cad7d37c4925 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $kJlBc.useRouter)(); // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const hasSomeFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false); // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query param in the URL does not need to be considered (unless this is for legacy PIN)
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, isOnLegacyPinRoute || titleHeaderText === null || titleHeaderText === undefined ? formatMessage((0, $8lbgA.messages).issues) : titleHeaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (...args)=>(0, $41gRk.isInAllFiltersState)(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false)(...args) : false),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $8lbgA.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $8lbgA.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $8lbgA.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $8lbgA.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? allOpenIssuesSelector : ()=>false,
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $8lbgA.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $8lbgA.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $8lbgA.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $8lbgA.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $8lbgA.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $8lbgA.messages).updatedRecently))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasSomeFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'pin-manage-filters'
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: "/secure/ManageFilters.jspa"
    }, formatMessage((0, $8lbgA.messages).viewAllFilters))));
};
const $da22c620e9d06640$export$1cb51167b20548a0 = (0, $2ijRB.default)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), $da22c620e9d06640$var$IssuesNew, $da22c620e9d06640$export$9bf0cad7d37c4925); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da22c620e9d06640$var$CompiledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ijRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c0d8b469289537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$63c0d8b469289537$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("jvL3n", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $6b45c28ee62250e5$export$f5b4503a4a7ca418);

var $dV4cd = parcelRequire("dV4cd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $1h6H8 = parcelRequire("1h6H8");

var $62ZdZ = parcelRequire("62ZdZ");

var $gGtKh = parcelRequire("gGtKh");

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $3HCkE = parcelRequire("3HCkE");

var $cINNO = parcelRequire("cINNO");

var $dWLk9 = parcelRequire("dWLk9");

var $de40W = parcelRequire("de40W");

var $g1pyf = parcelRequire("g1pyf");
const $6b45c28ee62250e5$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $eUqFw.useState)((0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $3HCkE.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $de40W.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: (0, $1ybV0.ff)('nin.global-scope_aqec8') && isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $iWLL0.usePreloadedQuery)((0, $dV4cd.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g1pyf.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $6b45c28ee62250e5$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $buJlM.useRelayResource)((0, $62ZdZ.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $dV4cd.default), resourceQueryRef);
    const cloudId = (0, $dWLk9.useCloudId)();
    const loadSidebarData = (0, $eUqFw.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b45c28ee62250e5$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null));
};

});
parcelRegister("dV4cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0180673d49314d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $0f0180673d49314d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0f0180673d49314d$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $0f0180673d49314d$export$2e2bcd8739ae039 = $0f0180673d49314d$var$node;

});

parcelRegister("1h6H8", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $c81bcd3cd8865351$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $c81bcd3cd8865351$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $c81bcd3cd8865351$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $c81bcd3cd8865351$export$458eda2352a1e223);

var $aZaPn = parcelRequire("aZaPn");

var $gUUjF = parcelRequire("gUUjF");
const $c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage = (0, $aZaPn.createLocalStorageProvider)('nin-changeboarding');
const $c81bcd3cd8865351$export$34434fbbe40a8047 = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.remove($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$55632339cd4dae9c = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$7b78bfe0a111cecf = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $c81bcd3cd8865351$export$34434fbbe40a8047();
    }
};
const $c81bcd3cd8865351$export$458eda2352a1e223 = ()=>{
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("62ZdZ", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $67f901853f9a37f2$export$be31dd7adcfd2297);
// eslint-disable-next-line jira/restricted/@atlassian+jira-relay-utils

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $lY2yG = parcelRequire("lY2yG");
const $67f901853f9a37f2$export$be31dd7adcfd2297 = (0, $lY2yG.withGiraAggAnonSsrFix)((0, $buJlM.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dV4cd.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("lY2yG", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $db78da6c364437f8$export$f4b29e78f4c0a526);
const $db78da6c364437f8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("cINNO", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $ae6e202da237abde$export$3f6390b4131d761b);

var $3HCkE = parcelRequire("3HCkE");

const $ae6e202da237abde$var$getDataLoader = ()=>(parcelRequire("4boWd"));
const $ae6e202da237abde$export$3f6390b4131d761b = (0, $3HCkE.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $ae6e202da237abde$var$getDataLoader
});

});
parcelRegister("4boWd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hdytc');
        const value = parcelRequire('3AaIE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hdytc").then(()=>parcelRequire('3AaIE'));
}

});


parcelRegister("de40W", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $58b0dd58f177e334$export$7082c02465d0ecd4);
const $58b0dd58f177e334$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("g1pyf", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $35a2047bceaae71b$export$b7f4b26a8737eee0);

var $kwce8 = parcelRequire("kwce8");

var $lz8Mx = parcelRequire("lz8Mx");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7eyVf = parcelRequire("7eyVf");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hR6B0 = parcelRequire("hR6B0");

var $efIfB = parcelRequire("efIfB");

var $9GCal = parcelRequire("9GCal");
var $35a2047bceaae71b$var$_StyledSection = /*#__PURE__*/ (0, $kwce8.default)((0, $7eyVf.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $35a2047bceaae71b$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $lz8Mx.default), jiraQuery);
    (0, $hR6B0.useFavouritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = data.favouriteFilters?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35a2047bceaae71b$var$_StyledSection, {
        title: formatMessage((0, $1ybV0.ff)('nin.global-scope_aqec8') ? (0, $9GCal.messages).newStarredFiltersHeader : (0, $9GCal.messages).starredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efIfB.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null));
};

});
parcelRegister("lz8Mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8652eb61facff2a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8652eb61facff2a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "starredFiltersList_navigationAppsSidebarCommon",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$8652eb61facff2a1$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
var $8652eb61facff2a1$export$2e2bcd8739ae039 = $8652eb61facff2a1$var$node;

});

parcelRegister("hR6B0", function(module, exports) {

$parcel$export(module.exports, "useFavouritesChangeEffect", () => $2f7c11e5ef943ce8$export$2c710fb0bffad609);

var $eUqFw = parcelRequire("eUqFw");

var $3LiTJ = parcelRequire("3LiTJ");

var $dQZ5c = parcelRequire("dQZ5c");

var $hzcvF = parcelRequire("hzcvF");
const $2f7c11e5ef943ce8$export$2c710fb0bffad609 = (type, effect)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavouriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $hzcvF.usePreviousWithInitial)(hasPendingChanges);
    (0, $eUqFw.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});
parcelRegister("hzcvF", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $42dfce76254176f5$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $42dfce76254176f5$export$23fbbb2e62c4a911);

var $eUqFw = parcelRequire("eUqFw");
const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("efIfB", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $d52ff21ebba57816$export$3cf161fcd24b6b4f);

var $emcDd = parcelRequire("emcDd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1UelU = parcelRequire("1UelU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d52ff21ebba57816$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $d52ff21ebba57816$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $iWLL0.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $emcDd.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $d52ff21ebba57816$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("emcDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $316231fa04a38c46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $316231fa04a38c46$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$316231fa04a38c46$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $316231fa04a38c46$export$2e2bcd8739ae039 = $316231fa04a38c46$var$node;

});


parcelRegister("9GCal", function(module, exports) {

$parcel$export(module.exports, "messages", () => $298836785675e03a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $298836785675e03a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.starred-filters-header",
        "defaultMessage": "Starred global filters"
    },
    // TODO: cleanup when tidying up FF: nin.global-scope_aqec8
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});



parcelRegister("1jPif", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $d6c63c3350dd7b8a$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $lRvnl = parcelRequire("lRvnl");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e7DJr = parcelRequire("e7DJr");
const $d6c63c3350dd7b8a$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c63c3350dd7b8a$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $e7DJr.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, formatMessage((0, $e7DJr.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6c63c3350dd7b8a$var$SectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7eyVf.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lRvnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3a504e8cabc14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf4A3 = parcelRequire("gf4A3");
const $4dc3a504e8cabc14$var$sectionMessageStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $4dc3a504e8cabc14$var$bleedStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $4dc3a504e8cabc14$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $gf4A3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        backgroundColor: $4dc3a504e8cabc14$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $4dc3a504e8cabc14$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
const $4dc3a504e8cabc14$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$4dc3a504e8cabc14$var$SectionMessage.displayName = 'SectionMessage';
var $4dc3a504e8cabc14$export$2e2bcd8739ae039 = $4dc3a504e8cabc14$var$SectionMessage;

});
parcelRegister("gf4A3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $ioiQ7 = parcelRequire("ioiQ7");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $5e1f1f04e3e69c39$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $PdmhA.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $PdmhA.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $PdmhA.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $PdmhA.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $PdmhA.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $PdmhA.P500)})`
    }
};
function $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $5e1f1f04e3e69c39$export$faa35441caff5bb6[appearance] || $5e1f1f04e3e69c39$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = $7f77ec2b05210607$var$CheckCircleIcon;
module.exports.default = $7f77ec2b05210607$var$_default;

});

parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});



parcelRegister("e7DJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d36cc3357c6d79c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4d36cc3357c6d79c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("J5kh6", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $35f10d3662b33f51$export$3c69152f8409a017);

var $eUqFw = parcelRequire("eUqFw");

var $51qRF = parcelRequire("51qRF");

var $3HCkE = parcelRequire("3HCkE");
const $35f10d3662b33f51$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $3HCkE.useResource)((0, $51qRF.staticSidebarDefaultPINFiltersResource));
    (0, $eUqFw.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
parcelRegister("51qRF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $9a0146f4bac170ac$export$d3efe54a881807bf);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $kOqDJ = parcelRequire("kOqDJ");
const $9a0146f4bac170ac$export$d3efe54a881807bf = (0, $3HCkE.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $kOqDJ.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("kOqDJ", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $367b2d3283f133ce$export$268c1bcb44a0ddd3);

var $lRmyA = parcelRequire("lRmyA");
const $367b2d3283f133ce$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $367b2d3283f133ce$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $lRmyA.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $367b2d3283f133ce$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});



parcelRegister("auisD", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $755cdea7fe43675a$export$5df36bcfaa4d1f9d);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");

var $3Cmcu = parcelRequire("3Cmcu");

var $41gRk = parcelRequire("41gRk");
const $755cdea7fe43675a$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $kJlBc.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $3Cmcu.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $3Cmcu.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $3Cmcu.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $3Cmcu.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $41gRk.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $3Cmcu.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $3Cmcu.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $3Cmcu.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $3Cmcu.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).createdRecently.analytics,
        selectedOn: (0, $41gRk.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $3Cmcu.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $3Cmcu.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $3Cmcu.messages).updatedRecently)));
};

});
parcelRegister("3Cmcu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $27be2807b2a35477$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $27be2807b2a35477$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});

});

parcelRegister("41gRk", function(module, exports) {

$parcel$export(module.exports, "isInAllFiltersState", () => $4de8f16c2cebce90$export$1596c397510d46b1);
$parcel$export(module.exports, "itemMap", () => $4de8f16c2cebce90$export$1072457701b9918d);

var $bgNoL = parcelRequire("bgNoL");

var $bS2FN = parcelRequire("bS2FN");
const $4de8f16c2cebce90$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $4de8f16c2cebce90$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$4de8f16c2cebce90$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("gs1oK", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $b725eee24cc929f3$export$c131ccfc44bcd85c);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $fPhxv = parcelRequire("fPhxv");
const $b725eee24cc929f3$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $b725eee24cc929f3$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: $b725eee24cc929f3$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fPhxv.messages).viewAllFilters)));
};

});
parcelRegister("fPhxv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd606415b82d3454$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bd606415b82d3454$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("8lbgA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a62695030ba4b800$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a62695030ba4b800$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.updated-recently",
        "defaultMessage": "Updated recently"
    },
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("1V2xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff74a8dacf24a66b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ff74a8dacf24a66b$var$messages = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
        "defaultMessage": "Issues"
    }
});
var $ff74a8dacf24a66b$export$2e2bcd8739ae039 = $ff74a8dacf24a66b$var$messages;

});


parcelRegister("8Xc28", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebf29b281f05c6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $asnZU = parcelRequire("asnZU");
var $kFwR2 = parcelRequire("kFwR2");

var $1gKca = parcelRequire("1gKca");
const $bebf29b281f05c6a$var$calculateStack = (route, connectStack)=>{
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) && connectStack) {
        const [first, ...other] = connectStack;
        // omit the reports nesting level as we render the reports menu
        // as a top level menu in business projects
        if ((0, $lg3mT.SECTION_ID).REPORTS === first) return other;
        return connectStack;
    }
    return [];
};
const $bebf29b281f05c6a$var$ReportsMenu = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$bebf29b281f05c6a$var$calculateStack(route, connectStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($bebf29b281f05c6a$var$calculateStack(route, connectStack));
    }, [
        route,
        connectStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gKca.Reports), {
        connectItems: connectItems
    })));
};
var $bebf29b281f05c6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bebf29b281f05c6a$var$ReportsMenu);

});
parcelRegister("1gKca", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $c5c469348dcea9ef$export$883262dc952d8f59);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $5KxOv = parcelRequire("5KxOv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $aWYQ8 = parcelRequire("aWYQ8");

var $hX9N3 = parcelRequire("hX9N3");

var $aJGiK = parcelRequire("aJGiK");

var $bRhBg = parcelRequire("bRhBg");

var $lmMuP = parcelRequire("lmMuP");
const $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI = (0, $kIUmN.withThrowOnError)((0, $aJGiK.useDefaultReportItems));
const $c5c469348dcea9ef$var$useThrowProjectDI = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c5c469348dcea9ef$var$useThrowReportFeaturesDI = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useReportFeatures));
const $c5c469348dcea9ef$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, $aWYQ8.ConnectMenu), MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), SkeletonItem: SkeletonItem = (0, $gLn5u.default), connectItems: connectItems, SectionHeader: SectionHeader = (0, $5KxOv.SectionHeader), matchUrlParams: matchUrlParams = (0, $bS2FN.matchUrlParams), useDefaultReportItems: useDefaultReportItems = $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, $5JgJ2.default), useProject: useProject = $c5c469348dcea9ef$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $c5c469348dcea9ef$var$useThrowReportFeaturesDI })=>{
    const baseUrl = '';
    const { data: defaultItems } = useDefaultReportItems();
    const { data: features } = useReportFeatures();
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    if (project == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonItem, null);
    const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
        baseUrl: baseUrl,
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, defaultItems && defaultItems.items.length > 0 && // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        id: defaultItems.id,
        key: defaultItems.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: item.id,
            analytics: {
                itemId: item.id
            },
            selectedOn: matchUrlParams([
                'reportKey'
            ]),
            href: item.url
        }, item.name != null ? item.name : null))), features && features.hasForcastSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).forecastAndManagement)), features.hasTimeTracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-tracking'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).timeTracking)), features.hasDeveloperWorkload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'developer-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).userWorkload)), features.hasVersionWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'version-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).versionWorkload))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).other)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'workloadpie'
        },
        href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).workloadPieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                title: formatMessage((0, $lmMuP.default).itemBack)
            }
        }
    })));
};

});
parcelRegister("hX9N3", function(module, exports) {

$parcel$export(module.exports, "createReportUrlFunc", () => $aaeaad86945af36f$export$fe91ad5e718e4335);
const $aaeaad86945af36f$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;

});

parcelRegister("aJGiK", function(module, exports) {

$parcel$export(module.exports, "useDefaultReportItems", () => $803b0b72c024ff00$export$ab2e8832e8916e83);

var $5JgJ2 = parcelRequire("5JgJ2");

var $cPEpP = parcelRequire("cPEpP");

var $hX9N3 = parcelRequire("hX9N3");

var $93Xzy = parcelRequire("93Xzy");
const $803b0b72c024ff00$export$ab2e8832e8916e83 = ()=>{
    const baseUrl = '';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project, loading: loading, error: error } = (0, $cPEpP.useProject)();
    let defaultIssueAnalysisSection = null;
    if (project) {
        const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        defaultIssueAnalysisSection = {
            name: formatMessage((0, $93Xzy.default).issueAnalysis),
            id: 'issue-analysis-sidebar-links',
            items: [
                {
                    id: 'averageage-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                    name: formatMessage((0, $93Xzy.default).averageAgeReport)
                },
                {
                    id: 'createdvsresolved-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                    name: formatMessage((0, $93Xzy.default).createdResolvedIssuesReport)
                },
                {
                    id: 'pie-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                    name: formatMessage((0, $93Xzy.default).pieChart)
                },
                {
                    id: 'recentlycreated-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                    name: formatMessage((0, $93Xzy.default).recentlyCreatedIssues)
                },
                {
                    id: 'resolutiontime-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                    name: formatMessage((0, $93Xzy.default).resolutionTime)
                },
                {
                    id: 'singlelevelgroupby',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                    name: formatMessage((0, $93Xzy.default).singleLevelGroup)
                },
                {
                    id: 'timesince-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                    name: formatMessage((0, $93Xzy.default).timeSinceIssues)
                }
            ]
        };
    }
    return {
        data: defaultIssueAnalysisSection,
        loading: loading,
        error: error
    };
};

});
parcelRegister("93Xzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7783a38d48407a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af7783a38d48407a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueAnalysis: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
        "defaultMessage": "Issue analysis"
    },
    averageAgeReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
        "defaultMessage": "Average Age Report"
    },
    createdResolvedIssuesReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
        "defaultMessage": "Created vs Resolved Issues Report"
    },
    pieChart: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
        "defaultMessage": "Pie Chart Report"
    },
    recentlyCreatedIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
        "defaultMessage": "Recently Created Issues Report"
    },
    resolutionTime: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
        "defaultMessage": "Resolution Time Report"
    },
    singleLevelGroup: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
        "defaultMessage": "Single Level Group By Report"
    },
    timeSinceIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
        "defaultMessage": "Time Since Issues Report"
    }
});

});


parcelRegister("lmMuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0b546a275ef68c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d0b546a275ef68c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    forecastAndManagement: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
        "defaultMessage": "Forecast & management"
    },
    timeTracking: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
        "defaultMessage": "Time Tracking Report"
    },
    userWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
        "defaultMessage": "User Workload Report"
    },
    versionWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
        "defaultMessage": "Version Workload Report"
    },
    workloadPieChart: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
        "defaultMessage": "Workload Pie Chart Report"
    },
    other: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
        "defaultMessage": "Other"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
        "defaultMessage": "Back to reports"
    }
});

});



parcelRegister("aZ40y", function(module, exports) {

$parcel$export(module.exports, "default", () => $578dbaa7eba68868$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $asnZU = parcelRequire("asnZU");
var $kFwR2 = parcelRequire("kFwR2");

var $1m2Xn = parcelRequire("1m2Xn");

var $eiI3i = parcelRequire("eiI3i");
const $578dbaa7eba68868$var$EMPTY_STACK = [];
const $578dbaa7eba68868$var$adjustAppStack = (appStack)=>{
    const [first, ...other] = appStack;
    // omit the settings nesting level as we render the settings menu
    // as a top level menu in business projects
    if ((0, $lg3mT.SECTION_ID).SETTINGS === first) return other;
    return appStack;
};
const $578dbaa7eba68868$var$calculateStack = (route, connectStack, forgeStack)=>{
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) && forgeStack) return $578dbaa7eba68868$var$adjustAppStack(forgeStack);
    if (route.name.includes((0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE)) {
        // this is the same logic as the one in src/packages/navigation-apps/sidebar/next-gen/src/ui/menu/main.js
        const [view] = route.name.replace(`${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE}-`, '').split('-');
        return view === 'issuetypes' ? [
            view
        ] : $578dbaa7eba68868$var$EMPTY_STACK;
    }
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) && connectStack) return $578dbaa7eba68868$var$adjustAppStack(connectStack);
    return $578dbaa7eba68868$var$EMPTY_STACK;
};
const $578dbaa7eba68868$var$SettingsMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const { data: forgeItems, stack: forgeStack } = (0, $kFwR2.useProjectSettingsForgeItems)((0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_FORGE_APPS, $578dbaa7eba68868$var$EMPTY_STACK);
    const ecosystemItems = (0, $eUqFw.useMemo)(()=>({
            forge: forgeItems,
            connect: connectItems
        }), [
        forgeItems,
        connectItems
    ]);
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eiI3i.SettingsMenu), {
        stack: stack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1m2Xn.Settings), {
        ecosystemItems: ecosystemItems
    }))));
};
var $578dbaa7eba68868$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($578dbaa7eba68868$var$SettingsMenu);

});
parcelRegister("1m2Xn", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f542bb55240ab7c0$export$c72f6eaae7b9adff);
/* eslint-disable complexity */ 
var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $lwZcK = parcelRequire("lwZcK");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fR9xM = parcelRequire("fR9xM");
var $gFuN0 = parcelRequire("gFuN0");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $jFPBh = parcelRequire("jFPBh");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $atb9c = parcelRequire("atb9c");

var $gF5SK = parcelRequire("gF5SK");

var $6vrw7 = parcelRequire("6vrw7");

var $8yhrX = parcelRequire("8yhrX");

var $bRhBg = parcelRequire("bRhBg");

var $7eeF2 = parcelRequire("7eeF2");
const $f542bb55240ab7c0$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $f542bb55240ab7c0$export$154ecbb867fd48f0 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useSettingFeatures));
const $f542bb55240ab7c0$export$17eaab3b8c213998 = (0, $kIUmN.withThrowOnError)((0, $gF5SK.useNewIssueViewLockedInStatus));
const $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES = [
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_NOTIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_NOTIFICATIONS
];
const $f542bb55240ab7c0$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
    const { data: features } = $f542bb55240ab7c0$export$154ecbb867fd48f0();
    const { data: status } = $f542bb55240ab7c0$export$17eaab3b8c213998();
    const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, $gF5SK.DEFAULT_TO_OLD_ISSUE_VIEW);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $f542bb55240ab7c0$export$a4007dc4843ca7f6();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    if (features == null || project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $7eeF2.default).projectSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: [
            (0, $1ybV0.ff)('hix-4818-adopt-modern-project-details-page-across-all-products_3zvy1') ? (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_DETAILS : (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_EDIT
        ],
        href: (0, $1ybV0.ff)('hix-4818-adopt-modern-project-details-page-across-all-products_3zvy1') ? `/jira/core/projects/${project.key}/settings/details` : `/secure/project/EditProject!default.jspa?pid=${project.id}`
    }, formatMessage((0, $7eeF2.default).details)), features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'people'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/people`
    }, formatMessage((0, $7eeF2.default).people)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFPBh.SpotlightTarget), {
        name: "spotlight-sidebar-project-automation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: (0, $lwZcK.getBaseAutomationUrl)({
            isSimplified: project.isSimplified,
            projectKey: (0, $6vrw7.toProjectKey)(project.key),
            projectType: (0, $7ZZxN.CORE_PROJECT)
        })
    }, formatMessage((0, $7eeF2.default).automation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fR9xM.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-automation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gFuN0.FireUiAnalytics), {
        actionSubject: "automationNavigationItem",
        action: "viewed"
    })), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/summary`
    }, formatMessage((0, $7eeF2.default).summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja')
    }, features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-types'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuetypes`
    }, formatMessage((0, $7eeF2.default).issueTypes)), isNewIssueViewLockedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-layout'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuelayout`
    }, formatMessage((0, $7eeF2.default).issueLayout)), (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        href: `/jira/core/projects/${project.key}/settings/forms`,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS
        ]
    }, formatMessage((0, $7eeF2.default).forms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupTwoSection
    }, features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'workflows'
        },
        href: `/plugins/servlet/project-config/${project.key}/workflows`
    }, formatMessage((0, $7eeF2.default).workflows)), features.hasScreens && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'screens'
        },
        href: `/plugins/servlet/project-config/${project.key}/screens`
    }, formatMessage((0, $7eeF2.default).screens)), features.hasFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'fields'
        },
        href: `/plugins/servlet/project-config/${project.key}/fields`
    }, formatMessage((0, $7eeF2.default).fields))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupThreeSection
    }, features.hasVersions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS
        ],
        analytics: {
            itemId: 'versions'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-versions`
    }, formatMessage((0, $7eeF2.default).versions)), features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS
        ],
        analytics: {
            itemId: 'components'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-components`
    }, formatMessage((0, $7eeF2.default).components))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupFourSection
    }, features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'permissions'
        },
        href: `/plugins/servlet/project-config/${project.key}/permissions`
    }, formatMessage((0, $7eeF2.default).permissions)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-security'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
    }, formatMessage((0, $7eeF2.default).issueSecurity)), features.hasNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES,
        analytics: {
            itemId: 'notifications'
        },
        href: `/plugins/servlet/project-config/${project.key}/notifications`
    }, formatMessage((0, $7eeF2.default).notifications)), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).devtools))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasgetIssueCollectorSection
    }, features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_COLLECTORS
        ],
        analytics: {
            itemId: 'issue-collectors'
        },
        href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).issueCollectors))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atb9c.default), {
        hasSeparator: true,
        items: ecosystemItems,
        forgeModule: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        overrides: {
            BackMenuItem: {
                href: `/plugins/servlet/project-config/${project.key}`,
                title: formatMessage((0, $7eeF2.default).itemBack)
            }
        }
    }), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classifications'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/data-classifications`
    }, formatMessage((0, $7eeF2.default).dataClassificationsNonFinal))));
};

});
parcelRegister("lwZcK", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $c220e0172ef405d3$export$8e479e490e1e69bc);
const $c220e0172ef405d3$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("fR9xM", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $56d259c5c8dc2f0b$export$f14689466e4eca7a);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $56d259c5c8dc2f0b$export$f14689466e4eca7a = (0, $16WDb.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});

parcelRegister("gFuN0", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $e57e9331bc8bc1d3$export$5a67e7291fd4569e);

var $d6f6c = parcelRequire("d6f6c");

var $16WDb = parcelRequire("16WDb");
const $e57e9331bc8bc1d3$export$5a67e7291fd4569e = (0, $16WDb.withNestingOptimisation)((0, $d6f6c.FireUiAnalytics));

});

parcelRegister("jFPBh", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $022d6d24d0c2da0b$export$e29577842f211e22);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $16WDb = parcelRequire("16WDb");
const $022d6d24d0c2da0b$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $022d6d24d0c2da0b$export$e29577842f211e22 = (0, $16WDb.withNestingOptimisation)($022d6d24d0c2da0b$var$SpotlightTargetWrapper);

});

parcelRegister("atb9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ea6e374e29cd9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");

var $l3JmK = parcelRequire("l3JmK");
const $21ea6e374e29cd9c$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $eUqFw.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $9ui8T.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $eUqFw.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21ea6e374e29cd9c$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21ea6e374e29cd9c$export$66569e9b4a285b16, restProps));

});

parcelRegister("8yhrX", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $e16f91d64a0cd31a$export$4472465702535e7);

var $gd0Sp = parcelRequire("gd0Sp");
const $e16f91d64a0cd31a$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("7eeF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3728eeca46b17d68$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3728eeca46b17d68$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettings: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
        "defaultMessage": "People"
    },
    summary: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
        "defaultMessage": "Fields"
    },
    versions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
        "defaultMessage": "Versions"
    },
    components: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
        "defaultMessage": "Components"
    },
    permissions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
        "defaultMessage": "Notifications"
    },
    notificationsEmail: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
        "defaultMessage": "Notification email"
    },
    hipChat: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    new: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
        "defaultMessage": "New"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
        "defaultMessage": "Back to project settings"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
        "defaultMessage": "Automation"
    },
    devtools: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
        "defaultMessage": "Development tools"
    },
    forms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
        "defaultMessage": "Advanced Forms"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
        "defaultMessage": "Data classification"
    }
});

});


parcelRegister("eiI3i", function(module, exports) {

$parcel$export(module.exports, "SettingsMenu", () => $c096d087fddf630b$export$1d7840d5cdc861d5);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3SvNA = parcelRequire("3SvNA");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $2DHQu = parcelRequire("2DHQu");
var $b7Flp = parcelRequire("b7Flp");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $cqJw8 = parcelRequire("cqJw8");

var $7czSC = parcelRequire("7czSC");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");
var $8yhrX = parcelRequire("8yhrX");

var $lg3mT = parcelRequire("lg3mT");

var $g7sKB = parcelRequire("g7sKB");
var $eqBMI = parcelRequire("eqBMI");

var $7ugdf = parcelRequire("7ugdf");

var $f4Fss = parcelRequire("f4Fss");
const $c096d087fddf630b$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c096d087fddf630b$export$c72f6eaae7b9adff = ({ stack: stack })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    const { hasCoreAccess: hasCoreAccess } = (0, $fz8wa.useApplicationPermissions)();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, $7czSC.useConnectApps)();
    // to remove on isAppControlsEnabled() cleanup
    (0, $eUqFw.useEffect)(()=>{
        if (project && !connectAppsData) fetchConnectApps(project.key);
    }, [
        connectAppsData,
        fetchConnectApps,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const showCoreForms = (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && hasCoreAccess;
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $f4Fss.messages).title)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $f4Fss.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/details`
    }, formatMessage((0, $f4Fss.messages).itemDetails)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'access'
        },
        href: `${baseSettingsUrl}/access`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemAccess)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        href: `${baseSettingsUrl}/notifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/automation`
    }, formatMessage((0, $f4Fss.messages).automation)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, (0, $lg3mT.SECTION_ID).ISSUE_TYPES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'issuetypes'
        },
        href: `${baseSettingsUrl}/issuetypes`,
        id: (0, $lg3mT.SECTION_ID).ISSUE_TYPES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        title: formatMessage((0, $f4Fss.messages).itemIssueTypes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ugdf.IssueTypes), null)), isPremiumUserSeat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'approvals'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/approvals`
    }, formatMessage((0, $f4Fss.messages).itemApprovals)), showCoreForms && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/forms`
    }, formatMessage((0, $f4Fss.messages).itemAdvancedForms)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, 'apps') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SvNA.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'apps'
        },
        menuItemLabel: formatMessage((0, $eqBMI.messages).apps),
        forceExpand: true,
        submenuId: "nextgen-apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g7sKB.EcosystemAppsMenu), null)), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classification'
        },
        href: `${baseSettingsUrl}/data-classifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).dataClassificationNonFinal))));
};
const $c096d087fddf630b$export$1d7840d5cdc861d5 = (props)=>{
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return(// to remove on isAppControlsEnabled() cleanup
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7czSC.ConnectAppsContainer), {
        baseUrl: "",
        onError: undefined,
        scope: project.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c096d087fddf630b$export$c72f6eaae7b9adff, props)));
};

});
parcelRegister("3SvNA", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $df73afd5d0671194$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aqZcy = parcelRequire("aqZcy");
var $5RTd0 = parcelRequire("5RTd0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aipcc = parcelRequire("aipcc");

var $1UelU = parcelRequire("1UelU");
const $df73afd5d0671194$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $df73afd5d0671194$var$useExpandableMenuStates = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $df73afd5d0671194$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $df73afd5d0671194$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, forceCollapse: forceCollapse = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $df73afd5d0671194$var$useExpandableMenuStates();
    const [subMenuActive, setSubMenuActive] = (0, $eUqFw.useState)(false);
    const [currentCookieData] = (0, $eUqFw.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $eUqFw.useState)(currentCookieData?.expanded || false);
    const expandableMenuItemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (forceExpand) setExpanded(true);
        if (forceCollapse) setExpanded(false);
    }, [
        forceExpand,
        forceCollapse
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aipcc.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df73afd5d0671194$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $df73afd5d0671194$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aipcc", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $654b7872966b947d$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");
const $654b7872966b947d$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    const Chevron = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const onKeydown = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: `var(--ds-icon, ${(0, $PdmhA.N500)})`,
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($654b7872966b947d$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $654b7872966b947d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("b7Flp", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $29014c8ea6c9a7cc$export$a35baff1c4efd3da);
const $29014c8ea6c9a7cc$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("cqJw8", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $8bf9744795c994e7$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $8bf9744795c994e7$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $8bf9744795c994e7$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $8bf9744795c994e7$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $8bf9744795c994e7$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $8bf9744795c994e7$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $8bf9744795c994e7$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $8bf9744795c994e7$export$dad567762dae162e);

var $7ZZxN = parcelRequire("7ZZxN");

var $6bYiA = parcelRequire("6bYiA");

var $6ZTsa = parcelRequire("6ZTsa");

var $avawr = parcelRequire("avawr");
const $8bf9744795c994e7$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('urls'), (0, $6ZTsa.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $8bf9744795c994e7$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $8bf9744795c994e7$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
};
const $8bf9744795c994e7$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $8bf9744795c994e7$export$b0d20d18e0230e83 = (projectKey)=>`${$8bf9744795c994e7$export$26432406821aa7bf((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $8bf9744795c994e7$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $8bf9744795c994e7$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && !isSimplified ? $8bf9744795c994e7$export$ff0a17aa36a000df(projectKey) : $8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $8bf9744795c994e7$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
const $8bf9744795c994e7$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;

});
parcelRegister("6bYiA", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $b6aeae99b4bfc5a4$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $b6aeae99b4bfc5a4$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $b6aeae99b4bfc5a4$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $b6aeae99b4bfc5a4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $b6aeae99b4bfc5a4$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $b6aeae99b4bfc5a4$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $b6aeae99b4bfc5a4$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $b6aeae99b4bfc5a4$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $b6aeae99b4bfc5a4$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $b6aeae99b4bfc5a4$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929);
// Issue Type Templates

var $ao0hp = parcelRequire("ao0hp");

var $lO4Or = parcelRequire("lO4Or");

var $6WXNs = parcelRequire("6WXNs");
var $7HKaW = parcelRequire("7HKaW");
var $38OPi = parcelRequire("38OPi");
var $6vrw7 = parcelRequire("6vrw7");
const $b6aeae99b4bfc5a4$export$9355e489ad16f98e = 'task';
const $b6aeae99b4bfc5a4$export$bcf558c186108044 = 'bug';
const $b6aeae99b4bfc5a4$export$1ea39a3ae330045 = 'story';
const $b6aeae99b4bfc5a4$export$3cb4a99a332e4186 = 'epic';
const $b6aeae99b4bfc5a4$export$a06f889861f6537d = 'subtask';
const $b6aeae99b4bfc5a4$export$952581bc40160893 = 'custom';
const $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e = [
    $b6aeae99b4bfc5a4$export$9355e489ad16f98e,
    $b6aeae99b4bfc5a4$export$bcf558c186108044,
    $b6aeae99b4bfc5a4$export$1ea39a3ae330045,
    $b6aeae99b4bfc5a4$export$3cb4a99a332e4186
];
const $b6aeae99b4bfc5a4$export$39cd48613b53ce2f = (0, $lO4Or.TEXT_AREA_CF_TYPE);
const $b6aeae99b4bfc5a4$export$56eae1056efd4899 = (0, $lO4Or.DESCRIPTION_TYPE);
const $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3 = (0, $lO4Or.ENVIRONMENT_TYPE);
const $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a = 'Story point estimate';
const $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $b6aeae99b4bfc5a4$export$a4d3702d4c7481d6 = 44;
const $b6aeae99b4bfc5a4$export$8a6a961f6caf7a8b = [
    $b6aeae99b4bfc5a4$export$56eae1056efd4899,
    $b6aeae99b4bfc5a4$export$39cd48613b53ce2f,
    $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3
];
const $b6aeae99b4bfc5a4$export$e27914436cc13e3c = 'Jira Software';
const $b6aeae99b4bfc5a4$export$a11dccbf88784c62 = 'Jira Service Management';
const $b6aeae99b4bfc5a4$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $b6aeae99b4bfc5a4$export$b3c4739240716eb6 = 'Jira Ops';
const $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7 = 'Jira';
const $b6aeae99b4bfc5a4$export$f31a652635bd75fe = (packageName)=>packageName;
const $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b = $b6aeae99b4bfc5a4$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $b6aeae99b4bfc5a4$export$a2231d79966e0ccc = 'NEW_';
const $b6aeae99b4bfc5a4$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9 = 'radio';
const $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1 = 'userpicker';
const $b6aeae99b4bfc5a4$export$b0e37d421e006913 = 'multiuserpicker';
const $b6aeae99b4bfc5a4$export$d77765147749db6b = 'select';
const $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d = 'cascadingselect';
const $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf = 'multiselect';
const $b6aeae99b4bfc5a4$export$ee975373b7797e8a = 'checkbox';
const $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5 = 'text';
const $b6aeae99b4bfc5a4$export$6f327bf99e20320 = 'number';
const $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05 = 'datetime';
const $b6aeae99b4bfc5a4$export$e6d73ed745b9a04 = 'projectpicker';
const $b6aeae99b4bfc5a4$export$d8b50f59220c7580 = 'date';
const $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2 = 'assetspicker';
const $b6aeae99b4bfc5a4$export$68b76ef93df5a880 = 'labelpicker';
const $b6aeae99b4bfc5a4$export$e7773fccbeec45e6 = 'grouppicker';
const $b6aeae99b4bfc5a4$export$b45487b145c52a37 = 'multigrouppicker';
const $b6aeae99b4bfc5a4$export$48548129a6d117f5 = 'version';
const $b6aeae99b4bfc5a4$export$722c271a9e11cb94 = 'multiversion';
const $b6aeae99b4bfc5a4$export$33dbe2a903610aa1 = 'textarea';
const $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $6WXNs.populateApplicationEditions)(),
        appPermissions: (0, $38OPi.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        atlassianAccountId: null,
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        cloudId: (0, $6vrw7.toCloudId)(''),
        activationId: (0, $6vrw7.toActivationId)(''),
        cloudName: (0, $6vrw7.toCloudName)(''),
        devopsProjectSignupSource: (0, $6vrw7.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $ao0hp.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false
    });

});
parcelRegister("lO4Or", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $4eac1b8021be0c88$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $4eac1b8021be0c88$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $4eac1b8021be0c88$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $4eac1b8021be0c88$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $4eac1b8021be0c88$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $4eac1b8021be0c88$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $4eac1b8021be0c88$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $4eac1b8021be0c88$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $4eac1b8021be0c88$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $4eac1b8021be0c88$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $4eac1b8021be0c88$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $4eac1b8021be0c88$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $4eac1b8021be0c88$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $4eac1b8021be0c88$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $4eac1b8021be0c88$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $4eac1b8021be0c88$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $4eac1b8021be0c88$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $4eac1b8021be0c88$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $4eac1b8021be0c88$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $4eac1b8021be0c88$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $4eac1b8021be0c88$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $4eac1b8021be0c88$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $4eac1b8021be0c88$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $4eac1b8021be0c88$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $4eac1b8021be0c88$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $4eac1b8021be0c88$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $4eac1b8021be0c88$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $4eac1b8021be0c88$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $4eac1b8021be0c88$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $4eac1b8021be0c88$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $4eac1b8021be0c88$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $4eac1b8021be0c88$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $4eac1b8021be0c88$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $4eac1b8021be0c88$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $4eac1b8021be0c88$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $4eac1b8021be0c88$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $4eac1b8021be0c88$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $4eac1b8021be0c88$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $4eac1b8021be0c88$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $4eac1b8021be0c88$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $4eac1b8021be0c88$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $4eac1b8021be0c88$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $4eac1b8021be0c88$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $4eac1b8021be0c88$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $4eac1b8021be0c88$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $4eac1b8021be0c88$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $4eac1b8021be0c88$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $4eac1b8021be0c88$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $4eac1b8021be0c88$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $4eac1b8021be0c88$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $4eac1b8021be0c88$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $4eac1b8021be0c88$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $4eac1b8021be0c88$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $4eac1b8021be0c88$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $4eac1b8021be0c88$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $4eac1b8021be0c88$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $4eac1b8021be0c88$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $4eac1b8021be0c88$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $4eac1b8021be0c88$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $4eac1b8021be0c88$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $4eac1b8021be0c88$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $4eac1b8021be0c88$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $4eac1b8021be0c88$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $4eac1b8021be0c88$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $4eac1b8021be0c88$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $4eac1b8021be0c88$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $4eac1b8021be0c88$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $4eac1b8021be0c88$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $4eac1b8021be0c88$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $4eac1b8021be0c88$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $4eac1b8021be0c88$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $4eac1b8021be0c88$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $4eac1b8021be0c88$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $4eac1b8021be0c88$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $4eac1b8021be0c88$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $4eac1b8021be0c88$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $4eac1b8021be0c88$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $4eac1b8021be0c88$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $4eac1b8021be0c88$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $4eac1b8021be0c88$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $4eac1b8021be0c88$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $4eac1b8021be0c88$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $4eac1b8021be0c88$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $4eac1b8021be0c88$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $4eac1b8021be0c88$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $4eac1b8021be0c88$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $4eac1b8021be0c88$export$7b79405842547ccb);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $4eac1b8021be0c88$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $4eac1b8021be0c88$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $4eac1b8021be0c88$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $4eac1b8021be0c88$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $4eac1b8021be0c88$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $4eac1b8021be0c88$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $4eac1b8021be0c88$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $4eac1b8021be0c88$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $4eac1b8021be0c88$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $4eac1b8021be0c88$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $4eac1b8021be0c88$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $4eac1b8021be0c88$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $4eac1b8021be0c88$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $4eac1b8021be0c88$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $4eac1b8021be0c88$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $4eac1b8021be0c88$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $4eac1b8021be0c88$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $4eac1b8021be0c88$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $4eac1b8021be0c88$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $4eac1b8021be0c88$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $4eac1b8021be0c88$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $4eac1b8021be0c88$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $4eac1b8021be0c88$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $4eac1b8021be0c88$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $4eac1b8021be0c88$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $4eac1b8021be0c88$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $4eac1b8021be0c88$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $4eac1b8021be0c88$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $4eac1b8021be0c88$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $4eac1b8021be0c88$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $4eac1b8021be0c88$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $4eac1b8021be0c88$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $4eac1b8021be0c88$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $4eac1b8021be0c88$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $4eac1b8021be0c88$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $4eac1b8021be0c88$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $4eac1b8021be0c88$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $4eac1b8021be0c88$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $4eac1b8021be0c88$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $4eac1b8021be0c88$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $4eac1b8021be0c88$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $4eac1b8021be0c88$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $4eac1b8021be0c88$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $4eac1b8021be0c88$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $4eac1b8021be0c88$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $4eac1b8021be0c88$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $4eac1b8021be0c88$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $4eac1b8021be0c88$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $4eac1b8021be0c88$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $4eac1b8021be0c88$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $4eac1b8021be0c88$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $4eac1b8021be0c88$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $4eac1b8021be0c88$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $4eac1b8021be0c88$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $4eac1b8021be0c88$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $4eac1b8021be0c88$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $4eac1b8021be0c88$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $4eac1b8021be0c88$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $4eac1b8021be0c88$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $4eac1b8021be0c88$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $4eac1b8021be0c88$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $4eac1b8021be0c88$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $4eac1b8021be0c88$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $4eac1b8021be0c88$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $4eac1b8021be0c88$export$3c3e26aadbfa2c32);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");
const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $4eac1b8021be0c88$export$358267065be1e = 'status';
const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
        REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
        LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
        SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
        EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
        VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
        DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
        GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
        USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
        TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
    });
    if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
    });
    if ((0, $1ybV0.ff)('jsm-sentiment-analysis_1dage')) Object.assign(types, {
        SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
    });
    if ((0, $1ybV0.ff)('sentiment-custom-field')) Object.assign(types, {
        SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
    });
    return types;
};
const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("6ZTsa", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $36a0a2a2a499297e$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $36a0a2a2a499297e$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils

var $6bYiA = parcelRequire("6bYiA");
const $36a0a2a2a499297e$export$706bbe4209d93dfe = (id)=>id;
const $36a0a2a2a499297e$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("avawr", function(module, exports) {

$parcel$export(module.exports, "logError", () => $f57ea56200106b95$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");
const $f57ea56200106b95$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $guiFP.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $gUUjF.default).unsafeErrorWithCustomerData(location, message, error);
};

});


parcelRegister("7czSC", function(module, exports) {

$parcel$export(module.exports, "ConnectAppsSubscriber", () => $e3deff51daf35120$export$2646f920b0e2e4de);
$parcel$export(module.exports, "useConnectApps", () => $e3deff51daf35120$export$4864478dcab77643);
$parcel$export(module.exports, "ConnectAppsContainer", () => $e3deff51daf35120$export$ac845603c8c91acd);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $687k4 = parcelRequire("687k4");
const $e3deff51daf35120$export$2646f920b0e2e4de = (0, $dYfll.createSubscriber)((0, $687k4.default), {
    displayName: 'ConnectAppsSubscriber'
});
const $e3deff51daf35120$export$4864478dcab77643 = (0, $ggKAj.createHook)((0, $687k4.default));
const $e3deff51daf35120$export$ac845603c8c91acd = (0, $heB5U.createContainer)((0, $687k4.default));

});
parcelRegister("687k4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c48d4b6f412e815$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $h3kcT = parcelRequire("h3kcT");
const $6c48d4b6f412e815$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null,
    hasFirstError: false
};
var $6c48d4b6f412e815$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'connect-apps',
    initialState: $6c48d4b6f412e815$export$d4c72bab9d6cc13a,
    actions: $h3kcT.actions
});

});
parcelRegister("h3kcT", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fda0cfe4b5bc8c12$export$e324594224ef24da);

var $cxnOv = parcelRequire("cxnOv");
const $fda0cfe4b5bc8c12$export$e324594224ef24da = {
    fetch: $cxnOv.default
};

});
parcelRegister("cxnOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $128f0df4723431a5$export$2e2bcd8739ae039);

var $kjsaR = parcelRequire("kjsaR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$128f0df4723431a5$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl, onError: onError })=>{
        const currentState = getState();
        if (!projectKey || currentState.loading) return;
        setState({
            loading: true,
            error: null
        });
        try {
            const data = await (0, $kjsaR.default)(baseUrl, projectKey);
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { hasFirstError: hasFirstError, data: data } = getState();
            // It's the first error if it does not already have a first error and there is no data currently in state
            const isFirstError = !hasFirstError && data === null;
            setState({
                error: err,
                loading: false,
                hasFirstError: hasFirstError || isFirstError
            });
            if (onError) onError(isFirstError);
        }
    };

});
parcelRegister("kjsaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $597ccf12213f1d63$export$2e2bcd8739ae039);

var $2OdyW = parcelRequire("2OdyW");

var $6ZTsa = parcelRequire("6ZTsa");

var $ft7kU = parcelRequire("ft7kU");

var $6Dpx1 = parcelRequire("6Dpx1");
const $597ccf12213f1d63$export$43bc37ac3360968f = (baseUrl, projectKey)=>`${baseUrl}/rest/internal/2/connectprojectconfig/${projectKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$597ccf12213f1d63$export$2e2bcd8739ae039 = (baseUrl, projectKey)=>{
    const fetchPromise = (0, $ft7kU.famaCatchAndLogFetchError)((0, $2OdyW.default)($597ccf12213f1d63$export$43bc37ac3360968f(baseUrl, projectKey)), (0, $6Dpx1.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('getConnectApps'), (0, $6ZTsa.toErrorMessage)('Failed to fetch connect apps for a project'));
    return fetchPromise.then((response)=>response.map((app)=>{
            // Server returns JSON as a string inside JSON as a string inside JSON as a string because reasons.
            // Let's parse it here
            const options = JSON.parse(app.iframe.options);
            const myApp = {
                title: app.title,
                id: options.uniqueKey,
                connectIframeProps: {
                    addon_key: app.iframe.addonKey,
                    key: app.iframe.moduleKey,
                    url: options.url,
                    options: {
                        ...options,
                        productContext: JSON.parse(options.productCtx),
                        structuredContext: JSON.parse(options.structuredContext),
                        user: {
                            uid: options.uid,
                            ukey: options.ukey,
                            timeZone: options.timeZone
                        }
                    }
                }
            };
            return myApp;
        }));
};

});
parcelRegister("ft7kU", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $9e0e185518348035$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $9e0e185518348035$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $avawr = parcelRequire("avawr");
const $9e0e185518348035$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $9e0e185518348035$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $7byHA.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $9e0e185518348035$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($9e0e185518348035$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $9e0e185518348035$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $9e0e185518348035$var$getStatusCodeGroup(error);
        (0, $avawr.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $9e0e185518348035$export$2e2bcd8739ae039 = $9e0e185518348035$var$catchAndLogFetchError;

});

parcelRegister("6Dpx1", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $f767aa89c33c344c$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $f767aa89c33c344c$export$b8b9d90f9e5bd72b);

var $6bYiA = parcelRequire("6bYiA");
const $f767aa89c33c344c$export$d76071d5de2774fc = 'project-settings/connect-apps';
const $f767aa89c33c344c$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsConnectApps');

});






parcelRegister("g7sKB", function(module, exports) {

$parcel$export(module.exports, "EcosystemAppsMenu", () => $bc220bff2b37181b$export$e583660e6ee09caf);

var $eUqFw = parcelRequire("eUqFw");

var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $7Xoh5 = parcelRequire("7Xoh5");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $cPEpP = parcelRequire("cPEpP");

var $l3JmK = parcelRequire("l3JmK");

var $j65a5 = parcelRequire("j65a5");

var $cqJw8 = parcelRequire("cqJw8");

var $7czSC = parcelRequire("7czSC");

var $lg3mT = parcelRequire("lg3mT");

var $eqBMI = parcelRequire("eqBMI");
const $bc220bff2b37181b$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ data: connectAppsData, loading: connectLoading }] = (0, $7czSC.useConnectApps)();
    const { data: forgeApps, loading: forgeLoading } = (0, $j65a5.useProjectSettingsForgeAppsForMenu)();
    const filteredConnectAppsData = (0, $eUqFw.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, $lg3mT.JIRA_AUTOMATION_ADDON_KEY)), [
        connectAppsData
    ]);
    const sortedApps = (0, $eUqFw.useMemo)(()=>[
            ...(forgeApps || []).map((app)=>({
                    type: 'forge',
                    name: app.name,
                    app: app
                })),
            ...(filteredConnectAppsData || []).map((app)=>({
                    type: 'connect',
                    name: app.title,
                    app: app
                }))
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        forgeApps,
        filteredConnectAppsData
    ]);
    const overrides = (0, $eUqFw.useMemo)(()=>({
            BackMenuItem: {
                href: `/jira/core/projects/${projectKey}/settings`,
                title: formatMessage((0, $eqBMI.messages).backItem),
                onClick: (ev)=>ev.preventDefault()
            }
        }), [
        projectKey,
        formatMessage
    ]);
    if (connectLoading || forgeLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'app-fields'
        },
        href: `${baseSettingsUrl}/apps/app-fields`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $eqBMI.messages).appFields)), sortedApps.map((ecosystemItem)=>{
        const { type: type, app: app } = ecosystemItem;
        if (type === 'forge') {
            const item = app;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: item.id,
                ...item,
                showIcon: false,
                overrides: overrides
            });
        }
        const connectApp = app;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: connectApp.id
            },
            key: connectApp.id,
            href: `${baseSettingsUrl}/apps/${connectApp.id}`,
            selectedOn: (0, $bS2FN.matchUrlPathname)()
        }, connectApp.title);
    }), forgeApps?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
        }
    }) : null);
};
const $bc220bff2b37181b$export$e583660e6ee09caf = (props)=>{
    const { children: children } = props;
    const { data: project } = (0, $cPEpP.useProject)();
    const projectKey = project && project.key || ''; // flow
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Xoh5.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7czSC.ConnectAppsContainer), {
        baseUrl: "",
        onError: undefined,
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc220bff2b37181b$export$c62cfdba33f43c7e, {
        baseSettingsUrl: baseSettingsUrl,
        projectKey: projectKey
    }), children != null && children));
};

});
parcelRegister("7Xoh5", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8ad441f9c3783975$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8ad441f9c3783975$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $8ad441f9c3783975$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8ad441f9c3783975$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("eqBMI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a385b1f82c0fdb0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3a385b1f82c0fdb0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    apps: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
        "defaultMessage": "Apps"
    },
    appFields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
        "defaultMessage": "App fields"
    },
    backItem: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("7ugdf", function(module, exports) {

$parcel$export(module.exports, "IssueTypes", () => $56d96fd9dd5cb0bb$export$15fef796fc6acc30);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $7eyVf = parcelRequire("7eyVf");

var $8cU5f = parcelRequire("8cU5f");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $1BKP5 = parcelRequire("1BKP5");

var $7Fu43 = parcelRequire("7Fu43");

var $kIUmN = parcelRequire("kIUmN");

var $4UslI = parcelRequire("4UslI");

var $cqJw8 = parcelRequire("cqJw8");

var $hnvmL = parcelRequire("hnvmL");

var $ecloj = parcelRequire("ecloj");
const $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $56d96fd9dd5cb0bb$export$15fef796fc6acc30 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, $hnvmL.useIssueTypesNavigationItems)();
    const [, addIssueTypesContextActions] = (0, $4UslI.useAddIssueTypeContext)();
    const { data: project } = $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6();
    let baseSettingsUrl = '';
    if (project !== null) baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
    const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
    if (!project || !isReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $ecloj.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: false,
        navigationItems: topLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: baseLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: bottomLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, (()=>{
        const addItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: 'add-issue-type'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: formatMessage((0, $ecloj.default).addIssueType)
            }),
            isDisabled: isAddIssueTypeDisabled,
            onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
        }, formatMessage((0, $ecloj.default).addIssueType));
        return addIssueTypeTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: addIssueTypeTooltip
        }, addItem) : addItem;
    })()));
};

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = $c3c90a7e02e55e7e$var$AddIcon;
module.exports.default = $c3c90a7e02e55e7e$var$_default;

});

parcelRegister("1BKP5", function(module, exports) {

$parcel$export(module.exports, "IssueTypesGroup", () => $21c5f892146ad62a$export$5bc39a07c26525ad);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7eyVf = parcelRequire("7eyVf");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");
const $21c5f892146ad62a$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
    if (!navigationItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: hasSeparator
    }, navigationItems.map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: String(issueType.id),
            analytics: {
                itemId: String(issueType.id)
            },
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                src: issueType.icon,
                borderColor: "transparent"
            })
        }, issueType.name)));
};

});

parcelRegister("4UslI", function(module, exports) {

$parcel$export(module.exports, "useAddIssueTypeContext", () => $6b794ec5bab5ffc3$export$40493c3e9059110a);
$parcel$export(module.exports, "useAddIssueTypeContextUpdateStoreReference", () => $6b794ec5bab5ffc3$export$f1a20ca23c90093e);
$parcel$export(module.exports, "addIssueTypeModalActions", () => $6b794ec5bab5ffc3$export$605f542240ea8e19);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $6b794ec5bab5ffc3$var$initialState = {
    isActive: false
};
const $6b794ec5bab5ffc3$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: true
        });
    };
const $6b794ec5bab5ffc3$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: false
        });
    };
const $6b794ec5bab5ffc3$var$actions = {
    openAddIssueTypeModal: $6b794ec5bab5ffc3$var$openAddIssueTypeModal,
    closeAddIssueTypeModal: $6b794ec5bab5ffc3$var$closeAddIssueTypeModal
};
const $6b794ec5bab5ffc3$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
const $6b794ec5bab5ffc3$var$Store = (0, $a61MH.createStore)({
    name: $6b794ec5bab5ffc3$var$STORE_NAME,
    initialState: $6b794ec5bab5ffc3$var$initialState,
    actions: $6b794ec5bab5ffc3$var$actions
});
const $6b794ec5bab5ffc3$export$40493c3e9059110a = (0, $ggKAj.createHook)($6b794ec5bab5ffc3$var$Store);
const $6b794ec5bab5ffc3$export$a0f296f941567e3d = (0, $dYfll.createSubscriber)($6b794ec5bab5ffc3$var$Store);
// instead of utilisling defaultRegistry, we will grab it from the render tree to have this singleton
// call useStoreReference in render tree before accessing the store instance
// https://github.com/atlassian/react-sweet-state/issues/139#issuecomment-890439621
const $6b794ec5bab5ffc3$var$storeInstance = {
    state: $6b794ec5bab5ffc3$var$initialState,
    actions: null
};
const $6b794ec5bab5ffc3$export$f1a20ca23c90093e = ()=>{
    const [issueTypeContextState, issueTypeContextActions] = $6b794ec5bab5ffc3$export$40493c3e9059110a();
    $6b794ec5bab5ffc3$var$storeInstance.state = issueTypeContextState;
    $6b794ec5bab5ffc3$var$storeInstance.actions = issueTypeContextActions;
    return null;
};
const $6b794ec5bab5ffc3$export$605f542240ea8e19 = ()=>$6b794ec5bab5ffc3$var$storeInstance.actions;

});

parcelRegister("hnvmL", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesNavigationItems", () => $50b7672a8696556a$export$8facf5695da03580);
$parcel$export(module.exports, "useIssueTypesNavigationItemsActions", () => $50b7672a8696556a$export$502d4d04702890ce);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $71ZqG = parcelRequire("71ZqG");

var $jEt1i = parcelRequire("jEt1i");

var $kcW9s = parcelRequire("kcW9s");
const $50b7672a8696556a$export$d4c72bab9d6cc13a = {
    projectId: null,
    asyncState: (0, $71ZqG.INIT),
    data: {
        limitPerProject: null,
        issueTypes: []
    },
    addIssueTypeTooltipMessage: ''
};
const $50b7672a8696556a$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            if (currentState.asyncState === (0, $71ZqG.LOADING) && projectId === currentState.projectId) return;
            setState({
                ...projectId === currentState.projectId ? currentState : $50b7672a8696556a$export$d4c72bab9d6cc13a,
                projectId: projectId,
                asyncState: (0, $71ZqG.LOADING)
            });
            const result = await (0, $jEt1i.queryIssueTypesNavigationItems)(projectId, productFeatures);
            if (getState().projectId !== projectId) return;
            const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
            setState({
                projectId: projectId,
                asyncState: (0, $71ZqG.SUCCESS),
                data: {
                    limitPerProject: limitPerProject,
                    issueTypes: data
                },
                addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                    limit: limitPerProject
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                asyncState: (0, $71ZqG.FAILURE)
            });
        }
    };
const $50b7672a8696556a$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
            }
        });
    };
const $50b7672a8696556a$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newDataById = {};
        for(let i = 0; i < layoutOwners.length; i += 1){
            const { data: data } = layoutOwners[i];
            newDataById[data.id] = {
                name: data.name,
                avatarId: data.avatarId,
                icon: data.iconUrl
            };
        }
        const issueTypes = state.data.issueTypes.map((issueType)=>{
            if (!newDataById[issueType.id]) return issueType;
            const { name: name, avatarId: avatarId } = newDataById[issueType.id];
            return {
                ...issueType,
                name: name,
                avatarId: avatarId || issueType.avatarId
            };
        });
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: issueTypes
            }
        });
    };
const $50b7672a8696556a$export$e324594224ef24da = {
    load: $50b7672a8696556a$var$load,
    remove: $50b7672a8696556a$var$remove,
    update: $50b7672a8696556a$var$update
};
const $50b7672a8696556a$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $kcW9s.getIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $kcW9s.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $71ZqG.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
// Made it const for visibility. Apparently, store name must be unique or it breaks the library
const $50b7672a8696556a$var$STORE_NAME = 'issue-type-page-navigation-items-new';
const $50b7672a8696556a$var$Store = (0, $a61MH.createStore)({
    name: $50b7672a8696556a$var$STORE_NAME,
    initialState: $50b7672a8696556a$export$d4c72bab9d6cc13a,
    actions: $50b7672a8696556a$export$e324594224ef24da
});
const $50b7672a8696556a$export$8facf5695da03580 = (0, $ggKAj.createHook)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});
// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>...' is not assignable to type 'HookActionsFunction<{ readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>; readonly remove: (...'.
const $50b7672a8696556a$export$502d4d04702890ce = (0, $ggKAj.createActionsHook)($50b7672a8696556a$var$Store);
const $50b7672a8696556a$export$313f907c8e339d1b = (0, $dYfll.createSubscriber)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});

});
parcelRegister("71ZqG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "INACTIVE_LIST", () => $1d604ab09c97d0b8$export$d7fec05af6b928f7);
$parcel$export(module.exports, "FIELD_TYPE_LIST", () => $1d604ab09c97d0b8$export$de26d0d1ef96d0ed);
$parcel$export(module.exports, "DELETE_DROPPABLE_ID", () => $1d604ab09c97d0b8$export$a155cb9d82798d65);
$parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", () => $1d604ab09c97d0b8$export$8191ccc97ff9885c);
$parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", () => $1d604ab09c97d0b8$export$c77ecc59e9e91e60);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $1d604ab09c97d0b8$export$663476c4863d5014);
$parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$9be9f574874c9a2f);
$parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$b320c6b352dcb101);
$parcel$export(module.exports, "SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$e66b34cc29932bbf);
$parcel$export(module.exports, "ASSETS_GROUP", () => $1d604ab09c97d0b8$export$c87c7df18254969e);
$parcel$export(module.exports, "DATES_GROUP", () => $1d604ab09c97d0b8$export$fa8c310a8ac47d47);
$parcel$export(module.exports, "LABELS_GROUP", () => $1d604ab09c97d0b8$export$5b2dd1b457037e13);
$parcel$export(module.exports, "NUMBER_GROUP", () => $1d604ab09c97d0b8$export$2c2f344ca2ba1c03);
$parcel$export(module.exports, "PEOPLE_GROUP", () => $1d604ab09c97d0b8$export$1441c9d524a8c0f2);
$parcel$export(module.exports, "SELECT_GROUP", () => $1d604ab09c97d0b8$export$d3e4788fc90e5f8f);
$parcel$export(module.exports, "SYSTEM_GROUP", () => $1d604ab09c97d0b8$export$724e0d23ac7e9b03);
$parcel$export(module.exports, "TEXT_GROUP", () => $1d604ab09c97d0b8$export$bd76d204d15f4c6a);
$parcel$export(module.exports, "VERSION_GROUP", () => $1d604ab09c97d0b8$export$33d3fa5e989ba460);
$parcel$export(module.exports, "ADVANCED_GROUP", () => $1d604ab09c97d0b8$export$c58a10f3e3456974);
$parcel$export(module.exports, "OTHER_GROUP", () => $1d604ab09c97d0b8$export$591e195d295fd27e);
$parcel$export(module.exports, "RESTRICTED_GROUP", () => $1d604ab09c97d0b8$export$14785d7afcf55619);
$parcel$export(module.exports, "AI_SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$df593ebd3e7c9c2d);
$parcel$export(module.exports, "INIT", () => $1d604ab09c97d0b8$export$d788bc089976c004);
$parcel$export(module.exports, "LOADING", () => $1d604ab09c97d0b8$export$26d55645375ca9a);
$parcel$export(module.exports, "SUCCESS", () => $1d604ab09c97d0b8$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $1d604ab09c97d0b8$export$5b1e245d5eac107);
$parcel$export(module.exports, "classicFieldTypesMap", () => $1d604ab09c97d0b8$export$369c1f8ac37104ce);
$parcel$export(module.exports, "ngFieldTypesMap", () => $1d604ab09c97d0b8$export$b361664c16c2ea91);
$parcel$export(module.exports, "SWIFT_VERSION_M2", () => $1d604ab09c97d0b8$export$527472231e0f6045);

var $lO4Or = parcelRequire("lO4Or");

var $6bYiA = parcelRequire("6bYiA");
const $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
const $1d604ab09c97d0b8$export$d7fec05af6b928f7 = 'inactive-list';
const $1d604ab09c97d0b8$export$de26d0d1ef96d0ed = 'field-type-list';
const $1d604ab09c97d0b8$export$a155cb9d82798d65 = 'delete-droppable-id';
const $1d604ab09c97d0b8$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
const $1d604ab09c97d0b8$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
const $1d604ab09c97d0b8$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
const $1d604ab09c97d0b8$export$663476c4863d5014 = 'jsd.field.helpText';
const $1d604ab09c97d0b8$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $1d604ab09c97d0b8$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $1d604ab09c97d0b8$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $1d604ab09c97d0b8$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $1d604ab09c97d0b8$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
const $1d604ab09c97d0b8$export$27366eb417850f7c = [
    $1d604ab09c97d0b8$export$aefba859678f04a,
    $1d604ab09c97d0b8$export$b320c6b352dcb101,
    $1d604ab09c97d0b8$export$97bca9c51480133e,
    $1d604ab09c97d0b8$export$b540ee71bad36b8b
];
const $1d604ab09c97d0b8$export$e66b34cc29932bbf = 'suggestedGroup';
const $1d604ab09c97d0b8$export$c87c7df18254969e = 'assetsGroup';
const $1d604ab09c97d0b8$export$fa8c310a8ac47d47 = 'datesGroup';
const $1d604ab09c97d0b8$export$5b2dd1b457037e13 = 'labelsGroup';
const $1d604ab09c97d0b8$export$2c2f344ca2ba1c03 = 'numberGroup';
const $1d604ab09c97d0b8$export$1441c9d524a8c0f2 = 'peopleGroup';
const $1d604ab09c97d0b8$export$d3e4788fc90e5f8f = 'selectGroup';
const $1d604ab09c97d0b8$export$724e0d23ac7e9b03 = 'systemGroup';
const $1d604ab09c97d0b8$export$bd76d204d15f4c6a = 'textGroup';
const $1d604ab09c97d0b8$export$33d3fa5e989ba460 = 'versionGroup';
const $1d604ab09c97d0b8$export$c58a10f3e3456974 = 'advancedGroup';
const $1d604ab09c97d0b8$export$591e195d295fd27e = 'otherGroup';
const $1d604ab09c97d0b8$export$14785d7afcf55619 = 'restrictedGroup';
const $1d604ab09c97d0b8$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
const $1d604ab09c97d0b8$export$d788bc089976c004 = 'INIT';
const $1d604ab09c97d0b8$export$26d55645375ca9a = 'LOADING';
const $1d604ab09c97d0b8$export$638cc6e36b2a737a = 'SUCCESS';
const $1d604ab09c97d0b8$export$5b1e245d5eac107 = 'FAILURE';
const $1d604ab09c97d0b8$export$369c1f8ac37104ce = {
    assetspicker: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    date: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    datetime: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    labelpicker: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    number: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    multiuserpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    userpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    checkbox: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    radio: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    cascadingselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    multiselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    select: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    attachment: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    textarea: $1d604ab09c97d0b8$export$bd76d204d15f4c6a
};
const $1d604ab09c97d0b8$export$b361664c16c2ea91 = {
    [(0, $lO4Or.ASSETS_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.DATE_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    people: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.ATTACHMENT_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.SUMMARY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.LABELS_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.PRIORITY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.REPORTER_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03
};
const $1d604ab09c97d0b8$export$8e333612d4b83b0e = 'M1';
const $1d604ab09c97d0b8$export$527472231e0f6045 = 'M2';

});

parcelRegister("jEt1i", function(module, exports) {

$parcel$export(module.exports, "queryIssueTypesNavigationItems", () => $e2b7fcab9d715067$export$d7f9b965a8cdf6ce);

var $2OdyW = parcelRequire("2OdyW");

var $6JubH = parcelRequire("6JubH");
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }                                
            }
        }            
    }
  }`;
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }                
                properties(keys: ${JSON.stringify(keys)})
            }
        }            
    }
  }`;
const $e2b7fcab9d715067$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
    const propertyKeys = (0, $6JubH.getAllPropertiesKeys)(productFeatures);
    const query = propertyKeys.length ? $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery(projectId);
    return (0, $2OdyW.default)('/rest/gira/latest/?issue-type-page-navigation', {
        method: 'POST',
        body: JSON.stringify({
            query: query
        })
    });
};

});
parcelRegister("6JubH", function(module, exports) {

$parcel$export(module.exports, "getAllPropertiesKeys", () => $cda94d5835810025$export$481a21941383de83);

const $cda94d5835810025$export$481a21941383de83 = (features)=>{
    const { issueTypeHelpText: issueTypeHelpText } = features;
    const allPropertiesKeys = [
        (0, $71863708d1e76c0d$export$97806a3c861a8076),
        (0, $71863708d1e76c0d$export$5a53542e76b69730)
    ];
    return issueTypeHelpText ? allPropertiesKeys : [];
};

});
const $71863708d1e76c0d$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $71863708d1e76c0d$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $71863708d1e76c0d$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $71863708d1e76c0d$export$663476c4863d5014 = 'jsd.field.helpText';
const $71863708d1e76c0d$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $71863708d1e76c0d$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';



parcelRegister("kcW9s", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", () => $381ebc40076882e7$export$fcf99cb11372431f);
$parcel$export(module.exports, "getIsIssueTypeLimitReached", () => $381ebc40076882e7$export$f9ef03d331bca3e6);

var $3l6tm = parcelRequire("3l6tm");

var $fPLIA = parcelRequire("fPLIA");
const $381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
const $381ebc40076882e7$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $fPLIA.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $3l6tm.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
const $381ebc40076882e7$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

});
parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});

parcelRegister("fPLIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca2223257c6a5a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getProjectAvatarUrl", () => $2ca2223257c6a5a8$export$65a50dd1fe88e116);
$parcel$export(module.exports, "normaliseSavedAvatar", () => $2ca2223257c6a5a8$export$b11f6166803b3fff);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ca2223257c6a5a8$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
            id: Number(raw.id),
            uri: raw.urls['48x48'],
            fileName: raw.fileName
        }));
const $2ca2223257c6a5a8$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
const $2ca2223257c6a5a8$export$b11f6166803b3fff = (avatar)=>({
        id: parseInt(avatar.id, 10),
        uri: $2ca2223257c6a5a8$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
        fileName: avatar.fileName
    });

});



parcelRegister("ecloj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef69dab8435bf50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ef69dab8435bf50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
        "defaultMessage": "Issue types"
    },
    addIssueType: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
        "defaultMessage": "Add issue type"
    }
});

});


parcelRegister("f4Fss", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b38fe1c4155e2b35$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b38fe1c4155e2b35$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
        "defaultMessage": "Project settings"
    },
    itemDetails: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
        "defaultMessage": "Details"
    },
    itemAccess: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
        "defaultMessage": "Access"
    },
    itemIssueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
        "defaultMessage": "Issue types"
    },
    itemAdvancedForms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
        "defaultMessage": "Advanced Forms"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
        "defaultMessage": "New"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
        "defaultMessage": "Automation"
    },
    itemNotifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
        "defaultMessage": "Notifications"
    },
    itemApprovals: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
        "defaultMessage": "Approvals"
    },
    dataClassificationNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
        "defaultMessage": "Data classification"
    }
});

});





parcelRegister("bVacK", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b69d7e9bc0f0ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $13b69d7e9bc0f0ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    favorites: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
        "defaultMessage": "Starred"
    },
    recents: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
        "defaultMessage": "Recent"
    },
    expandSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
        "defaultMessage": "Expand {section} projects"
    },
    collapseSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
        "defaultMessage": "Collapse {section} projects"
    }
});

});

parcelRegister("1nRKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8307479266abafd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3YFEG = parcelRequire("3YFEG");

var $kCTcl = parcelRequire("kCTcl");
const $e8307479266abafd$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
const $e8307479266abafd$var$ViewAllProjects = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        href: "/jira/projects?selectedProjectType=business",
        testId: $e8307479266abafd$var$TEST_ID,
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e8307479266abafd$var$Content, null, label ?? formatMessage((0, $kCTcl.messages).viewAllProjectsLabel)));
};
var $e8307479266abafd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($e8307479266abafd$var$ViewAllProjects);
const $e8307479266abafd$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kCTcl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a83bdf732a2f08ae$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a83bdf732a2f08ae$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllProjectsLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
        "defaultMessage": "View all projects"
    }
});

});



parcelRegister("439fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2bfd1ec3623003$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lbttE = parcelRequire("lbttE");

var $2JncP = parcelRequire("2JncP");

var $94rY2 = parcelRequire("94rY2");

var $7LPMB = parcelRequire("7LPMB");

var $46qxU = parcelRequire("46qxU");
const $5b2bfd1ec3623003$var$ProjectsHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data } = (0, $2JncP.useProjectCreatePermissionsResource)();
    const canCreateProject = Boolean(data?.canCreateProject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $7LPMB.messages).projectsHeader)
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46qxU.default), {
            openProjectCreateDrawer: open
        })));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$5b2bfd1ec3623003$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5b2bfd1ec3623003$var$ProjectsHeader);

});
parcelRegister("lbttE", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $3fbad164cde8fff4$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $3fbad164cde8fff4$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $3fbad164cde8fff4$export$8172ff4ed0f75a1e);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9CmwD = parcelRequire("9CmwD");

var $kJlBc = parcelRequire("kJlBc");

var $9EFi5 = parcelRequire("9EFi5");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $3fbad164cde8fff4$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }
});
const $3fbad164cde8fff4$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eUqFw.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        };
        // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        };
        this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            });
        };
        this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        };
        this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        };
        this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        };
        this.onCreateStarted = (_projectKey, templateKey)=>{
            if ((0, $9CmwD.getIsJsmBlankProjectTemplate)(templateKey)) (0, $9EFi5.LazyComponent).preload();
        };
    }
};
const $3fbad164cde8fff4$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $3fbad164cde8fff4$export$9a8662cd60931de1 } = $3fbad164cde8fff4$var$Context;
$3fbad164cde8fff4$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $3fbad164cde8fff4$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $eUqFw.useContext)($3fbad164cde8fff4$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("9EFi5", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $6ae11cc3f6e45a93$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $6ae11cc3f6e45a93$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $6ae11cc3f6e45a93$export$ff317c5d87147a19);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $iVSJI = parcelRequire("iVSJI");

const $6ae11cc3f6e45a93$export$31f1740ae531af94 = (0, $7rh0R.lazy)(()=>(parcelRequire("2vI6z")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/index.tsx"
});
const $6ae11cc3f6e45a93$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae11cc3f6e45a93$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $6ae11cc3f6e45a93$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");
var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("2vI6z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('561Jq'),
            load('1QYl5'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('iYygF')
        ]);
        const value = parcelRequire('8Zm1o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("561Jq"),
        load("1QYl5"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("iYygF")
    ]).then(()=>parcelRequire('8Zm1o'));
}

});



parcelRegister("7LPMB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1677fc3cc494a9e0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1677fc3cc494a9e0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("46qxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa00e86d64bf3cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $5RHM4 = parcelRequire("5RHM4");

var $eJ4Al = parcelRequire("eJ4Al");

const $afa00e86d64bf3cb$export$ef99f99721eacc0f = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("eJ4Al"))), {
    ssr: false,
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
});
const $afa00e86d64bf3cb$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const renderContent = (0, $eUqFw.useCallback)((data, loading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "sidebar-template-picker",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ4Al.TemplatePickerFallback), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afa00e86d64bf3cb$export$ef99f99721eacc0f, {
            data: data,
            loading: loading,
            openProjectCreateDrawer: openProjectCreateDrawer
        })), [
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RHM4.default), {
        renderContent: renderContent,
        openProjectCreateDrawer: openProjectCreateDrawer
    });
};
var $afa00e86d64bf3cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($afa00e86d64bf3cb$var$OneClickProject);

});
parcelRegister("5RHM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f62e632270fd1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $ctuRV = parcelRequire("ctuRV");

var $kpmC0 = parcelRequire("kpmC0");

var $lg3mT = parcelRequire("lg3mT");

var $jPQKl = parcelRequire("jPQKl");

var $43dkR = parcelRequire("43dkR");
const $d2f62e632270fd1e$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, $jPQKl.useProjectTemplates)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const wasFetched = data != null || loading || error != null;
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && !wasFetched) fetchJwmTemplates();
    }, [
        isOpen,
        wasFetched,
        fetchJwmTemplates
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isLeftSidebarCollapsed && isOpen) onClose();
    }, [
        isLeftSidebarCollapsed,
        isOpen,
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error && isOpen) {
            openProjectCreateDrawer((0, $ctuRV.getJwmCreateProjectDrawerOptions)((0, $lg3mT.LOCATION)));
            setIsOpen(false);
        }
    }, [
        error,
        isOpen,
        openProjectCreateDrawer
    ]);
    const content = (0, $eUqFw.useCallback)(()=>renderContent(data, loading), [
        renderContent,
        data,
        loading
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43dkR.default), {
            onClick: ()=>setIsOpen(!isOpen)
        })), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        placement: "right-start",
        onClose: onClose,
        content: content,
        trigger: trigger
    });
};
var $d2f62e632270fd1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d2f62e632270fd1e$var$OneClickProjectButton);

});
parcelRegister("ctuRV", function(module, exports) {

$parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", () => $98e3a17d6f2eb763$export$c1785414279ee192);

var $7ZZxN = parcelRequire("7ZZxN");
const $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
const $98e3a17d6f2eb763$export$c1785414279ee192 = (source)=>({
        isNextGen: true,
        selectedProjectType: (0, $7ZZxN.CORE_PROJECT),
        showExperienceSelection: false,
        defaultSelectedTemplateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
        recommendedTemplate: {
            templateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            isSimplified: false
        },
        source: source
    });

});

parcelRegister("jPQKl", function(module, exports) {

$parcel$export(module.exports, "useProjectTemplates", () => $fd9a9d07d5b37dc7$export$45e810e42086790f);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $lg3mT = parcelRequire("lg3mT");

var $8Rrw0 = parcelRequire("8Rrw0");
const $fd9a9d07d5b37dc7$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $fd9a9d07d5b37dc7$export$45e810e42086790f = ()=>{
    const [{ loading: loading, data: data, error: error }, setState] = (0, $eUqFw.useState)($fd9a9d07d5b37dc7$var$initialState);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            data: null,
            loading: true,
            error: null
        });
        try {
            const response = await (0, $2OdyW.default)('/rest/simplified/2.0/project-templates?recommendations');
            // * The exposure will be fired at the backend
            // eslint-disable-next-line jira/ff/unsafe-no-exposure
            const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
            const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
            const jwmTemplates = shouldUseNewRecommendations ? (0, $8Rrw0.getFilteredTemplatesNew)(response) : (0, $8Rrw0.getFilteredTemplates)(response);
            setState({
                data: jwmTemplates,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useProjectTemplates',
                    packageName: (0, $lg3mT.PACKAGE_NAME),
                    teamName: 'jira-warepil'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                data: null,
                loading: false,
                error: err
            });
        }
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        fetch: fetch
    };
};

});
parcelRegister("8Rrw0", function(module, exports) {

$parcel$export(module.exports, "getFilteredTemplates", () => $aefab5fdd7f61066$export$e9643d22c03c3a30);
$parcel$export(module.exports, "getFilteredTemplatesNew", () => $aefab5fdd7f61066$export$126495c59883efa);
const $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY = 4;
const $aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
// note: these 4 templates are hardcoded for the time being
const $aefab5fdd7f61066$var$TEMPLATE_KEYS = new Set([
    'jwm.blank-project',
    'jwm.project-management',
    'jwm.personal-task-planner',
    'jwm.task-tracking'
]);
const $aefab5fdd7f61066$export$e9643d22c03c3a30 = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    templates.forEach((template)=>{
        const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
        if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
            ...template,
            isLastUsed: true
        });
        else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
            ...template,
            isRecommended: true
        });
        else if ($aefab5fdd7f61066$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
    });
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 4 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY);
    return filteredTemplates;
};
const $aefab5fdd7f61066$export$126495c59883efa = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    recommendedTemplateKeys?.forEach((key, index)=>{
        const template = templates.find((t)=>t.key === key);
        if (template) {
            const { projectTypeTemplates: projectTypeTemplates } = template;
            // * The first recommended template will be the last used template if there is one
            if (index === 0 && lastUsedTemplateKey) {
                const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                lastUsedTemplates.push({
                    ...template,
                    ...isLastUsed && {
                        isLastUsed: isLastUsed
                    }
                });
                return;
            }
            const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
            recommendedTemplates.push({
                ...template,
                ...isRecommended && {
                    isRecommended: isRecommended
                }
            });
        }
    });
    // * If there are not enough templates to display, add additional templates
    if (lastUsedTemplates.length + recommendedTemplates.length < $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY) {
        // * Get the keys of the templates that are not last used or recommended
        const placeholderTemplateKeys = Array.from($aefab5fdd7f61066$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
        templates.forEach((template)=>{
            if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
        });
    }
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 4 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY);
    return filteredTemplates;
};

});


parcelRegister("43dkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c15f45e40c9348dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $lg3mT = parcelRequire("lg3mT");

var $rRiBz = parcelRequire("rRiBz");

var $bvh6n = parcelRequire("bvh6n");
const $c15f45e40c9348dc$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
const $c15f45e40c9348dc$var$CreateProjectButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        label: formatMessage((0, $bvh6n.default).createProjectLabel),
        testId: $c15f45e40c9348dc$var$TEST_ID,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $lg3mT.LOCATION));
            onClick();
        }
    });
};
var $c15f45e40c9348dc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c15f45e40c9348dc$var$CreateProjectButton);

});
parcelRegister("bvh6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4df5be60050e5cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4df5be60050e5cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createProjectLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
        "defaultMessage": "Create project"
    }
});

});



parcelRegister("eJ4Al", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TemplatePickerFallback", () => $ada0eacffac0a44d$export$675ac63e0637d34d);
$parcel$export(module.exports, "default", () => $ada0eacffac0a44d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $bULPy = parcelRequire("bULPy");
var $eMD3i = parcelRequire("eMD3i");
var $8BKky = parcelRequire("8BKky");

var $4Bees = parcelRequire("4Bees");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $lg3mT = parcelRequire("lg3mT");

var $9euug = parcelRequire("9euug");
const $ada0eacffac0a44d$var$POPUP_WIDTH = 272;
const $ada0eacffac0a44d$export$675ac63e0637d34d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
const $ada0eacffac0a44d$var$TemplatePicker = ({ data: data, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleTemplateClick = (0, $eUqFw.useCallback)((projectTypeTemplates, isLastUsed, isRecommended)=>()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                selectedProjectType: 'business',
                showExperienceSelection: false,
                defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                source: (0, $lg3mT.LOCATION)
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                isLastUsed: isLastUsed,
                isRecommended: isRecommended
            });
        }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleMoreTemplatesClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION)
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleImportButtonClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION),
            isImportProjectOpenInitially: true
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMD3i.default), {
        minWidth: $ada0eacffac0a44d$var$POPUP_WIDTH,
        testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$export$675ac63e0637d34d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: formatMessage((0, $9euug.default).sectionTitle)
    }, Array.isArray(data) && data.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$StyledImage, {
                src: iconUrl,
                alt: `${title.label} icon`
            }),
            key: key,
            onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$ButtonText, null, title.label), isLastUsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $9euug.default).lastCreated))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
        onClick: handleMoreTemplatesClick
    }, formatMessage((0, $9euug.default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin && (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p')) && !(0, $dfBCt.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
        onClick: handleImportButtonClick
    }, formatMessage((0, $9euug.default).importButtonText)))));
};
var $ada0eacffac0a44d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($ada0eacffac0a44d$var$TemplatePicker);
const $ada0eacffac0a44d$var$StyledImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsbzwfg _5ral1dfr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eMD3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4de9f5740e2589$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $6d4de9f5740e2589$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $6d4de9f5740e2589$export$2e2bcd8739ae039 = $6d4de9f5740e2589$var$PopupMenuGroup;

});

parcelRegister("9euug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faf631161ec9357$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2faf631161ec9357$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sectionTitle: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
        "defaultMessage": "Start a new project"
    },
    moreTemplatesButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
        "defaultMessage": "More templates"
    },
    importButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
        "defaultMessage": "Import"
    },
    lastCreated: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
        "defaultMessage": "Last created"
    }
});

});








//# sourceMappingURL=async-sidebar-core.5973451c.js.map
